// 278 in array as of 23.04
export const CHARACTERS = [
  {
    id: "1",
    name: "Estelle Bright",
    gender: "Female",
    weapon: "Staff",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 16,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/estelle.webp",
    wikiUrl: "https://falcom.wiki/wiki/Estelle_Bright",
  },
  {
    id: "2",
    name: "Joshua Bright",
    gender: "Male",
    weapon: "Blade",
    nationality: ["Erebonian"],
    affiliation: ["Bracer Guild", "Ouroboros"],
    age: 16,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/joshua.webp",
    wikiUrl: "https://falcom.wiki/wiki/Joshua_Bright",
  },
  {
    id: "3",
    name: "Scherazard Harvey",
    gender: "Female",
    weapon: "Whip",
    nationality: "South Zemurian",
    affiliation: ["Bracer Guild", "Royal Family"],
    age: 23,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/scherazard.webp",
    wikiUrl: "https://falcom.wiki/wiki/Scherazard_Harvey",
  },
  {
    id: "4",
    name: "Olivier Lenheim",
    gender: "Male",
    weapon: "Gun",
    nationality: "Erebonian",
    affiliation: ["Royal Family", "Thors Board"],
    age: 25,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/olivier.webp",
    wikiUrl: "https://falcom.wiki/wiki/Olivier_Lenheim",
  },
  {
    id: "5",
    name: "Kloe Rinz",
    gender: "Female",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Royal Family", "Jenis"],
    age: 16,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/kloe.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kloe_Rinz",
  },
  {
    id: "6",
    name: "Agate Crosner",
    gender: "Male",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 24,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/agate.webp",
    wikiUrl: "https://falcom.wiki/wiki/Agate_Crosner",
  },
  {
    id: "7",
    name: "Tita Russell",
    gender: "Female",
    weapon: ["Orbal Cannon", "Orbal Gear"],
    nationality: "Liberlian",
    affiliation: ["Thors", "ZCF"],
    age: 12,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/tita.webp",
    wikiUrl: "https://falcom.wiki/wiki/Tita_Russell",
  },
  {
    id: "8",
    name: "Zin Vathek",
    gender: "Male",
    weapon: "Fists",
    nationality: "Calvardian",
    affiliation: ["Bracer Guild"],
    age: 30,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/zin.webp",
    wikiUrl: "https://falcom.wiki/wiki/Zin_Vathek",
  },
  {
    id: "9",
    name: "Kevin Graham",
    gender: "Male",
    weapon: "Crossbow",
    nationality: "Emerosean",
    affiliation: ["Gralsritter", "Septian Church"],
    age: 21,
    debutGame: "SC",
    imageUrl: "/images/characterSquares/kevin.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kevin_Graham",
  },
  {
    id: "10",
    name: "Ries Argent",
    gender: "Female",
    weapon: "Blade",
    nationality: "Arterian",
    affiliation: ["Gralsritter", "Septian Church"],
    age: 18,
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/ries.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ries_Argent",
  },
  {
    id: "11",
    name: "Lloyd Bannings",
    gender: "Male",
    weapon: "Tonfas",
    nationality: "Crossbellan",
    affiliation: ["SSS"],
    age: 18,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/lloyd.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lloyd_Bannings",
  },
  {
    id: "12",
    name: "Elie MacDowell",
    gender: "Female",
    weapon: "Gun",
    nationality: "Crossbellan",
    affiliation: ["SSS"],
    age: 18,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/elie.webp",
    wikiUrl: "https://falcom.wiki/wiki/Elie_MacDowell",
  },
  {
    id: "13",
    name: "Randy Orlando",
    gender: "Male",
    weapon: "Halberd",
    nationality: "Unknown",
    affiliation: ["SSS", "Thors", "Jaeger"],
    age: 21,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/randy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Randy_Orlando",
  },
  {
    id: "14",
    name: "Tio Plato",
    gender: "Female",
    weapon: "Orbal Staff",
    nationality: "Remiferian",
    affiliation: ["SSS", "Epstein Foundation"],
    age: 14,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/tio.webp",
    wikiUrl: "https://falcom.wiki/wiki/Tio_Plato",
  },
  {
    id: "15",
    name: "Wazy Hemisphere",
    gender: "Male",
    weapon: "Fists",
    nationality: "Unknown",
    affiliation: ["SSS", "Gralsritter", "Septian Church", "Testaments"],
    age: 17,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/wazy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Wazy_Hemisphere",
  },
  {
    id: "16",
    name: "Noel Seeker",
    gender: "Female",
    weapon: ["Gun", "Halberd"],
    nationality: "Crossbellan",
    affiliation: ["SSS", "CGF"],
    age: 18,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/noel.webp",
    wikiUrl: "https://falcom.wiki/wiki/Noel_Seeker",
  },
  {
    id: "17",
    name: "Rean Schwarzer",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII", "New Class VII"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/rean.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rean_Schwarzer",
  },
  {
    id: "18",
    name: "Alisa Reinford",
    gender: "Female",
    weapon: ["Bow", "Orbal Gear"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII", "Reinford Group"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/alisa.webp",
    wikiUrl: "https://falcom.wiki/wiki/Alisa_Reinford",
  },
  {
    id: "19",
    name: "Elliot Craig",
    gender: "Male",
    weapon: "Orbal Staff",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII"],
    age: 16,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/elliot.webp",
    wikiUrl: "https://falcom.wiki/wiki/Elliot_Craig",
  },
  {
    id: "20",
    name: "Laura S. Arseid",
    gender: "Female",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII", "Arseid Family"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/laura.webp",
    wikiUrl: "https://falcom.wiki/wiki/Laura_S._Arseid",
  },
  {
    id: "21",
    name: "Machias Regnitz",
    gender: "Male",
    weapon: "Gun",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/machias.webp",
    wikiUrl: "https://falcom.wiki/wiki/Machias_Regnitz",
  },
  {
    id: "22",
    name: "Emma Millstein",
    gender: "Female",
    weapon: "Orbal Staff",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII", "Hexen Clan"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/emma.webp",
    wikiUrl: "https://falcom.wiki/wiki/Emma_Millstein",
  },
  {
    id: "23",
    name: "Jusis Albarea",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII", "Four Great Houses"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/jusis.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jusis_Albarea",
  },
  {
    id: "24",
    name: "Fie Claussell",
    gender: "Female",
    weapon: "Gunblade",
    nationality: "Unknown",
    affiliation: ["Thors", "Class VII", "Bracer Guild", "Jaeger"],
    age: 15,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/fie.webp",
    wikiUrl: "https://falcom.wiki/wiki/Fie_Claussell",
  },
  {
    id: "25",
    name: "Gaius Worzel",
    gender: "Male",
    weapon: "Spear",
    nationality: "Nord",
    affiliation: ["Thors", "Class VII", "Gralsritter"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/gaius.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gaius_Worzel",
  },
  {
    id: "26",
    name: "Millium Orion",
    gender: "Female",
    weapon: "Combat Shell",
    nationality: "Erebonian",
    affiliation: ["Thors", "Class VII", "Intelligence Division", "Ironbloods"],
    age: 13,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/millium.webp",
    wikiUrl: "https://falcom.wiki/wiki/Millium_Orion",
  },
  {
    id: "27",
    name: "Crow Armbrust",
    gender: "Male",
    weapon: ["Gun", "Blade"],
    nationality: ["Erebonian", "Jurai"],
    affiliation: ["Thors", "Class VII", "ILF"],
    age: 19,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/crow.webp",
    wikiUrl: "https://falcom.wiki/wiki/Crow_Armbrust",
  },
  {
    id: "28",
    name: "Juna Crawford",
    gender: "Female",
    weapon: "Tonfas",
    nationality: "Crossbellan",
    affiliation: ["Thors", "New Class VII", "SSS"],
    age: 17,
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/juna.webp",
    wikiUrl: "https://falcom.wiki/wiki/Juna_Crawford",
  },
  {
    id: "29",
    name: "Kurt Vander",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Thors", "New Class VII", "Vander School"],
    age: 17,
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/kurt.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kurt_Vander",
  },
  {
    id: "30",
    name: "Altina Orion",
    gender: "Female",
    weapon: "Combat Shell",
    nationality: "Erebonian",
    affiliation: [
      "Thors",
      "New Class VII",
      "Intelligence Division",
      "Epstein Foundation",
    ],
    age: 12,
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/altina.webp",
    wikiUrl: "https://falcom.wiki/wiki/Altina_Orion",
  },
  {
    id: "31",
    name: "Musse Egret",
    gender: "Female",
    weapon: "Gun",
    nationality: "Erebonian",
    affiliation: ["Thors", "New Class VII", "St. Astraia", "Four Great Houses"],
    age: 16,
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/musse.webp",
    wikiUrl: "https://falcom.wiki/wiki/Musse_Egret",
  },
  {
    id: "32",
    name: "Ash Carbide",
    gender: "Male",
    weapon: "Axe",
    nationality: "Erebonian",
    affiliation: ["Thors", "New Class VII"],
    age: 17,
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/ash.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ash_Carbide",
  },
  {
    id: "33",
    name: "Renne Bright",
    gender: "Female",
    weapon: "Scythe",
    nationality: "Crossbellan",
    affiliation: ["Aramis", "Ouroboros", "Picnic"],
    age: 11,
    debutGame: "SC",
    imageUrl: "/images/characterSquares/renne.webp",
    wikiUrl: "https://falcom.wiki/wiki/Renne",
  },
  {
    id: "34",
    name: "Arios MacLaine",
    gender: "Male",
    weapon: "Blade",
    nationality: "Crossbellan",
    affiliation: ["Bracer Guild", "CPD", "Crossbell Government"],
    age: 30,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/arios.webp",
    wikiUrl: "https://falcom.wiki/wiki/Arios_MacLaine",
  },
  {
    id: "35",
    name: "Sara Valestein",
    gender: "Female",
    weapon: ["Gun", "Blade"],
    nationality: "North Ambrian",
    affiliation: ["Thors", "Bracer Guild", "Class VII", "Jaeger"],
    age: 25,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/sara.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sara_Valestein",
  },
  {
    id: "36",
    name: "Van Arkride",
    gender: "Male",
    weapon: "Stun Caliber",
    nationality: "Calvardian",
    affiliation: ["Arkride Solutions"],
    age: 24,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/van.webp",
    wikiUrl: "https://falcom.wiki/wiki/Van_Arkride",
  },
  {
    id: "37",
    name: "Agnès Claudel",
    gender: "Female",
    weapon: "Orbal Staff",
    nationality: "Calvardian",
    affiliation: ["Aramis", "Arkride Solutions"],
    age: 16,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/agnes.webp",
    wikiUrl: "https://falcom.wiki/wiki/Agnès_Claudel",
  },
  {
    id: "38",
    name: "Feri Al-Fayed",
    gender: "Female",
    weapon: "Gunblade",
    nationality: "Central Eastern",
    affiliation: ["Arkride Solutions", "Jaeger"],
    age: 13,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/feri.webp",
    wikiUrl: "https://falcom.wiki/wiki/Feri_Al-Fayed",
  },
  {
    id: "39",
    name: "Aaron Wei",
    gender: "Male",
    weapon: "Blade",
    nationality: "Calvardian",
    affiliation: ["Arkride Solutions", "Heiyue"],
    age: 19,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/aaron.webp",
    wikiUrl: "https://falcom.wiki/wiki/Aaron_Wei",
  },
  {
    id: "40",
    name: "Risette Twinings",
    gender: "Female",
    weapon: ["Gun", "Blade"],
    nationality: "Calvardian",
    affiliation: ["Arkride Solutions", "Marduk"],
    age: 20,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/risette.webp",
    wikiUrl: "https://falcom.wiki/wiki/Risette_Twinings",
  },
  {
    id: "41",
    name: "Quatre Salision",
    gender: "Male",
    weapon: ["Gun", "Drone"],
    nationality: "Calvardian",
    affiliation: ["Arkride Solutions", "Verne Company", "Basel Institute"],
    age: 15,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/quatre.webp",
    wikiUrl: "https://falcom.wiki/wiki/Quatre_Salision",
  },
  {
    id: "42",
    name: "Elaine Auclair",
    gender: "Female",
    weapon: "Blade",
    nationality: "Calvardian",
    affiliation: ["Bracer Guild"],
    age: 24,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/elaine.webp",
    wikiUrl: "https://falcom.wiki/wiki/Elaine_Auclair",
  },
  {
    id: "43",
    name: "Towa Herschel",
    gender: "Female",
    weapon: "Gun",
    nationality: "Erebonian",
    affiliation: ["Thors", "Aramis"],
    age: 18,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/towa.webp",
    wikiUrl: "https://falcom.wiki/wiki/Towa_Herschel",
  },
  {
    id: "44",
    name: "Claire Rieveldt",
    gender: "Female",
    weapon: "Gun",
    nationality: "Erebonian",
    affiliation: ["RMP", "Ironbloods"],
    age: 24,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/claire.webp",
    wikiUrl: "https://falcom.wiki/wiki/Claire_Rieveldt",
  },
  {
    id: "45",
    name: "Celine Millstein",
    gender: "Female",
    weapon: "N/A",
    nationality: "Erebonian",
    affiliation: ["Hexen Clan", "Familiar"],
    age: "Unknown",
    predictedAgeRange: { min: 8, max: 12 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/celine.webp",
    wikiUrl: "https://falcom.wiki/wiki/Celine_Millstein",
  },
  {
    id: "46",
    name: "Elise Schwarzer",
    gender: "Female",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["St. Astraia"],
    age: 15,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/elise.webp",
    wikiUrl: "https://falcom.wiki/wiki/Elise_Schwarzer",
  },
  {
    id: "47",
    name: "Alfin Reise Arnor",
    gender: "Female",
    weapon: "Orbal Staff",
    nationality: "Erebonian",
    affiliation: ["Royal Family", "St. Astraia"],
    age: 15,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/alfin.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Alfin_Reise_Arnor",
  },
  {
    id: "48",
    name: "Rixia Mao",
    gender: "Female",
    weapon: "Blade",
    nationality: "Calvardian",
    affiliation: ["Arc en Ciel", "Heiyue"],
    age: 17,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/rixia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rixia_Mao",
  },
  {
    id: "49",
    name: "Ilya Platiere",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["Arc en Ciel"],
    age: 22,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/ilya.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ilya_Platiere",
  },
  {
    id: "50",
    name: "Shizuna Rem Misurugi",
    gender: "Female",
    weapon: "Blade",
    nationality: "East Zemurian",
    affiliation: ["Jaeger", "Ikaruga"],
    age: 23,
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/shizuna.webp",
    wikiUrl: "https://falcom.wiki/wiki/Shizuna_Rem_Misurugi",
  },
  {
    id: "51",
    name: "Cassius Bright",
    gender: "Male",
    weapon: ["Staff", "Blade"],
    nationality: "Liberlian",
    affiliation: ["Bracer Guild", "Royal Army"],
    age: 45,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/cassius.webp",
    wikiUrl: "https://falcom.wiki/wiki/Cassius_Bright",
  },
  {
    id: "52",
    name: "Aina Holden",
    gender: "Female",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 23,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/aina.webp",
    wikiUrl: "https://falcom.wiki/wiki/Aina_Holden",
  },
  {
    id: "53",
    name: "Georg Weissmann",
    gender: "Male",
    weapon: "Non-Orbal Staff",
    nationality: "North Ambrian",
    affiliation: ["Ouroboros", "Septian Church"],
    age: 36,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/weissmann.webp",
    wikiUrl: "https://falcom.wiki/wiki/Georg_Weissmann",
  },
  {
    id: "54",
    name: "Nial Burns",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Liberl News", "Journalist"],
    age: 29,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/nial.webp",
    wikiUrl: "https://falcom.wiki/wiki/Nial_Burns",
  },
  {
    id: "55",
    name: "Dorothy Hyatt",
    gender: "Female",
    weapon: "Camera",
    nationality: "Liberlian",
    affiliation: ["Liberl News", "Journalist"],
    age: 20,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/dorothy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Dorothy_Hyatt",
  },
  {
    id: "56",
    name: "Josette Capua",
    gender: "Female",
    weapon: "Gun",
    nationality: "Erebonian",
    affiliation: ["Capua Family"],
    age: 16,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/josette.webp",
    wikiUrl: "https://falcom.wiki/wiki/Josette_Capua",
  },
  {
    id: "57",
    name: "Don Capua",
    gender: "Male",
    weapon: "Orbal Cannon",
    nationality: "Erebonian",
    affiliation: ["Capua Family"],
    age: 30,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/don.webp",
    wikiUrl: "https://falcom.wiki/wiki/Don_Capua",
  },
  {
    id: "58",
    name: "Kyle Capua",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Capua Family"],
    age: 23,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/kyle.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kyle_Capua",
  },
  {
    id: "59",
    name: "Maybelle",
    gender: "Female",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Bose Government", "Jenis"],
    age: 22,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/maybelle.webp",
    wikiUrl: "https://falcom.wiki/wiki/Maybelle",
  },
  {
    id: "60",
    name: "Lila",
    gender: "Female",
    weapon: "N/A",
    nationality: ["Liberlian", "Lemanian"],
    affiliation: ["Bose Government"],
    age: 20,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/lila.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lila",
  },
  {
    id: "61",
    name: "Morgan",
    gender: "Male",
    weapon: "Halberd",
    nationality: "Liberlian",
    affiliation: ["Royal Army"],
    age: 62,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/morgan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Morgan",
  },
  {
    id: "62",
    name: "Alan Richard",
    gender: "Male",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Royal Army", "Intelligence Division"],
    age: 34,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/richard.webp",
    wikiUrl: "https://falcom.wiki/wiki/Alan_Richard",
  },
  {
    id: "63",
    name: "Kanone Amalthea",
    gender: "Female",
    weapon: "Gun",
    nationality: "Liberlian",
    affiliation: ["Royal Army", "Intelligence Division"],
    age: 27,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/kanone.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kanone_Amalthea",
  },
  {
    id: "64",
    name: "Anelace Elfead",
    gender: "Female",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 18,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/anelace.webp",
    wikiUrl: "https://falcom.wiki/wiki/Anelace_Elfead",
  },
  {
    id: "65",
    name: "Grant",
    gender: "Male",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 22,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/grant.webp",
    wikiUrl: "https://falcom.wiki/wiki/Grant",
  },
  {
    id: "66",
    name: "Julia Schwarz",
    gender: "Female",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Royal Army"],
    age: 27,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/julia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Julia_Schwarz",
  },
  {
    id: "67",
    name: "Gilbert Stein",
    gender: "Male",
    weapon: "Gun",
    nationality: "Liberlian",
    affiliation: ["Ruan Government", "Ouroboros", "Jenis"],
    age: 23,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/gilbert.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gilbert_Stein",
  },
  {
    id: "68",
    name: "Dean Collins",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Jenis"],
    age: "Unknown",
    predictedAgeRange: { min: 65, max: 80 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/collins.webp",
    wikiUrl: "https://falcom.wiki/wiki/Collins",
  },
  {
    id: "69",
    name: "Jill Ridonor",
    gender: "Female",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Jenis"],
    age: "Unknown",
    predictedAgeRange: { min: 16, max: 18 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/jill.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jill_Ridonor",
  },
  {
    id: "70",
    name: "Hans",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Jenis"],
    age: "Unknown",
    predictedAgeRange: { min: 16, max: 18 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/hans.webp",
    wikiUrl: "https://falcom.wiki/wiki/Hans",
  },
  {
    id: "71",
    name: "Carna",
    gender: "Female",
    weapon: "Gun",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 25,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/carna.webp",
    wikiUrl: "https://falcom.wiki/wiki/Carna",
  },
  {
    id: "72",
    name: "Jean",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 24,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/jean.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jean",
  },
  {
    id: "73",
    name: "Albert Russell",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["ZCF"],
    age: 68,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/russell.webp",
    wikiUrl: "https://falcom.wiki/wiki/Russell",
  },
  {
    id: "74",
    name: "Kilika Rouran",
    gender: "Female",
    weapon: "Chakram",
    nationality: "Calvardian",
    affiliation: ["Bracer Guild", "CID", "Rocksmith Agency"],
    age: 26,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/kilika.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kilika_Rouran",
  },
  {
    id: "75",
    name: "Maximillian Cid",
    gender: "Male",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Royal Army"],
    age: 32,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/cid.webp",
    wikiUrl: "https://falcom.wiki/wiki/Maximillian_Cid",
  },
  {
    id: "76",
    name: "Gustav",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["ZCF"],
    age: 48,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/gustav.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gustav",
  },
  {
    id: "77",
    name: "Alicia von Auslese",
    gender: "Female",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Royal Family"],
    age: 60,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/alicia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Alicia_von_Auslese",
  },
  {
    id: "78",
    name: "Dunan von Auslese",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Royal Family"],
    age: 35,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/dunan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Dunan_von_Auslese",
  },
  {
    id: "79",
    name: "Phillip Runall",
    gender: "Male",
    weapon: "Blade",
    nationality: "Liberlian",
    affiliation: ["Royal Family", "Royal Army"],
    age: 58,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/phillip.webp",
    wikiUrl: "https://falcom.wiki/wiki/Phillip_Renard",
  },
  {
    id: "80",
    name: "Kurt Nardin",
    gender: "Male",
    weapon: "Spear",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 29,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/kurtn.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kurt_Nardin",
  },
  {
    id: "81",
    name: "Elnan",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Bracer Guild"],
    age: 25,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/elnan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Elnan",
  },
  {
    id: "82",
    name: "Loewe",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Ouroboros", "Jaeger", "Intelligence Division"],
    age: 26,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/loewe.webp",
    wikiUrl: "https://falcom.wiki/wiki/Leonhardt",
  },
  {
    id: "83",
    name: "Mueller Vander",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Imperial Army", "Vander School"],
    age: 28,
    debutGame: "FC",
    imageUrl: "/images/characterSquares/mueller.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mueller_Vander",
  },
  {
    id: "84",
    name: "Lena Bright",
    gender: "Female",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["N/A"],
    age: "Unknown",
    predictedAgeRange: { min: 30, max: 35 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/lena.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lena_Bright",
  },
  {
    id: "85",
    name: "Luciola",
    gender: "Female",
    weapon: "Fan",
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    predictedAgeRange: { min: 22, max: 26 },
    debutGame: "SC",
    imageUrl: "/images/characterSquares/luciola.webp",
    wikiUrl: "https://falcom.wiki/wiki/Luciola",
  },
  {
    id: "86",
    name: "Bleublanc",
    gender: "Male",
    weapon: "Non-Orbal Staff",
    nationality: "South Zemurian",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    predictedAgeRange: { min: 25, max: 35 },
    debutGame: "SC",
    imageUrl: "/images/characterSquares/bleublanc.webp",
    wikiUrl: "https://falcom.wiki/wiki/Bleublanc",
  },
  {
    id: "87",
    name: "Campanella",
    gender: "Male",
    weapon: "N/A",
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    debutGame: "SC",
    imageUrl: "/images/characterSquares/campanella.webp",
    wikiUrl: "https://falcom.wiki/wiki/Campanella",
  },
  {
    id: "88",
    name: "Mayor Klaus",
    gender: "Male",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Rolent Government"],
    age: "Unknown",
    predictedAgeRange: { min: 57, max: 69 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/klaus.webp",
    wikiUrl: "https://falcom.wiki/wiki/Klaus",
  },
  {
    id: "89",
    name: "Walter Kron",
    gender: "Male",
    weapon: "Fists",
    nationality: "Calvardian",
    affiliation: ["Ouroboros"],
    age: 31,
    debutGame: "SC",
    imageUrl: "/images/characterSquares/walter.webp",
    wikiUrl: "https://falcom.wiki/wiki/Walter",
  },
  {
    id: "90",
    name: "Zechs Vander",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Imperial Army", "Vander School"],
    age: "Unknown",
    predictedAgeRange: { min: 48, max: 60 },
    debutGame: "SC",
    imageUrl: "/images/characterSquares/zechs.webp",
    wikiUrl: "https://falcom.wiki/wiki/Zechs_Vander",
  },
  {
    id: "91",
    name: "Lechter Arundel",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: [
      "Imperial Army",
      "Intelligence Division",
      "Ironbloods",
      "Jenis",
    ],
    age: 19,
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/lechter.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lechter_Arundel",
  },
  {
    id: "92",
    name: "Ein Selnate",
    gender: "Female",
    weapon: "Blade",
    nationality: "Unknown",
    affiliation: ["Gralsritter", "Septian Church"],
    age: 29,
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/ein.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ein_Selnate",
  },
  {
    id: "93",
    name: "Grandmaster",
    gender: "Female",
    weapon: "N/A",
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/grandmaster.webp",
    wikiUrl: "https://falcom.wiki/wiki/Grandmaster",
  },
  {
    id: "94",
    name: "Giliath Osborne",
    gender: "Male",
    weapon: "Blade",
    nationality: "Erebonian",
    affiliation: ["Imperial Army", "Ironbloods", "Erebonian Government"],
    age: 52,
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/osborne.webp",
    wikiUrl: "https://falcom.wiki/wiki/Giliath_Osborne",
  },
  {
    id: "95",
    name: "Halle Coleman",
    gender: "Female",
    weapon: "Gun",
    nationality: "Calvardian",
    affiliation: ["Information Broker"],
    age: 15,
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/halle.webp",
    wikiUrl: "https://falcom.wiki/wiki/Halle_Coleman",
  },
  {
    id: "96",
    name: "Jack Trevor",
    gender: "Male",
    weapon: "Gun",
    nationality: "Calvardian",
    affiliation: ["Information Broker"],
    age: 28,
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/jack.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jack_Trevor",
  },
  {
    id: "97",
    name: "Abbas",
    gender: "Male",
    weapon: "Fists",
    nationality: "Unknown",
    affiliation: ["Testaments", "Gralsritter", "Septian Church"],
    age: 29,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/abbas.webp",
    wikiUrl: "https://falcom.wiki/wiki/Abbas",
  },
  {
    id: "98",
    name: "Aeolia",
    gender: "Female",
    weapon: "Knives",
    nationality: "Remiferian",
    affiliation: ["Bracer Guild"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 25 },
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/aeolia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Aeolia",
  },
  {
    id: "99",
    name: "Alex Dudley",
    gender: "Male",
    weapon: "Gun",
    nationality: "Crossbellan",
    affiliation: ["CPD"],
    age: 27,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/dudley.webp",
    wikiUrl: "https://falcom.wiki/wiki/Alex_Dudley",
  },
  {
    id: "100",
    name: "KeA",
    gender: "Female",
    weapon: "N/A",
    nationality: "Unknown",
    affiliation: ["SSS"],
    age: 9,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/kea.webp",
    wikiUrl: "https://falcom.wiki/wiki/KeA_Bannings",
  },
  {
    id: "101",
    name: "Lynn",
    gender: "Female",
    weapon: "Fists",
    nationality: "Unknown",
    affiliation: ["Bracer Guild"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 25 },
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/lynn.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lynn",
  },
  {
    id: "102",
    name: "Cao Lee",
    gender: "Male",
    weapon: "Fists",
    nationality: "Calvardian",
    affiliation: ["Heiyue"],
    age: 25,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/cao.webp",
    wikiUrl: "https://falcom.wiki/wiki/Cao_Lee",
  },
  {
    id: "103",
    name: "Cecile Neues",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["St. Ursula"],
    age: 23,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/cecile.webp",
    wikiUrl: "https://falcom.wiki/wiki/Cecile_Neues",
  },
  {
    id: "104",
    name: "Mariabell Crois",
    gender: "Female",
    weapon: "Non-Orbal Staff",
    nationality: "Crossbellan",
    affiliation: ["Ouroboros", "IBC"],
    age: 19,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/mariabell.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mariabell_Crois",
  },
  {
    id: "105",
    name: "Mireille",
    gender: "Female",
    weapon: ["Gun", "Halberd"],
    nationality: "Crossbellan",
    affiliation: ["CGF"],
    age: 21,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/mireille.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mireille",
  },
  {
    id: "106",
    name: "Michel",
    gender: "Male",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["Bracer Guild"],
    age: 32,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/michel.webp",
    wikiUrl: "https://falcom.wiki/wiki/Michel",
  },
  {
    id: "107",
    name: "Dieter Crois",
    gender: "Male",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["IBC", "Crossbell Government"],
    age: 45,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/dieter.webp",
    wikiUrl: "https://falcom.wiki/wiki/Dieter_Crois",
  },
  {
    id: "108",
    name: "Mishy",
    gender: "Male",
    weapon: "N/A",
    nationality: "Somewhere fluffy",
    affiliation: ["Mishelam Wonderland"],
    age: "Unknown",
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/mishy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mishy",
  },
  {
    id: "109",
    name: "Mishette",
    gender: "Female",
    weapon: "N/A",
    nationality: "Somewhere fluffy",
    affiliation: ["Mishelam Wonderland"],
    age: "Unknown",
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/mishette.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mishette",
  },
  {
    id: "110",
    name: "Ernest Reis",
    gender: "Male",
    weapon: "Blade",
    nationality: "Crossbellan",
    affiliation: ["Crossbell Government", "D.G Cult"],
    age: 28,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/ernest.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ernest_Reis",
  },
  {
    id: "111",
    name: "Fran Seeker",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["CPD"],
    age: 17,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/fran.webp",
    wikiUrl: "https://falcom.wiki/wiki/Fran_Seeker",
  },
  {
    id: "112",
    name: "Garcia Rossi",
    gender: "Male",
    weapon: "Fists",
    nationality: "Unknown",
    affiliation: ["Revache", "Jaeger"],
    age: 42,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/garcia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Garcia_Rossi",
  },
  {
    id: "113",
    name: "Grace Lynn",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["Crossbell News", "Journalist"],
    age: 25,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/grace.webp",
    wikiUrl: "https://falcom.wiki/wiki/Grace_Lynn",
  },
  {
    id: "114",
    name: "Guy Bannings",
    gender: "Male",
    weapon: "Tonfas",
    nationality: "Crossbellan",
    affiliation: ["CPD"],
    age: 25,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/guy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Guy_Bannings",
  },
  {
    id: "115",
    name: "Harold Hayworth",
    gender: "Male",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["N/A"],
    age: 34,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/harold.webp",
    wikiUrl: "https://falcom.wiki/wiki/Harold_Hayworth",
  },
  {
    id: "116",
    name: "Henry MacDowell",
    gender: "Male",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["Crossbell Government"],
    age: 70,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/henry.webp",
    wikiUrl: "https://falcom.wiki/wiki/Henry_MacDowell",
  },
  {
    id: "117",
    name: "Sergei Lou",
    gender: "Male",
    weapon: "Gun",
    nationality: "Crossbellan",
    affiliation: ["SSS", "CPD"],
    age: 38,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/sergei.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sergei_Lou",
  },
  {
    id: "118",
    name: "Shanshan",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["N/A"],
    age: "17",
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/shanshan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Shanshan",
  },
  {
    id: "119",
    name: "Sonya Baelz",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["CGF"],
    age: 36,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/sonya.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sonya_Baelz",
  },
  {
    id: "120",
    name: "Shizuku Maclaine",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["N/A"],
    age: 9,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/shizuku.webp",
    wikiUrl: "https://falcom.wiki/wiki/Shizuku_MacLaine",
  },
  {
    id: "121",
    name: "Sully Atraid",
    gender: "Female",
    weapon: "N/A",
    nationality: "North Ambrian",
    affiliation: ["Arc en Ciel"],
    age: 13,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/sully.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sully_Atraid",
  },
  {
    id: "122",
    name: "Ian Grimwood",
    gender: "Male",
    weapon: "Gun",
    nationality: "Crossbellan",
    affiliation: ["Grimwood Law Office"],
    age: 56,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/grimwood.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ian_Grimwood",
  },
  {
    id: "123",
    name: "Imelda",
    gender: "Female",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["Antique Shop"],
    age: "Unknown",
    predictedAgeRange: { min: 60, max: 75 },
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/imelda.webp",
    wikiUrl: "https://falcom.wiki/wiki/Imelda",
  },
  {
    id: "124",
    name: "Jingo",
    gender: "Female",
    weapon: "Gun",
    nationality: "Crossbellan",
    affiliation: ["Neinvalli"],
    age: 10,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/jingo.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jingo",
  },
  {
    id: "125",
    name: "Joachim Guenter",
    gender: "Male",
    weapon: "Non-Orbal Staff",
    nationality: "Remiferian",
    affiliation: ["St. Ursula", "D.G Cult"],
    age: 34,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/joachim.webp",
    wikiUrl: "https://falcom.wiki/wiki/Joachim_Guenter",
  },
  {
    id: "126",
    name: "Joerg Rosenberg",
    gender: "Male",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["Rosenberg Studio", "Thirteen Factories", "Ouroboros"],
    age: 75,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/rosenberg.webp",
    wikiUrl: "https://falcom.wiki/wiki/Joerg_Rosenberg",
  },
  {
    id: "127",
    name: "Zita Asval",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Central Eastern",
    affiliation: ["Royal Family"],
    age: "17",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/zita.webp",
    wikiUrl: "https://falcom.wiki/wiki/Zita_Asval",
  },
  {
    id: "128",
    name: "Jona Sacred",
    gender: "Male",
    weapon: "N/A",
    nationality: "Lemanian",
    affiliation: ["Epstein Foundation"],
    age: 13,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/jona.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jona_Sacred",
  },
  {
    id: "129",
    name: "Wald Wales",
    gender: "Male",
    weapon: "Club",
    nationality: "Crossbellan",
    affiliation: ["Saber Vipers", "Septian Church", "Gralsritter"],
    age: 20,
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/wald.webp",
    wikiUrl: "https://falcom.wiki/wiki/Wald_Wales",
  },
  {
    id: "130",
    name: "Zeit",
    gender: "Male",
    weapon: "N/A",
    nationality: "Unknown",
    affiliation: ["SSS"],
    age: "Unknown",
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/zeit.webp",
    wikiUrl: "https://falcom.wiki/wiki/Zeit",
  },
  {
    id: "131",
    name: "Nadia Rayne",
    gender: "Female",
    weapon: ["Needles", "Bears"],
    nationality: "Remiferian",
    affiliation: ["Picnic", "The Gardens", "Arkride Solutions"],
    age: "13",
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/nadia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Nadia_Rayne",
  },
  {
    id: "132",
    name: "Swin Abel",
    gender: "Male",
    weapon: "Blade",
    nationality: "Remiferian",
    affiliation: ["Picnic", "The Gardens", "Arkride Solutions"],
    age: "15",
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/swin.webp",
    wikiUrl: "https://falcom.wiki/wiki/Swin_Abel",
  },
  {
    id: "133",
    name: "Sharon Kreuger",
    gender: "Female",
    weapon: ["Wires", "Blade"],
    nationality: "Unknown",
    affiliation: ["Ouroboros", "Reinford Group", "Class VII"],
    age: "23",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/sharon.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sharon_Kreuger",
  },
  {
    id: "134",
    name: "Arianrhod",
    gender: "Female",
    weapon: ["Lance"],
    nationality: "Erebonian",
    affiliation: ["Ouroboros", "Stahlritter", "Eisenritter"],
    age: "278",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/arianrhod.webp",
    wikiUrl: "https://falcom.wiki/wiki/Arianrhod",
  },
  {
    id: "135",
    name: "Duvalie",
    gender: "Female",
    weapon: ["Blade"],
    nationality: "Unknown",
    affiliation: ["Stahlritter", "Ouroboros"],
    age: "21",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/duvalie.webp",
    wikiUrl: "https://falcom.wiki/wiki/Duvalie",
  },
  {
    id: "136",
    name: "Ines",
    gender: "Female",
    weapon: ["Halberd"],
    nationality: "Unknown",
    affiliation: ["Stahlritter", "Ouroboros"],
    age: "21",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/ines.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ines",
  },
  {
    id: "137",
    name: "Ennea",
    gender: "Female",
    weapon: ["Bow"],
    nationality: "Unknown",
    affiliation: ["Stahlritter", "Ouroboros"],
    age: "22",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/ennea.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ennea",
  },
  {
    id: "138",
    name: "Professor Seiland",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Remiferian",
    affiliation: ["St. Ursula", "Seiland Company"],
    age: "Unknown",
    predictedAgeRange: { min: 37, max: 42 },
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/seiland.webp",
    wikiUrl: "https://falcom.wiki/wiki/seiland",
  },
  {
    id: "139",
    name: "Novartis",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Lemanian",
    affiliation: ["Ouroboros", "Thirteen Factories"],
    age: "Unknown",
    predictedAgeRange: { min: 55, max: 75 },
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/novartis.webp",
    wikiUrl: "https://falcom.wiki/wiki/F._Novartis",
  },
  {
    id: "140",
    name: "Samuel Rocksmith",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Calvard Government", "Rocksmith Agency"],
    age: "64",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/rocksmith.webp",
    wikiUrl: "https://falcom.wiki/wiki/Samuel_Rocksmith",
  },
  {
    id: "141",
    name: "Shirley Orlando",
    gender: "Female",
    weapon: ["Gunblade"],
    nationality: "Unknown",
    affiliation: ["Jaeger", "Ouroboros", "Thors"],
    age: "16",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/shirley.webp",
    wikiUrl: "https://falcom.wiki/wiki/Shirley_Orlando",
  },
  {
    id: "142",
    name: "Sigmund Orlando",
    gender: "Male",
    weapon: ["Dual Axes"],
    nationality: "Unknown",
    affiliation: ["Jaeger"],
    age: "43",
    debutGame: "Azure",
    imageUrl: "/images/characterSquares/sigmund.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sigmund_Orlando",
  },
  {
    id: "143",
    name: "Victor S. Arseid",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Arseid Family"],
    age: "43",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/victor.webp",
    wikiUrl: "https://falcom.wiki/wiki/Victor_S._Arseid",
  },
  {
    id: "144",
    name: "Vita Clotilde",
    gender: "Female",
    weapon: ["Non-Orbal Staff", "Fan"],
    nationality: "Erebonian",
    affiliation: ["Ouroboros", "Hexen Clan", "Radio Trista"],
    age: "24",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/vita.webp",
    wikiUrl: "https://falcom.wiki/wiki/Vita_Clotilde",
  },
  {
    id: "145",
    name: "Vivi",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Imperial Chronicle", "Journalist", "Class V"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/vivi.webp",
    wikiUrl: "https://falcom.wiki/wiki/Vivi",
  },
  {
    id: "146",
    name: "Vulcan",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Erebonian",
    affiliation: ["ILF", "Jaeger"],
    age: 32,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/vulcan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Vulcan",
  },
  {
    id: "147",
    name: "Irina Reinford",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors Board", "Reinford Group"],
    age: "40",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/irina.webp",
    wikiUrl: "https://falcom.wiki/wiki/Irina_Reinford",
  },
  {
    id: "148",
    name: "Xeno",
    gender: "Male",
    weapon: ["Gunblade"],
    nationality: "Unknown",
    affiliation: ["Jaeger"],
    age: "34",
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/xeno.webp",
    wikiUrl: "https://falcom.wiki/wiki/Xeno",
  },
  {
    id: "149",
    name: "George Nome",
    gender: "Male",
    weapon: ["Combat Shell"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Gnomes", "Black Workshop"],
    age: 19,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/george.webp",
    wikiUrl: "https://falcom.wiki/wiki/George_Nome",
  },
  {
    id: "150",
    name: "Grianos",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Familiar", "Hexen Clan"],
    age: "Unknown",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/grianos.webp",
    wikiUrl: "https://falcom.wiki/wiki/Grianos",
  },
  {
    id: "151",
    name: "Gwyn Reinford",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Reinford Group"],
    age: "Unknown",
    predictedAgeRange: { min: 60, max: 75 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/gwyn.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gwyn_Reinford",
  },
  {
    id: "152",
    name: "Thoma Worzel",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Nord",
    affiliation: ["Nord Village"],
    age: "14",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/thoma.webp",
    wikiUrl: "https://falcom.wiki/wiki/Thoma_Worzel",
  },
  {
    id: "153",
    name: "Thomas Lysander",
    gender: "Male",
    weapon: ["Orbal Staff"],
    nationality: "Unknown",
    affiliation: ["Thors", "Gralsritter", "Septian Church"],
    age: "34",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/thomas.webp",
    wikiUrl: "https://falcom.wiki/wiki/Thomas_Lysander",
  },
  {
    id: "154",
    name: "Toval Randonneur",
    gender: "Male",
    weapon: ["Stun Rod"],
    nationality: "Erebonian",
    affiliation: ["Bracer Guild"],
    age: "27",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/toval.webp",
    wikiUrl: "https://falcom.wiki/wiki/Toval_Randonneur",
  },
  {
    id: "155",
    name: "Heinrich",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors"],
    age: "Unknown",
    predictedAgeRange: { min: 58, max: 65 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/heinrich.webp",
    wikiUrl: "https://falcom.wiki/wiki/Heinrich",
  },
  {
    id: "156",
    name: "Helmut Albarea",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Four Great Houses"],
    age: "Unknown",
    predictedAgeRange: { min: 50, max: 60 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/helmut.webp",
    wikiUrl: "https://falcom.wiki/wiki/Helmut_Albarea",
  },
  {
    id: "157",
    name: "Vandyck",
    gender: "Male",
    weapon: ["Polearm"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Imperial Army"],
    age: "70",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/vandyck.webp",
    wikiUrl: "https://falcom.wiki/wiki/Vandyck",
  },
  {
    id: "158",
    name: "Rosine",
    gender: "Female",
    weapon: ["Bowgun"],
    nationality: "Unknown",
    affiliation: ["Thors", "Gralsritter", "Septian Church"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/rosine.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rosine",
  },
  {
    id: "159",
    name: "Rufus Albarea",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Thors Board", "Picnic", "Ironbloods", "Four Great Houses"],
    age: "27",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/rufus.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rufus_Albarea",
  },
  {
    id: "160",
    name: "Rex",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Imperial Chronicle", "Journalist"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/rex.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rex",
  },
  {
    id: "161",
    name: "Priscilla Reise Arnor",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Royal Family"],
    age: "36",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/priscilla.webp",
    wikiUrl: "https://falcom.wiki/wiki/Priscilla_Reise_Arnor",
  },
  {
    id: "162",
    name: "Eugent Reise Arnor III",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Royal Family", "Erebonian Government"],
    age: "48",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/eugent.webp",
    wikiUrl: "https://falcom.wiki/wiki/Eugent_Reise_Arnor_III",
  },
  {
    id: "163",
    name: "Patrick T. Hyarms",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Four Great Houses", "Class I"],
    age: "18",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/patrick.webp",
    wikiUrl: "https://falcom.wiki/wiki/Patrick_T._Hyarms",
  },
  {
    id: "164",
    name: "Emily",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Imperial Army"],
    age: "18",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/emily.webp",
    wikiUrl: "https://falcom.wiki/wiki/Emily",
  },
  {
    id: "165",
    name: "Olaf Craig",
    gender: "Male",
    weapon: ["Polearm"],
    nationality: "Erebonian",
    affiliation: ["Imperial Army"],
    age: "45",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/olaf.webp",
    wikiUrl: "https://falcom.wiki/wiki/Olaf_Craig",
  },
  {
    id: "166",
    name: "Neithardt",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Imperial Army"],
    age: "29",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/neithardt.webp",
    wikiUrl: "https://falcom.wiki/wiki/Neithardt",
  },
  {
    id: "167",
    name: "Croire de Cayenne",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Four Great Houses"],
    age: "Unknown",
    predictedAgeRange: { min: 45, max: 55 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/cayenne.webp",
    wikiUrl: "https://falcom.wiki/wiki/Croire_de_Cayenne",
  },
  {
    id: "168",
    name: "Cedric Reise Arnor",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Ouroboros", "Royal Family"],
    age: "15",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/cedric.webp",
    wikiUrl: "https://falcom.wiki/wiki/Cedric_Reise_Arnor",
  },
  {
    id: "169",
    name: "Carl Regnitz",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors Board", "Erebonian Government"],
    age: "50",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/carl.webp",
    wikiUrl: "https://falcom.wiki/wiki/Carl_Regnitz",
  },
  {
    id: "170",
    name: "Mint Braun",
    gender: "Female",
    weapon: ["Orbal Cannon"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Class III"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/mint.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mint_Braun",
  },
  {
    id: "171",
    name: "Michael Gideon",
    gender: "Male",
    weapon: ["Gun", "Flute"],
    nationality: "Erebonian",
    affiliation: ["ILF"],
    age: 34,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/gideon.webp",
    wikiUrl: "https://falcom.wiki/wiki/Michael_Gideon",
  },
  {
    id: "172",
    name: "Mary Altheim",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors"],
    age: "Unknown",
    predictedAgeRange: { min: 26, max: 34 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/mary.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mary_Altheim",
  },
  {
    id: "173",
    name: "Makarov",
    gender: "Male",
    weapon: ["Orbal Staff"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Roer Institute"],
    age: "Unknown",
    predictedAgeRange: { min: 36, max: 46 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/makarov.webp",
    wikiUrl: "https://falcom.wiki/wiki/Makarov",
  },
  {
    id: "174",
    name: "Becky",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Class V"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/becky.webp",
    wikiUrl: "https://falcom.wiki/wiki/Becky",
  },
  {
    id: "175",
    name: "Beryl",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Thors", "Class III"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/beryl.webp",
    wikiUrl: "https://falcom.wiki/wiki/Beryl",
  },
  {
    id: "176",
    name: "Butler Klaus",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Arseid Family"],
    age: "Unknown",
    predictedAgeRange: { min: 55, max: 65 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/butlerklaus.webp",
    wikiUrl: "https://falcom.wiki/wiki/Butler_Klaus",
  },
  {
    id: "177",
    name: "Beatrix",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Imperial Army"],
    age: "Unknown",
    predictedAgeRange: { min: 60, max: 70 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/beatrix.webp",
    wikiUrl: "https://falcom.wiki/wiki/Beatrix",
  },
  {
    id: "178",
    name: "Angelica Rogner",
    gender: "Female",
    weapon: ["Fists"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Four Great Houses"],
    age: 19,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/angelica.webp",
    wikiUrl: "https://falcom.wiki/wiki/Angelica_Rogner",
  },
  {
    id: "179",
    name: "Lacan Worzel",
    gender: "Male",
    weapon: ["Spear"],
    nationality: "Nord",
    affiliation: ["Nord Village"],
    age: "Unknown",
    predictedAgeRange: { min: 50, max: 60 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/lacan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lacan_Worzel",
  },
  {
    id: "180",
    name: "Leonidas",
    gender: "Male",
    weapon: ["Gauntlet"],
    nationality: "Central Eastern",
    affiliation: ["Jaeger"],
    age: "36",
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/leonidas.webp",
    wikiUrl: "https://falcom.wiki/wiki/Leonidas",
  },
  {
    id: "181",
    name: "Linde",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "St. Ursula", "Class V"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/linde.webp",
    wikiUrl: "https://falcom.wiki/wiki/Linde",
  },
  {
    id: "182",
    name: "Aurelia Le Guin",
    gender: "Female",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Weissland Army"],
    age: "30",
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/aurelia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Aurelia_Le_Guin",
  },
  {
    id: "183",
    name: "Wallace Bardias",
    gender: "Male",
    weapon: ["Spear"],
    nationality: "Erebonian",
    affiliation: ["Weissland Army"],
    age: "Unknown",
    predictedAgeRange: { min: 29, max: 36 },
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/bardias.webp",
    wikiUrl: "https://falcom.wiki/wiki/Wallace_Bardias",
  },
  {
    id: "184",
    name: "Gerhard Schmidt",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Roer Institute"],
    age: "70",
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/schmidt.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gerhard_Schmidt",
  },
  {
    id: "185",
    name: "Roselia",
    gender: "Female",
    weapon: ["Non-Orbal Staff"],
    nationality: "Erebonian",
    affiliation: ["Hexen Clan", "Familiar"],
    age: "800",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/roselia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Roselia_Millstein",
  },
  {
    id: "186",
    name: "Rutger Claussell",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Unknown",
    affiliation: ["Jaeger"],
    age: "50",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/rutger.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rutger_Claussell",
  },
  {
    id: "187",
    name: "Michael Irving",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Erebonian",
    affiliation: ["Thors", "RMP"],
    age: "28",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/michael.webp",
    wikiUrl: "https://falcom.wiki/wiki/Michael_Irving",
  },
  {
    id: "188",
    name: "Rufina Argent",
    gender: "Female",
    weapon: ["Blade", "Bowgun"],
    nationality: "Arterian",
    affiliation: ["Gralsritter", "Septian Church"],
    age: "27",
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/rufina.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rufina_Argent",
  },

  {
    id: "189",
    name: "Black Alberich",
    gender: "Male",
    weapon: ["Combat Shell"],
    nationality: "Erebonian",
    affiliation: ["Black Workshop", "Reinford Group", "Gnomes"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 49 },
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/alberich.webp",
    wikiUrl: "https://falcom.wiki/wiki/Black_Alberich",
  },
  {
    id: "190",
    name: "Lapis Rosenberg",
    gender: "Female",
    weapon: ["Axe"],
    nationality: "N/A",
    affiliation: ["Rosenberg Studio", "Picnic"],
    age: "Unknown",
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/lapis.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lapis_Rosenberg",
  },
  {
    id: "191",
    name: "Matteus Vander",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Vander School", "Imperial Army"],
    age: "Unknown",
    predictedAgeRange: { min: 50, max: 60 },
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/matteus.webp",
    wikiUrl: "https://falcom.wiki/wiki/Matteus_Vander",
  },
  {
    id: "192",
    name: "Lucy Seiland",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Remiferian",
    affiliation: ["Seiland Company", "Jenis"],
    age: "Unknown",
    predictedAgeRange: { min: 17, max: 18 },
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/lucy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lucy_Seiland",
  },
  {
    id: "193",
    name: "Alexandre",
    gender: "Male",
    weapon: ["Gauntlet"],
    nationality: "North Ambrian",
    affiliation: ["Almata"],
    age: "35",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/alexandre.webp",
    wikiUrl: "https://falcom.wiki/wiki/Alexandre",
  },
  {
    id: "194",
    name: "Alvis",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Calvardian",
    affiliation: ["Bracer Guild"],
    age: "Unknown",
    predictedAgeRange: { min: 22, max: 27 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/alvis.webp",
    wikiUrl: "https://falcom.wiki/wiki/Alvis",
  },
  {
    id: "195",
    name: "Arioch",
    gender: "Male",
    weapon: ["Halberd"],
    nationality: "Iskan",
    affiliation: ["Almata", "The Gardens"],
    age: "26",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/arioch.webp",
    wikiUrl: "https://falcom.wiki/wiki/Arioch",
  },
  {
    id: "196",
    name: "Ashen Lu",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Heiyue"],
    age: "17",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/ashen.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ashen_Lu",
  },
  {
    id: "197",
    name: "Ashladd",
    gender: "Male",
    weapon: ["Mace"],
    nationality: "Unknown",
    affiliation: ["Septian Church", "Iscariot"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 50 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/ashladd.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ashladd",
  },
  {
    id: "198",
    name: "Latoya Hamilton",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Epstein Foundation", "Verne Company", "Basel Institute"],
    age: "74",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/latoya.webp",
    wikiUrl: "https://falcom.wiki/wiki/Latoya_Hamilton",
  },
  {
    id: "199",
    name: "Leon Balthazar",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Gralsritter", "Septian Church"],
    age: "25",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/leon.webp",
    wikiUrl: "https://falcom.wiki/wiki/Leon_Balthazar",
  },
  {
    id: "200",
    name: "Lucrezia Isselee",
    gender: "Female",
    weapon: ["Glaive"],
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "29",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/lucrezia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Lucrezia_Isselee",
  },
  {
    id: "201",
    name: "Mare",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Marduk", "Arkride Solutions"],
    age: "Unknown",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/mare.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mare",
  },
  {
    id: "202",
    name: "Maxim Lugan",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Z1"],
    age: "31",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/maxim.webp",
    wikiUrl: "https://falcom.wiki/wiki/Maxim_Lugan",
  },
  {
    id: "203",
    name: "Marielle Aymé",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Tyrell Times", "Journalist"],
    age: "21",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/marielle.webp",
    wikiUrl: "https://falcom.wiki/wiki/Marielle_Aymé",
  },
  {
    id: "204",
    name: "Melchior",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Unknown",
    affiliation: ["Almata", "The Gardens"],
    age: "21",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/melchior.webp",
    wikiUrl: "https://falcom.wiki/wiki/Melchior",
  },
  {
    id: "205",
    name: "Bergard Zeman",
    gender: "Male",
    weapon: ["Fists"],
    nationality: "Unknown",
    affiliation: ["Septian Church", "Gralsritter", "Arkride Solutions"],
    age: "69",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/bergard.webp",
    wikiUrl: "https://falcom.wiki/wiki/Bergard_Zeman",
  },
  {
    id: "206",
    name: "Bermotti",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Information Broker"],
    age: "Unknown",
    predictedAgeRange: { min: 25, max: 30 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/bermotti.webp",
    wikiUrl: "https://falcom.wiki/wiki/Bermotti",
  },
  {
    id: "207",
    name: "Nate",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["CNP"],
    age: "Unknown",
    predictedAgeRange: { min: 22, max: 26 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/nate.webp",
    wikiUrl: "https://falcom.wiki/wiki/Nate",
  },
  {
    id: "208",
    name: "Nina Fenly",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Septian Church"],
    age: "18",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/nina.webp",
    wikiUrl: "https://falcom.wiki/wiki/Nina_Fenly",
  },
  {
    id: "209",
    name: "Odette",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Aramis"],
    age: "16",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/odette.webp",
    wikiUrl: "https://falcom.wiki/wiki/Odette",
  },
  {
    id: "210",
    name: "Olympia",
    gender: "Female",
    weapon: ["Doll"],
    nationality: "East Zemurian",
    affiliation: ["Almata", "The Gardens"],
    age: "19",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/olympia.webp",
    wikiUrl: "https://falcom.wiki/wiki/Olympia",
  },
  {
    id: "211",
    name: "Celis Ortesia",
    gender: "Female",
    weapon: ["Blade"],
    nationality: "Unknown",
    affiliation: ["Gralsritter", "Septian Church"],
    age: "27",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/celis.webp",
    wikiUrl: "https://falcom.wiki/wiki/Celis_Ortesia",
  },
  {
    id: "212",
    name: "Cody McMillan",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Calvardian",
    affiliation: ["CID"],
    age: "18",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/cody.webp",
    wikiUrl: "https://falcom.wiki/wiki/Cody_McMillan",
  },
  {
    id: "213",
    name: "Paulette",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Montmart"],
    age: "27",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/paulette.webp",
    wikiUrl: "https://falcom.wiki/wiki/Paulette",
  },
  {
    id: "214",
    name: "Daswani",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["CNP"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 50 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/daswani.webp",
    wikiUrl: "https://falcom.wiki/wiki/Daswani",
  },
  {
    id: "215",
    name: "Dingo Brad",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Information Broker", "Journalist"],
    age: "28",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/dingo.webp",
    wikiUrl: "https://falcom.wiki/wiki/Dingo_Brad",
  },
  {
    id: "216",
    name: "Ellroy Harwood",
    gender: "Male",
    weapon: ["Poison"],
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "47",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/ellroy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ellroy_Harwood",
  },
  {
    id: "217",
    name: "Esmeray Archette",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Basel Institute"],
    age: "27",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/esmeray.webp",
    wikiUrl: "https://falcom.wiki/wiki/Esmeray_Archette",
  },
  {
    id: "218",
    name: "René Kincaid",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["CID", "Calvard Government"],
    age: "25",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/rene.webp",
    wikiUrl: "https://falcom.wiki/wiki/René_Kincaid",
  },
  {
    id: "219",
    name: "Roy Gramheart",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["Calvard Government"],
    age: "45",
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/roy.webp",
    wikiUrl: "https://falcom.wiki/wiki/Roy_Gramheart",
  },
  {
    id: "220",
    name: "Fan Lu",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Heiyue"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 50 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/fan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Fan_Lu",
  },
  {
    id: "221",
    name: "Saara",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Central Eastern",
    affiliation: ["N/A"],
    age: "Unknown",
    predictedAgeRange: { min: 17, max: 20 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/saara.webp",
    wikiUrl: "https://falcom.wiki/wiki/Saara",
  },
  {
    id: "222",
    name: "Salvatore Gotti",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Vegas Films"],
    age: "Unknown",
    predictedAgeRange: { min: 45, max: 55 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/gotti.webp",
    wikiUrl: "https://falcom.wiki/wiki/Salvatore_Gotti",
  },
  {
    id: "223",
    name: "Shaheena",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Central Eastern",
    affiliation: ["N/A"],
    age: "15",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/shaheena.webp",
    wikiUrl: "https://falcom.wiki/wiki/Shaheena",
  },
  {
    id: "224",
    name: "Sherid Asval",
    gender: "Male",
    weapon: ["Flute", "Gems"],
    nationality: "Central Eastern",
    affiliation: ["Royal Family"],
    age: "27",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/sherid.webp",
    wikiUrl: "https://falcom.wiki/wiki/Sherid_Asval",
  },
  {
    id: "225",
    name: "Gerard Dantès",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Calvardian",
    affiliation: ["Almata", "D.G Cult"],
    age: "34",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/gerard.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gerard_Dantès",
  },
  {
    id: "226",
    name: "Viola",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Central Eastern",
    affiliation: ["Almata"],
    age: "26",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/viola.webp",
    wikiUrl: "https://falcom.wiki/wiki/Viola",
  },
  {
    id: "227",
    name: "Hasan Al-Fayed",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Central Eastern",
    affiliation: ["Jaeger"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 50 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/hasan.webp",
    wikiUrl: "https://falcom.wiki/wiki/Hasan_Al-Fayed",
  },
  {
    id: "229",
    name: "Judith Lanster",
    gender: "Female",
    weapon: ["Whip"],
    nationality: "Calvardian",
    affiliation: ["Arkride Solutions", "Grimcat"],
    age: "22",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/judith.webp",
    wikiUrl: "https://falcom.wiki/wiki/Judith_Lanster",
  },
  {
    id: "230",
    name: "Yumé",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Montmart"],
    age: "6",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/yume.webp",
    wikiUrl: "https://falcom.wiki/wiki/Yumé",
  },
  {
    id: "231",
    name: "Kaela McMillan",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["CID"],
    age: "19",
    debutGame: "CS4",
    imageUrl: "/images/characterSquares/kaela.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kaela_McMillan",
  },
  {
    id: "232",
    name: "Kasim Al-Fayed",
    gender: "Male",
    weapon: ["Gunblade"],
    nationality: "Central Eastern",
    affiliation: ["Marduk", "Jaeger"],
    age: "27",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/kasim.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kasim_Al-Fayed",
  },
  {
    id: "233",
    name: "Kurogane",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "East Zemurian",
    affiliation: ["Jaeger"],
    age: "38",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/kurogane.webp",
    wikiUrl: "https://falcom.wiki/wiki/Kurogane",
  },
  {
    id: "234",
    name: "Gien Lu",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Heiyue"],
    age: "78",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/gien.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gien_Lu",
  },
  {
    id: "235",
    name: "Naje Berka",
    gender: "Female",
    weapon: ["Blade"],
    nationality: "Central Eastern",
    affiliation: ["Royal Family"],
    age: "25",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/naje.webp",
    wikiUrl: "https://falcom.wiki/wiki/Naje_Berka",
  },
  {
    id: "236",
    name: "Rosalie",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Thirteen Factories", "Zecht Arms"],
    age: "Unknown",
    predictedAgeRange: { min: 32, max: 40 },
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/rosalie.webp",
    wikiUrl: "https://falcom.wiki/wiki/Rosalie",
  },
  {
    id: "237",
    name: "Gaolang",
    gender: "Male",
    weapon: ["Fists"],
    nationality: "Calvardian",
    affiliation: ["Heiyue"],
    age: "25",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/gaolang.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gaolang",
  },
  {
    id: "238",
    name: "Gilliam Thorndyke",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Marduk"],
    age: "35",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/gilliam.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gilliam_Thorndyke",
  },
  {
    id: "239",
    name: "Ixs",
    gender: "Male",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["Ouroboros", "The Gardens"],
    age: "14",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/ixs.webp",
    wikiUrl: "https://falcom.wiki/wiki/Ixs",
  },
  {
    id: "240",
    name: "Jorda",
    gender: "Female",
    weapon: ["Shadow Hand"],
    nationality: "Calvardian",
    affiliation: ["Ouroboros", "The Gardens"],
    age: "14",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/jorda.webp",
    wikiUrl: "https://falcom.wiki/wiki/Jorda",
  },
  {
    id: "241",
    name: "Dominique Lanster",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Calvardian",
    affiliation: ["Grimcat"],
    age: "69",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/dominique.webp",
    wikiUrl: "https://falcom.wiki/wiki/Dominique_Lanster",
  },
  {
    id: "242",
    name: "Mirabel Aalton",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Marduk"],
    age: "22",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/mirabel.webp",
    wikiUrl: "https://falcom.wiki/wiki/Mirabel_Aalton",
  },
  {
    id: "243",
    name: "McBurn",
    gender: "Male",
    weapon: ["Fire", "Blade"],
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    debutGame: "CS2",
    imageUrl: "/images/characterSquares/mcburn.webp",
    wikiUrl: "https://falcom.wiki/wiki/McBurn",
  },
  {
    id: "244",
    name: "Anton",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Liberlian",
    affiliation: ["N/A"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 26 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/anton.webp",
    wikiUrl: "https://falcom.wiki/wiki/Anton",
  },
  {
    id: "245",
    name: "Munk",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Radio Trista"],
    age: 17,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/munk.webp",
    wikiUrl: "https://falcom.wiki/wiki/Munk",
  },
  {
    id: "246",
    name: "Scarlet",
    gender: "Female",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["ILF", "Septian Church", "Gralsritter"],
    age: 22,
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/scarlet.webp",
    wikiUrl: "https://falcom.wiki/wiki/Scarlet",
  },
  {
    id: "247",
    name: "Gardenmaster",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Calvardian",
    affiliation: ["The Gardens"],
    age: "Unknown",
    debutGame: "Daybreak 2",
    imageUrl: "/images/characterSquares/gardenmaster.webp",
    wikiUrl: "https://falcom.wiki/wiki/Gardenmaster",
  },
  {
    id: "248",
    name: "Aida",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Unknown",
    affiliation: ["Jaeger"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 28 },
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/aida.webp",
    wikiUrl: "https://falcom.wiki/wiki/Aida",
  },
  {
    id: "249",
    name: "Ada Grant",
    gender: "Female",
    weapon: ["Gun"],
    nationality: "Erebonian",
    affiliation: ["Thors"],
    age: "17",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/ada.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Ada_Grant",
  },
  {
    id: "250",
    name: "Aurier Vander",
    gender: "Female",
    weapon: ["Naginata"],
    nationality: "Erebonian",
    affiliation: ["Vander School"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 50 },
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/aurier.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Aurier_Vander",
  },
  {
    id: "251",
    name: "Azure Siegfried",
    gender: "Male",
    weapon: ["Gun"],
    nationality: ["Erebonian", "Jurai"],
    affiliation: ["Gnomes", "Black Workshop"],
    age: "21",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/siegfried.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Azure_Siegfried",
  },
  {
    id: "252",
    name: "Bridget",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Class II"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/bridget.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Bridget",
  },
  {
    id: "253",
    name: "C/Reverie",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Picnic"],
    age: "24",
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/c.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/C",
  },
  {
    id: "254",
    name: "Celeste D. Auslese",
    gender: "Female",
    weapon: "N/A",
    nationality: "Liberlian",
    affiliation: ["Royal Family"],
    age: "Unknown",
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/celeste.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Celeste_D._Auslese",
  },
  {
    id: "255",
    name: "Celestin",
    gender: "Male",
    weapon: "Fists",
    nationality: "Erebonian",
    affiliation: ["Four Great Houses", "Thors"],
    age: "Unknown",
    predictedAgeRange: { min: 30, max: 35 },
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/celestin.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Celestin",
  },
  {
    id: "256",
    name: "Colin Hayworth",
    gender: "Male",
    weapon: "N/A",
    nationality: "Crossbellan",
    affiliation: ["N/A"],
    age: "5",
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/colin.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Colin_Hayworth",
  },
  {
    id: "257",
    name: "Dan Russell",
    gender: "Male",
    weapon: ["Staff", "N/A"],
    nationality: "Liberlian",
    affiliation: ["Bracer Guild", "ZCF"],
    age: "36",
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/dan.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Dan_Russell",
  },
  {
    id: "258",
    name: "Rais",
    gender: "Male",
    weapon: ["Stun Rod"],
    nationality: "Liberlian",
    affiliation: ["Bracer Guild", "Ravens"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 28 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/rais.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Rais",
  },
  {
    id: "259",
    name: "Deen",
    gender: "Male",
    weapon: ["Stun Rod"],
    nationality: "Liberlian",
    affiliation: ["Bracer Guild", "Ravens"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 28 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/deen.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Deen",
  },
  {
    id: "260",
    name: "Rocco",
    gender: "Male",
    weapon: ["Stun Rod"],
    nationality: "Liberlian",
    affiliation: ["Bracer Guild", "Ravens"],
    age: "Unknown",
    predictedAgeRange: { min: 20, max: 28 },
    debutGame: "FC",
    imageUrl: "/images/characterSquares/rocco.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Rocco",
  },
  {
    id: "261",
    name: "Emilia Harring",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Calvardian",
    affiliation: ["Republican Army", "Calvard Government"],
    age: "28",
    debutGame: "Daybreak",
    imageUrl: "/images/characterSquares/emilia.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Emilia_Harring",
  },
  {
    id: "262",
    name: "Emperor",
    gender: "Male",
    weapon: ["Scepter"],
    nationality: "Unknown",
    affiliation: ["The Gardens"],
    age: "Unknown",
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/emperor.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Emperor",
  },
  {
    id: "263",
    name: "Erika Russell",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Liberlian",
    affiliation: ["ZCF"],
    age: "33",
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/erika.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Erika_Russell",
  },
  {
    id: "264",
    name: "Fernand Hyarms",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Four Great Houses"],
    age: "Unknown",
    predictedAgeRange: { min: 40, max: 50 },
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/fernand.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Fernand_Hyarms",
  },
  {
    id: "265",
    name: "Ferris Florald",
    gender: "Female",
    weapon: ["Bow"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Class I"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/ferris.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Ferris_Florald",
  },
  {
    id: "266",
    name: "Fiona Craig",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["N/A"],
    age: "22",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/fiona.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Fiona_Craig",
  },
  {
    id: "267",
    name: "Freddy",
    gender: "Male",
    weapon: ["Trident"],
    nationality: "Erebonian",
    affiliation: ["Thors"],
    age: "17",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/freddy.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Freddy",
  },
  {
    id: "268",
    name: "Fritz Geithner",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "Erebonian",
    affiliation: ["Thors"],
    age: "17",
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/fritz.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Fritz_Geithner",
  },
  {
    id: "269",
    name: "Hartmann",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Crossbellan",
    affiliation: ["Crossbell Government"],
    age: "58",
    debutGame: "Zero",
    imageUrl: "/images/characterSquares/hartmann.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Hartmann",
  },
  {
    id: "270",
    name: "Hugo Kleist",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Kleist & Co.", "Class III"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/hugo.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Hugo_Kleist",
  },
  {
    id: "271",
    name: "Isola Millstein",
    gender: "Female",
    weapon: ["Staff"],
    nationality: "Erebonian",
    affiliation: ["Hexen Clan"],
    age: "Unknown",
    predictedAgeRange: { min: 35, max: 45 },
    debutGame: "Reverie",
    imageUrl: "/images/characterSquares/isola.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Isola_Millstein",
  },
  {
    id: "272",
    name: "Marcel Nielsen",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Unknown",
    affiliation: ["Journalist"],
    age: "Unknown",
    predictedAgeRange: { min: 35, max: 45 },
    debutGame: "3rd",
    imageUrl: "/images/characterSquares/marcel.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Marcel_Nielsen",
  },
  {
    id: "273",
    name: "Margarita Dresden",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Thors", "Class II"],
    age: "17",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/margarita.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Margarita_Dresden",
  },
  {
    id: "274",
    name: "Misty",
    gender: "Female",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Radio Trista"],
    age: "24",
    debutGame: "CS1",
    imageUrl: "/images/characterSquares/misty.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Misty",
  },
  {
    id: "275",
    name: "Simeon",
    gender: "Male",
    weapon: ["Imagination"],
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    debutGame: "Horizon",
  },
  {
    id: "276",
    name: "Ulrika",
    gender: "Female",
    weapon: ["Words"],
    nationality: "Unknown",
    affiliation: ["Ouroboros"],
    age: "Unknown",
    debutGame: "Horizon",
  },
  {
    id: "277",
    name: "Wilhelm Ballad",
    gender: "Male",
    weapon: ["N/A"],
    nationality: "Erebonian",
    affiliation: ["Four Great Houses"],
    age: "Unknown",
    predictedAgeRange: { min: 60, max: 70 },
    debutGame: "CS3",
    imageUrl: "/images/characterSquares/wilhelm.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Wilhelm_Ballad",
  },
  {
    id: "278",
    name: "Yun Ka-Fai",
    gender: "Male",
    weapon: ["Blade"],
    nationality: "East Zemurian",
    affiliation: ["Ikaruga"],
    age: "70",
    debutGame: "Horizon",
    imageUrl: "/images/characterSquares/yun.webp",
    wikiUrl: "https://kiseki.fandom.com/wiki/Yun_Ka-Fai",
  },
];
// 130 in array as of 25.04
export const QUOTES = [
  {
    id: "1",
    quote:
      "Calvard? Sounds familiar... Is that some famous store or something?",
    quoteJp: "",
    character: "Estelle Bright",
    game: "FC",
    recipient: "Joshua Bright",
    recipientImage: "/images/characterSquares/joshua.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t0100_1&game_id=1#134",
  },
  {
    id: "2",
    quote:
      "Pain pain go away, come again some other day! Or not at all would be better, I guess.",
    quoteJp: "",
    character: "Dorothy Hyatt",
    game: "FC",
    recipient: "Estelle Bright",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r3101&game_id=1#40",
  },
  {
    id: "3",
    quote:
      "But there's nothing, NOT A THING, that can beat a girl who's dressed up all cute!",
    quoteJp: "",
    character: "Anelace Elfead",
    game: "SC",
    recipient: "Estelle Bright",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5110&game_id=2#14",
  },
  {
    id: "4",
    quote:
      "Drinking without getting drunk is, I mean what's the point of drinking at all?",
    quoteJp: "",
    character: "Scherazard Harvey",
    game: "SC",
    recipient: "Anton",
    recipientImage: "/images/characterSquares/anton.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t0133_1&game_id=2#82",
  },
  {
    id: "5",
    quote:
      "Even the Testaments of the Goddess say that 'all roads lead to food.' Food is the fundamental basis of everything.",
    quoteJp: "",
    character: "Ries Argent",
    game: "3rd",
    recipient: "Kevin Graham",
    recipientImage: "/images/characterSquares/kevin.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=u7003&game_id=3#27",
  },
  {
    id: "6",
    quote: "You couldn't look more like a nobody if you tried.",
    quoteJp: "",
    character: "Ries Argent",
    game: "3rd",
    recipient: "Gilbert Stein",
    recipientImage: "/images/characterSquares/gilbert.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t4404&game_id=3#10",
  },
  {
    id: "7",
    quote:
      "Oh, Joshua! You twist my arm but the pain only leaves me weak with pleasure.",
    quoteJp: "",
    character: "Olivier Lenheim",
    game: "3rd",
    recipient: "Joshua Astray",
    recipientImage: "/images/characterSquares/joshua.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m7408&game_id=3#204",
  },
  {
    id: "8",
    quote:
      "We've got better things to do with our time than listen to nonsensical riddles from a guy who can't even bother to show his face.",
    quoteJp: "",
    character: "Kevin Graham",
    game: "3rd",
    recipient: "Schwarzritter (Loewe)",
    recipientImage: "/images/characterSquares/loewe.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m7107&game_id=3#39",
  },
  {
    id: "9",
    quote:
      "I never thought there was a bigger dumbass in this world than me...and yet here we are.",
    quoteJp: "",
    character: "Lechter Arundel",
    game: "3rd",
    recipient: "Osborne / About Olivert",
    recipientImage: "/images/characterSquares/osborne.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e0810&game_id=3#47",
  },
  {
    id: "10",
    quote: "If fishing at a hospital is wrong, I don't want to be right.",
    quoteJp: "",
    character: "Lloyd Bannings",
    game: "Zero",
    recipient: "Himself",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1500&game_id=4#237",
  },
  {
    id: "11",
    quote:
      "No matter what things happened in the past, good or bad...they're the things that add up to make you who you are today.",
    quoteJp: "",
    character: "Estelle Bright",
    game: "Zero",
    recipient: "Renne",
    recipientImage: "/images/characterSquares/renne.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m3099&game_id=4#288",
  },
  {
    id: "12",
    quote:
      "Alas! If only my evil step-teacher would stop dumping a bunch of work on me and let me go to the ball.",
    quoteJp: "",
    character: "Rean Schwarzer",
    game: "CS1",
    recipient: "Sara Valestein",
    recipientImage: "/images/characterSquares/sara.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1000&game_id=6#1020",
  },
  {
    id: "13",
    quote:
      "It's not like I have much of a choice but to go along with your 'yay team' attitude, now, do I?!",
    quoteJp: "",
    character: "Machias Regnitz",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e5011&game_id=6#58",
  },
  {
    id: "14",
    quote:
      "Impossible. The Empire hasn't yet turned out a man desperate enough to woo that alcoholic typhoon.",
    quoteJp: "",
    character: "Jusis Albarea",
    game: "CS1",
    recipient: "Emma Millstein",
    recipientImage: "/images/characterSquares/emma.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1000&game_id=6#950",
  },
  {
    id: "15",
    quote:
      "There's no such thing as a dumb question, Regnitz, but that one came awfully close. ",
    quoteJp: "",
    character: "Neithardt",
    game: "CS1",
    recipient: "Machias Regnitz",
    recipientImage: "/images/characterSquares/machias.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t0050&game_id=6#970",
  },
  {
    id: "16",
    quote:
      "Oh aye, dae us a favor and don't try tae read the books here waeout buying them.",
    quoteJp: "",
    character: "Becky",
    game: "CS1",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=tk_becky&game_id=6#105",
  },
  {
    id: "17",
    quote:
      "That means it's finally lunchtime, but the real refreshment is this beer I smuggled in with me!",
    quoteJp: "",
    character: "Sara Valestein",
    game: "CS1",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=tk_sara&game_id=6#9",
  },
  {
    id: "18",
    quote:
      "If you don't want to die like a dog, don't run around snapping your fangs at everyone.",
    quoteJp: "",
    character: "Jusis Albarea",
    game: "CS1",
    recipient: "Class VII/About Gideon",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5660&game_id=6#95",
  },
  {
    id: "19",
    quote:
      "You're supposed to be No. I! Would it kill you to put even the tiniest bit of effort into your job?!",
    quoteJp: "",
    character: "Duvalie",
    game: "CS2",
    recipient: "McBurn",
    recipientImage: "/images/characterSquares/mcburn.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r0205&game_id=7#124",
  },
  {
    id: "20",
    quote:
      "Oh, dear, you're right. I'm turning 25 this year. Death is swiftly approaching...",
    quoteJp: "",
    character: "Sharon Kreuger",
    game: "CS3",
    recipient: "Ash Carbide",
    recipientImage: "/images/characterSquares/ash.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m3200&game_id=8#74",
  },
  {
    id: "21",
    quote:
      "Whoa there. I said we needed a 'decent' number of people, not a small army.",
    quoteJp: "",
    character: "Lechter Arundel",
    game: "CS3",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c2000&game_id=8#133",
  },
  {
    id: "22",
    quote:
      "'When it comes to love, age doesn't matter'... Heehee, what a wonderful lesson, Instructor.",
    quoteJp: "",
    character: "Musse Egret",
    game: "CS3",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=tk_musse&game_id=8#128",
  },
  {
    id: "23",
    quote:
      "I won't know if I'll like a book until I read it... Even if it's boring, I'm sure I'll still gain something out of it.",
    quoteJp: "",
    character: "Ash Carbide",
    game: "CS3",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t0240&game_id=8#255",
  },
  {
    id: "24",
    quote: "Oooh! I'm a walking EXPERT! I walk like the best of them!",
    quoteJp: "",
    character: "Lapis Rosenberg",
    game: "Reverie",
    recipient: "Nadia Rayne",
    recipientImage: "/images/characterSquares/nadia.webp",
    trailsDbUrl: "",
  },
  {
    id: "25",
    quote: "WHERE ARE MY ROYALTIES?!",
    quoteJp: "",
    character: "Nadia Rayne",
    game: "Reverie",
    recipient: "Swin Abel",
    recipientImage: "/images/characterSquares/swin.webp",
    trailsDbUrl: "",
  },
  {
    id: "26",
    quote:
      "But...that doesn't mean you always have to stand and endure everything life throws your way, okay? If it gets too much, it's all right to sit down and let it all out. Whether you're a boy or a grown man doesn't change that. It's okay...",
    quoteJp: "",
    character: "Towa Herschel",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t0080&game_id=7#124",
  },
  {
    id: "27",
    quote:
      "*sigh* I don't know what I expected. The fact you're this oblivious about it is what makes you so dangerous.",
    quoteJp: "",
    character: "Elie MacDowell",
    game: "Zero",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0410&game_id=4#610",
  },
  {
    id: "28",
    quote:
      "Even my earliest memory has me wandering lost on a battlefield, trying to find somewhere I could belong...",
    quoteJp: "いつの間にか戦場を彷徨っていたあの頃から……",
    character: "Fie Claussell",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1010&game_id=7#910",
  },
  {
    id: "29",
    quote: "Hahaha! I'm gonna murder you someday, you little shit.",
    quoteJp: "ハハハ、殺すぞクソガキ。",
    character: "Van Arkride",
    game: "Daybreak",
    recipient: "Aaron Wei",
    recipientImage: "/images/characterSquares/aaron.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0000&game_id=11#4150",
  },
  {
    id: "30",
    quote:
      "Especially, that brainless bimbo! she honestly believed that we could be friends!",
    quoteJp:
      "特に、あのノーテンキ女！ボクのことを毛ほども疑わずに『仲良くなれそう』だってさ！",
    character: "Josette Capua",
    game: "FC",
    recipient: "Capua Grunts",
    recipientImage: "/images/characterSquares/capua.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0302&game_id=1#17",
  },
  {
    id: "31",
    quote:
      "Mishelam Wonderland. I would like you to take me there once this crisis is averted.",
    quoteJp:
      "……ミシュラムのテーマパーク。この騒ぎが無事解決したらあそこに連れて行ってください。",
    character: "Tio Plato",
    game: "Zero",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c134b&game_id=4#143",
  },
  {
    id: "32",
    quote:
      "If you won't be my ally, Estelle, I'll gut you like a fish after all.",
    quoteJp: "レンの仲間にならないんだったらエステルなんか死ねばいいわ。",
    character: "Renne Bright",
    game: "SC",
    recipient: "Estelle Bright",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1705&game_id=2#45",
  },
  {
    id: "33",
    quote:
      "Give us our Crossbell back! The free city where anyone could dream!",
    quoteJp: "あたしたちのクロスベルを！あの自由で、誰もが夢を持てた街を！",
    character: "Juna Crawford",
    game: "CS3",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1080&game_id=8#254",
  },
  {
    id: "34",
    quote:
      "With my Unclouded Eye and your super sniffer, we'll be unstoppable!",
    quoteJp: '私の観の目と君の嗅覚があれば"上がり"に辿り着くのも簡単そうだ。',
    character: "Shizuna Rem Misurugi",
    game: "Daybreak",
    recipient: "Van Arkride",
    recipientImage: "/images/characterSquares/van.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m6100&game_id=11#280",
  },
  {
    id: "35",
    quote:
      "(By the flow of the wind, I'm guessing there are six or seven of them.)",
    quoteJp: "この風の流れ……６、７人といったところか。",
    character: "Gaius Worzel",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m1540&game_id=6#32",
  },
  {
    id: "36",
    quote:
      "I really don't enjoy it... but I was taught how to use a sword, if it's to protect others.",
    quoteJp:
      "本当は使いたくありませんでしたけど… 剣は、人を守るために振るうように教わりました。",
    character: "Kloe Rinz",
    game: "FC",
    recipient: "Raven Thugs",
    recipientImage: "/images/characterSquares/raventhug.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t2130&game_id=1#170",
  },
  {
    id: "37",
    quote:
      "Sorry. I really dunno what you mean... What's it even like to cry, anyway?",
    quoteJp:
      '？？？んー、何言ってんのかよく分かんないや。"泣く"ってどういうこと？',
    character: "Millium Orion",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e5210&game_id=7#22",
  },
  {
    id: "38",
    quote:
      "I DO remember seeing your funny face when you found me, though! Your eyes and mouth were wiiiiide open!",
    quoteJp:
      "ロイドが口をぽかんとあけて目をまんまるにしてたのならおぼえてるけどー。",
    character: "KeA",
    game: "Zero",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0110&game_id=4#736",
  },
  {
    id: "39",
    quote:
      "(Damned if I'm gettin' caught in the crossfire between those two. That ain't the kind of threesome I'm into.)",
    quoteJp: "（こんな化物共に付き合ってられるかっつうの。）",
    character: "Van Arkride",
    game: "Daybreak",
    recipient: "Shizuna Rem Misurugi",
    recipientImage: "/images/characterSquares/shizuna.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1200&game_id=11#1948",
  },
  {
    id: "40",
    quote:
      "...we shall simply have it --and my worthless son-- dance at the end of our strings.",
    quoteJp: "我が不肖の息子共々、せいぜい踊ってもらうとしよう。",
    character: "Giliath Osborne",
    game: "CS3",
    recipient: "Ironbloods",
    recipientImage: "/images/characterSquares/ironbloods.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c2410&game_id=8#3",
  },
  {
    id: "41",
    quote: "Interesting... You mixed, by any chance?",
    quoteJp: 'ひょっとしてお前──"混じって"やがるな？',
    character: "McBurn",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#337",
  },
  {
    id: "42",
    quote: "I'd better start upping my rizz just to be sure.",
    quoteJp: "",
    character: "Nadia Rayne",
    game: "Daybreak 2",
    recipient: "Judith Lanster",
    recipientImage: "/images/characterSquares/judith.webp",
    trailsDbUrl: "",
  },
  {
    id: "43",
    quote: "Whoa there, Little Miss War Crime. Don't go gettin' any ideas.",
    quoteJp: "おっと、イカした姉さん。妙なことはやめてくれよな？",
    character: "Ash Carbide",
    game: "CS3",
    recipient: "Shirley Orlando",
    recipientImage: "/images/characterSquares/shirley.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r1410&game_id=8#111",
  },
  {
    id: "44",
    quote: "Ma'am? This is juice.",
    quoteJp: "あ、これただのジュースだから。",
    character: "Wazy Hemisphere",
    game: "Zero",
    recipient: "Noel Seeker",
    recipientImage: "/images/characterSquares/noel.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1410&game_id=4#32",
  },
  {
    id: "45",
    quote:
      "Also, while I cannot force you to kill each other, I will cry if you don't. So for my sake, don't show any mercy.",
    quoteJp:
      "できれば殺し合いの末に奪い合って欲しいかなァ。目的も違うだろうし、他人に命を委ねたくないよね？",
    character: "Melchior",
    game: "Daybreak",
    recipient: "Arkride Solutions",
    recipientImage: "/images/characterSquares/aso.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m6110&game_id=11#28",
  },
  {
    id: "46",
    quote: "Am I in heaven? My angel Tio is here, so I must be.",
    quoteJp: "ティオちゃんがいるって事は天国か何かかしら……？",
    character: "Aeolia",
    game: "Azure",
    recipient: "Tio Plato",
    recipientImage: "/images/characterSquares/tio.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m4210&game_id=5#51",
  },
  {
    id: "47",
    quote: "Perfection is a truly fragile thing.",
    quoteJp: "",
    character: "Rufus Albarea",
    game: "Reverie",
    recipient: "Supreme Leader Rufus",
    recipientImage: "/images/characterSquares/rufus.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=a1000&game_id=10#104",
  },
  {
    id: "48",
    quote:
      "The lovey-dovey energy filling this room will soon reach dangerous levels. Further exposure is bound to induce vomiting.",
    quoteJp: '……"二人の世界"×２でオーバーフローしてる感じです。',
    character: "Altina Orion",
    game: "CS4",
    recipient: "Rean Schwarzer/Alfin Reise Arnor + Agate Crosner/Tita Russell",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m7020&game_id=9#87",
  },
  {
    id: "49",
    quote: "Get a load of this smoked ham sandwich!",
    quoteJp: "あたしのはスモークハムのサンドイッチね。",
    character: "Estelle Bright",
    game: "FC",
    recipient: "Joshua Bright",
    recipientImage: "/images/characterSquares/joshua.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t2300&game_id=1#151",
  },
  {
    id: "50",
    quote:
      "Not a hint of shame on your face after all the complete nonsense you just said. Marvelous!",
    quoteJp: "あれだけデタラメ並べといていっこうに悪びれる風もないよ。",
    character: "Olivier Lenheim",
    game: "SC",
    recipient: "Estelle Bright",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t2130_1&game_id=2#138",
  },
  {
    id: "51",
    quote:
      "Until I met everyone here, I was... very lonely. I think, in that sense, I was a little like Joshua, before he met you.",
    quoteJp:
      "私は先生たちと出会うまで孤独な日々を過ごしていました。多分、ヨシュアさんもエステルさんと出会うまでは同じだったのかもしれません。",
    character: "Kloe Rinz",
    game: "SC",
    recipient: "Estelle Bright",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t2513&game_id=2#18",
  },
  {
    id: "52",
    quote: "??? (<- Has no idea what's going on)",
    quoteJp: "？？？（←よく分かってない）",
    character: "Tita Russell",
    game: "3rd",
    recipient: "Sky 3rd Cast",
    recipientImage: "/images/characterSquares/sky3.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=u7000_3&game_id=3#198",
  },
  {
    id: "53",
    quote:
      "No man is an island; no matter how much they may wish to isolate themselves from others, no one can live their life truly alone.",
    quoteJp: "人は……どう望んだところで……真に孤独ではいられないという事を……",
    character: "Cassius Bright",
    game: "3rd",
    recipient: "Kevin Graham",
    recipientImage: "/images/characterSquares/kevin.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m3204&game_id=3#92",
  },
  {
    id: "54",
    quote: "Caught you.",
    quoteJp: "捕まえた。",
    character: "Estelle Bright",
    game: "Zero",
    recipient: "Renne Bright",
    recipientImage: "/images/characterSquares/renne.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m3099&game_id=4#296",
  },
  {
    id: "55",
    quote:
      "That city was constructed before the Great Collapse, yet was sealed away by human hands. It was a symbol of both mankind's potential...and its hubris.",
    quoteJp:
      "あれもゼムリアの時代に建造され、そして人の手で封印されたそうだ。人の可能性と愚かさの象徴として。",
    character: "Giliath Osborne",
    game: "Azure",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1550&game_id=5#464",
  },
  {
    id: "56",
    quote:
      "That's some little brother you left behind, you bastard. I guess he ain't turnin' out so bad.",
    quoteJp: "……あの野郎の弟か。なかなか良い面構えになってきたじゃねぇか。",
    character: "Garcia Rossi",
    game: "Azure",
    recipient: "Himself/Referring to Guy",
    recipientImage: "/images/characterSquares/garcia.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t6000&game_id=5#114",
  },
  {
    id: "57",
    quote: "How long do you think your precious Crossbell will last?",
    quoteJp: "君たちはこのクロスベルがどれだけ持つと考えている？",
    character: "Giliath Osborne",
    game: "Azure",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1550&game_id=5#481",
  },
  {
    id: "58",
    quote:
      "And what's up with these little comments in the margins? 'Optimal bounce vectors'? 'Show dem titties'? Are you serious?",
    quoteJp:
      "あとこの『ムチムチ強調』とか『動くと開ける』とかのコメントは削除してもらわないと。",
    character: "Rean Schwarzer",
    game: "CS1",
    recipient: "Crow Armbrust",
    recipientImage: "/images/characterSquares/crow.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t3530&game_id=6#84",
  },
  {
    id: "59",
    quote:
      "Stunning ladies in bikinis, wrestling piggyback in the pool! Come for the fights, stay for the accidental exposure!",
    quoteJp:
      "『ドキッ、女子限定、くんずほぐれつ水中騎馬戦～ポロリもあるよ～』なんてどうだ？",
    character: "Crow Armbrust",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1010&game_id=6#806",
  },
  {
    id: "60",
    quote:
      "If you eat nothing but dull, bland food all the time, well...you know what they say. 'You are what you eat.'",
    quoteJp:
      "粗食ばかりだと舌がバカになるからメリハリが大事だとは思うけどねー。",
    character: "Sara Valestein",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5520&game_id=6#141",
  },
  {
    id: "61",
    quote: "My flawless plan to have my way with Edel's body...had a flaw.",
    quoteJp: "むむ……リンデでかく乱したスキに部長のボディを堪能する計画が！",
    character: "Vivi",
    game: "CS1",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=tk_vivi&game_id=6#23",
  },
  {
    id: "62",
    quote:
      "Could you not do whatever you damn well please when we're abroad for once?",
    quoteJp:
      "まったく、お前という奴は……いつもいつも好き勝手しおって。- 少しは自分の立場というものを弁えてほしいものだが。",
    character: "Mueller Vander",
    game: "Azure",
    recipient: "Olivier Lenheim",
    recipientImage: "/images/characterSquares/olivier.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0100&game_id=5#170",
  },
  {
    id: "63",
    quote:
      "There's a part of me that hopes you'll stay my little cherub forever...",
    quoteJp: "ううむ、天使のようなエリオットにこのままでいて欲しくもあるが……",
    character: "Olaf Craig",
    game: "CS1",
    recipient: "Elliot Craig",
    recipientImage: "/images/characterSquares/elliot.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5700&game_id=6#31",
  },
  {
    id: "64",
    quote:
      "I-I mean, stop treating me like a child! ...Though yes, I would like some jam.",
    quoteJp: "だ、だから子ども扱いしないでってば！その、ジャムは頂くけど……",
    character: "Alisa Reinford",
    game: "CS1",
    recipient: "Sharon Kreuger",
    recipientImage: "/images/characterSquares/sharon.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1010&game_id=6#433",
  },
  {
    id: "65",
    quote:
      "I'm not gonna cause them any trouble! Unlike you, I'm a little angel.",
    quoteJp:
      "レクターじゃあるまいし、迷惑なんてかけないってばー。ボク、イイ子だもん。",
    character: "Millium Orion",
    game: "CS1",
    recipient: "Lechter Arundel",
    recipientImage: "/images/characterSquares/lechter.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1090&game_id=6#329",
  },
  {
    id: "66",
    quote:
      "Uncertainty weighs on the hearts ofall people, but it's far preferable to standing still.",
    quoteJp: '迷ってこそ"人"──立ち止まるより遥かにいいだろう。',
    character: "Victor S. Arseid",
    game: "CS1",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t3050&game_id=6#318",
  },
  {
    id: "67",
    quote: "Oh, oh! Do bananas count as snacks?!",
    quoteJp: "そうだ！バナナはおやつに入るのー！？",
    character: "Millium Orion",
    game: "CS1",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1010&game_id=6#733",
  },
  {
    id: "68",
    quote:
      "I had a feeling this ship was gonna be cool, but DAMN. It's got more babes on board than any ship's got a right to, too!",
    quoteJp:
      "いやー、すげえなカレイジャス！噂に聞いてた以上だぜ！Ⅶ組を中心にカワイイ女の子も結構乗っているみたいだし……",
    character: "Rex",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=tk_rex&game_id=7#37",
  },
  {
    id: "69",
    quote: "(I feel like I'm surrounded by horny teenagers all of a sudden...)",
    quoteJp: "（やっぱり鼻の下、伸びてる。）",
    character: "Fie Claussell",
    game: "CS2",
    recipient: "Class VII Boys",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5701&game_id=7#136",
  },
  {
    id: "70",
    quote: "...so keep going forward... Relentlessly, without looking back...",
    quoteJp: "だがお前は……お前らは……まっすぐ前を向いて歩いていけ………",
    character: "Crow Armbrust",
    game: "CS2",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m4560&game_id=7#331",
  },
  {
    id: "71",
    quote: "Ugggh... Why do I always have to babysit?!",
    quoteJp: "ああもう──どうしてわたくしが御守を！",
    character: "Duvalie",
    game: "CS3",
    recipient: "Shirley Orlando",
    recipientImage: "/images/characterSquares/shirley.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r0090&game_id=8#115",
  },
  {
    id: "72",
    quote: "The only suitable punishment for that is D E A T H.",
    quoteJp: "──万死に値するな。",
    character: "Rean Schwarzer",
    game: "CS3",
    recipient: "Elise Schwarzer",
    recipientImage: "/images/characterSquares/elise.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c3030&game_id=8#75",
  },
  {
    id: "73",
    quote: "Ah. I believe this is what's known as 'hitting on chicks.'",
    quoteJp: "いわゆるナンパですか。",
    character: "Altina Orion",
    game: "CS3",
    recipient: "Randy Orlando",
    recipientImage: "/images/characterSquares/randy.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=v0020&game_id=8#397",
  },
  {
    id: "74",
    quote:
      "I'll fight to make sure the weapons made by my family never need to be used for anything besides protecting people!",
    quoteJp: "ラインフォルトが手がけたものを抑止力以上にさせないためにも……！",
    character: "Alisa Reinford",
    game: "CS3",
    recipient: "Roselia",
    recipientImage: "/images/characterSquares/roselia.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m3490&game_id=8#38",
  },
  {
    id: "75",
    quote:
      "Together, we shall write the end to this wretched fairy tale. In ink, black as despair.",
    quoteJp: "世界を絶望で染め上げる、昏き終末の御伽噺を。",
    character: "Giliath Osborne",
    game: "CS3",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m4004&game_id=8#239",
  },
  {
    id: "76",
    quote:
      "Nrrgh, that's cheating! This is so unfair! I really wanted to show off how cool I can be!",
    quoteJp:
      "ズルイ、ズルイぞ！そういうのをチートと言うんじゃろ！？何よりも、妾のカッコイイ見せ場が無くなるではないか～！？",
    character: "Roselia",
    game: "CS4",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5010&game_id=9#490",
  },
  {
    id: "77",
    quote:
      "So fortunate are we that a man of his eloquence and skill walks upon this earth. *sigh*",
    quoteJp: "ホント、口八丁手八丁を地で行くような男ねぇ。",
    character: "Scherazard Harvey",
    game: "CS4",
    recipient: "Alfin Reise Arnor (About Olivert)",
    recipientImage: "/images/characterSquares/alfin.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=v3000&game_id=9#564",
  },
  {
    id: "78",
    quote:
      "Though I never had children of my own, you were all daughters to me.",
    quoteJp: "子を成さなかった人生でしたが…………貴女たちと過ごした日々はまるで……",
    character: "Arianrhod",
    game: "CS4",
    recipient: "Stahlritter",
    recipientImage: "/images/characterSquares/stahlritter.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m2660&game_id=9#198",
  },
  {
    id: "79",
    quote:
      "Technology doesn't mean anything on its own. Without human hearts to guide it, it's nothing more than steel and circuits.",
    quoteJp: "技術だけじゃ、人の心が伴わなければ何も生まれない。",
    character: "Alisa Reinford",
    game: "CS4",
    recipient: "Black Alberich",
    recipientImage: "/images/characterSquares/alberich.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m9041&game_id=9#89",
  },
  {
    id: "80",
    quote:
      "Under all of that kindness, you harbor a terrible sorrow. It's weighed you down for a very long time, I believe.",
    quoteJp:
      "シャロンさんはずっと、優しさの下に深い哀しみを抱えたんじゃないか……今もずっと、苦しみ続けてるんじゃないかって──",
    character: "Anton",
    game: "CS4",
    recipient: "Sharon Kreuger",
    recipientImage: "/images/characterSquares/sharon.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=f4200&game_id=9#749",
  },
  {
    id: "81",
    quote:
      "All right, then let us drink one final toast. To the moon, and to Mishy!",
    quoteJp: "最後に一杯だけ、月とみっしぃに乾杯するとしようか？",
    character: "Olivier Lenheim",
    game: "CS4",
    recipient: "Mueller Vander",
    recipientImage: "/images/characterSquares/mueller.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=tk_common&game_id=9#2771",
  },
  {
    id: "82",
    quote:
      "The donut cushion has proven to be a fine gift indeed. Not only am I able to gaze upon one of the most delectable foods in the world, any time I wish...but I'm also embraced by the perfect plushness when I hug or sit on it. I quite love it!",
    quoteJp:
      "ドーナツの形をしたクッション……これはなかなかに優れた品じゃの。妾の大好物であるドーナツをずっと見ていられる上──抱き心地も座り心地も良いと来た。大層気に入ったぞ！",
    character: "Roselia",
    game: "CS4",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=system3&game_id=9#223",
  },
  {
    id: "83",
    quote:
      "I am but a shadow. I exist solely to announce the appointed time to the world.",
    quoteJp: '私は"影"──世界に刻限を告げるだけの存在です。',
    character: "Grandmaster",
    game: "CS4",
    recipient: "Ouroboros",
    recipientImage: "/images/characterSquares/ouroboros.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=f6000&game_id=9#25",
  },
  {
    id: "84",
    quote: "Hoo-wee... The dynamic duo's gettin' bigger and bigger by the day.",
    quoteJp: "やれやれ、お嬢、また育ったんじゃねえか？",
    character: "Randy Orlando",
    game: "CS4",
    recipient: "Elie MacDowell",
    recipientImage: "/images/characterSquares/elie.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m7400&game_id=9#97",
  },
  {
    id: "85",
    quote:
      "*sigh* Yes, yes, I throw myself on my blades in regret, on the hour, every hour.",
    quoteJp: "……はいはい、反省してます。",
    character: "Joshua Bright",
    game: "SC",
    recipient: "Estelle & Kloe",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e0301&game_id=2#97",
  },
  {
    id: "86",
    quote: "Ha ha ha... Ever a jester!",
    quoteJp: "はっはっは、ご冗談を。",
    character: "Olivier Lenheim",
    game: "FC",
    recipient: "Mueller",
    recipientImage: "/images/characterSquares/mueller.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t4112&game_id=1#25",
  },
  {
    id: "87",
    quote:
      "That storm you were talking about is going to be worse than expected. A lot worse.",
    quoteJp: "どうやら予想以上に 激しい嵐が近づいているようだ。",
    character: "Mueller Vander",
    game: "FC",
    recipient: "Olivier",
    recipientImage: "/images/characterSquares/olivier.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t4112&game_id=1#24",
  },
  {
    id: "88",
    quote: "I'm nothing but a unrefined former jaeger in a soldier's uniform.",
    quoteJp: "軍人とは名ばかりの 猟兵あがりの無骨者にすぎません。",
    character: "Loewe",
    game: "FC",
    recipient: "Alan Richard",
    recipientImage: "/images/characterSquares/richard.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t4112&game_id=1#24",
  },
  {
    id: "89",
    quote:
      "The ringleaders of the hawks were nothing more than political losers who had nowhere else to go.",
    quoteJp:
      "実際、主戦派の首謀者たちは 当時あったという政争に敗れて 後がない者たちばかりだったと聞く。",
    character: "Loewe",
    game: "SC",
    recipient: "Georg Weissmann",
    recipientImage: "/images/characterSquares/weissmann.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c5317&game_id=2#328",
  },
  {
    id: "90",
    quote:
      "Of course, really, all I did was introduce them to a band of jaeger dropouts I knew and put the name 'Hamel' in their ears.",
    quoteJp:
      "もっとも私がやった事は、 彼らに猟兵くずれを紹介して ハーメルの名を囁いただけさ。",
    character: "Georg Weissmann",
    game: "SC",
    recipient: "Liberl Crew + Loewe",
    recipientImage: "/images/characterSquares/liberlcrew.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c5317&game_id=2#331",
  },
  {
    id: "91",
    quote:
      "In that case, why didn't they tie us up or, I dunno, stab us or something? They just left us in the open...",
    quoteJp:
      "それだと、私たちを拘束しないで 放置した理由が分からないんだよね。",
    character: "Anelace Elfead",
    game: "SC",
    recipient: "Estelle Bright",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c5504&game_id=2#26",
  },
  {
    id: "92",
    quote: "Try again, girlies! We smashed your phone",
    quoteJp: "フン…… 宿舎の通信器は完全に破壊した。",
    character: "Grant",
    game: "SC",
    recipient: "Estelle Bright & Anelace Elfead",
    recipientImage: "/images/characterSquares/estelle.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c5511&game_id=2#15",
  },
  {
    id: "93",
    quote:
      "Awww, you heard about that already? There goes half my fun. But oh, yes, the man was incredible.",
    quoteJp:
      "なあんだ、知ってたのか。 いや～、あのオジサン、 ホントとんでもない人だよね。",
    character: "Campanella",
    game: "SC",
    recipient: "Loewe (about Cassius)",
    recipientImage: "/images/characterSquares/loewe.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c5600&game_id=2#8",
  },
  {
    id: "94",
    quote: "Elementary, my dear jaegers.",
    quoteJp: "フッ、答えは簡単……",
    character: "Estelle Bright",
    game: "SC",
    recipient: "Enhanced Jaeger",
    recipientImage: "/images/characterSquares/enhancedjaeger.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t2510&game_id=2#519",
  },
  {
    id: "95",
    quote:
      "Heh. Ah, moments like these are the best part of being a hero. If only there were more people here to marvel at just how cool I am this very moment!",
    quoteJp:
      "フッ……これぞヒーローの醍醐味…… ああっ！僕ってばなんて格好イイッ！",
    character: "Gilbert Stein",
    game: "3rd",
    recipient: "Himself",
    recipientImage: "/images/characterSquares/gilbert.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=p0800&game_id=3#7",
  },
  {
    id: "96",
    quote:
      "Hah. An honest jaeger like myself would never stoop to such a poor strategy.",
    quoteJp: "ハッ、まともな猟兵団なら そんな作戦は絶対に立てねぇな。",
    character: "Garcia Rossi",
    game: "Zero",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0500&game_id=4#299",
  },
  {
    id: "97",
    quote: "Now, which of my regulars is going to take the bait?",
    quoteJp: "さーて、どのくらい お得意様が喰い付くかな～。",
    character: "Jona Sacred",
    game: "Zero",
    recipient: "LLoyd & Tio",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m0101&game_id=4#39",
  },
  {
    id: "98",
    quote:
      "Y'know, Mama's got some history with this one jaeger guy I've seen in here before.",
    quoteJp: "ママは猟兵とも付き合いあんだー。",
    character: "Jingo",
    game: "Zero",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1440&game_id=4#291",
  },
  {
    id: "99",
    quote:
      "Not uncommon to have a beer today with the same guy you were tryin' to kill yesterday.",
    quoteJp: "昨日の敵は今日の味方…… その逆も日常茶飯事にありえる。",
    character: "Randy Orlando",
    game: "Azure",
    recipient: "Alex Dudley",
    recipientImage: "/images/characterSquares/alex.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1150&game_id=5#681",
  },
  {
    id: "100",
    quote: "Hmph... If you ask me, you're the colonel's ass!",
    quoteJp: "フン、てめえら そんな大層な肩書だったのかよ。",
    character: "Agate",
    game: "FC",
    recipient: "Special Ops Soldier",
    recipientImage: "/images/characterSquares/sepcial_ops_soldier.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c3107&game_id=1#25",
  },
  {
    id: "101",
    quote:
      "Am I to understand the Imperial government hired jaegers on foreign soil for the purpose of carrying out a mass execution?!",
    quoteJp: "帝国政府が処刑などの名目で 国外で猟兵団を運用しただと！？",
    character: "Olivier Lenheim",
    game: "Azure",
    recipient: "Giliath Osborne",
    recipientImage: "/images/characterSquares/osborne.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c1540&game_id=5#406",
  },
  {
    id: "102",
    quote:
      "You're a frivolous nightlife dweller with a hair-trigger temper. But hotheaded as you may be, you stay cool when it matters most.",
    quoteJp:
      "お調子者で、夜遊びが好きで 少し好戦的で熱くなりがちだけど ちゃんと引き際もわきまえてる……",
    character: "Lloyd Bannings",
    game: "Azure",
    recipient: "Randy Orlando",
    recipientImage: "/images/characterSquares/randy.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e0510&game_id=5#102",
  },
  {
    id: "103",
    quote:
      "This time, the hunters will learn what it is like to be prey. I swear it on my pride as ****",
    quoteJp: "神狼としての誇りを掛けて、 存分に敵を翻弄させてもらうとしよう。",
    character: "Zeit",
    game: "Azure",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e3020_1&game_id=5#220",
  },
  {
    id: "104",
    quote:
      "The way I refuse escort and protection must make me as fun as fishing in a barrel to them.",
    quoteJp:
      "護衛もあまり連れていない ボクみたいな相手は標的として 物足りないんじゃないかな？",
    character: "Olivier Lenheim",
    game: "Azure",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e3210&game_id=5#150",
  },
  {
    id: "105",
    quote:
      "And to commemorate the occasion, I think this calls for hitting up Crossbell's famous nightlife.",
    quoteJp:
      "しかしそういう事なら お礼に夜のクロスベルの名所でも 案内してもらおうかな？",
    character: "Olivier Lenheim",
    game: "Azure",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e3210&game_id=5#158",
  },
  {
    id: "106",
    quote: "Not on your life, you simpleton.",
    quoteJp: "──させるか、阿呆。",
    character: "Mueller Vander",
    game: "Azure",
    recipient: "Olivier Lenheim",
    recipientImage: "/images/characterSquares/olivier.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e3210&game_id=5#162",
  },
  {
    id: "107",
    quote:
      "Yeah, warn a guy next time you wanna sic a pile of claws and feathers at him.",
    quoteJp: "さすがにアレは 何かと思ったからなぁ。",
    character: "Randy Orlando",
    game: "Azure",
    recipient: "Kloe Rinz",
    recipientImage: "/images/characterSquares/kloe.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e3210&game_id=5#169",
  },
  {
    id: "108",
    quote:
      "Our place in history goes back some time, as it turns out. All the way to the Dark Ages, even.",
    quoteJp: "まあ、歴史だけで言うなら 中世の暗黒時代に遡るからなぁ。",
    character: "Randy Orlando",
    game: "Azure",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e440b&game_id=5#163",
  },
  {
    id: "109",
    quote:
      "...but now that they've offed each other, that leaves me as the strongest one standing.",
    quoteJp: "その２人が相討ちになった後では、俺が最強と言えるかもしれん。",
    character: "Sigmund Orlando",
    game: "Azure",
    recipient: "SSS",
    recipientImage: "/images/characterSquares/sss.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m9072&game_id=5#19",
  },
  {
    id: "110",
    quote:
      "You're not a jaeger. Not a soldier. You've never spilled anyone's blood...",
    quoteJp: "軍人でも猟兵でもない、 殺し合いのプロでもない お前らが……",
    character: "Randy Orlando",
    game: "Azure",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r2060&game_id=5#145",
  },
  {
    id: "111",
    quote:
      "This is the man you see standing in front of you... An irredeemable piece of shit!",
    quoteJp: "お前らの目の前にいるのは そんな救いようのねぇクソ野郎だッ！",
    character: "Randy Orlando",
    game: "Azure",
    recipient: "Lloyd Bannings",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r2060&game_id=5#156",
  },
  {
    id: "112",
    quote: "I hear his little girl is a chip off the old block, too.",
    quoteJp: "噂じゃ娘の方も 相当ヤバイと聞いているが。",
    character: "Garcia Rossi",
    game: "Azure",
    recipient: "Lloyd Bannings (about Shirley)",
    recipientImage: "/images/characterSquares/lloyd.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t6051&game_id=5#69",
  },
  {
    id: "113",
    quote:
      "If one defines knighthood as the way of the virtuous, how can the path of the jaeger be seen as anything but corrupt?",
    quoteJp: "騎士を“正道”とするならば、猟兵は言わば“邪道”……",
    character: "Laura S. Arseid",
    game: "CS1",
    recipient: "Fie Claussell",
    recipientImage: "/images/characterSquares/fie.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=c0700&game_id=6#219",
  },
  {
    id: "114",
    quote: "Are you a survivor of the Arngarmr jaeger corps?",
    quoteJp: "猟兵団《アルンガルム》…… その生き残りだったりしない？",
    character: "Fie Claussell",
    game: "CS1",
    recipient: "Vulcan",
    recipientImage: "/images/characterSquares/vulcan.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=m1260&game_id=6#13",
  },
  {
    id: "115",
    quote: "Let's go catch us some big bad wannabe-jaegers!",
    quoteJp: "それじゃあ武装集団を 捕らえるためにレッツ・ゴー！",
    character: "Millium Orion",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=r0800&game_id=6#387",
  },
  {
    id: "116",
    quote: "And what of the barbarian and your jaeger-tot?",
    quoteJp: "おまけに蛮族や 猟兵上がりの小娘まで 混じっているとは……！",
    character: "Patrick T. Hyarms",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t0000b&game_id=6#290",
  },
  {
    id: "117",
    quote:
      "Hmm... The way you tell it, you sound like one big family, in a sense.",
    quoteJp: "ああ……どこか“家族”を 感じさせるというか。",
    character: "Rean Schwarzer",
    game: "CS1",
    recipient: "Fie Claussell",
    recipientImage: "/images/characterSquares/fie.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t1000&game_id=6#1312",
  },
  {
    id: "118",
    quote:
      "Apparently, he was killed by a real top-rate jaeger corps hired by your friend the Blood and Iron Chancellor.",
    quoteJp: "《鉄血》に雇われていた 凄腕の猟兵団にやられたそうよ。",
    character: "Scarlet",
    game: "CS1",
    recipient: "Class VII",
    recipientImage: "/images/characterSquares/class7.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t5660&game_id=6#91",
  },
  {
    id: "119",
    quote:
      "We're gonna do a thousand arm swings a day and a million push ups! And we're gonna be so buff, you won't even know what hit you!",
    quoteJp: "こうなったら毎日、素振り千回とか 地獄のトックンをするしか！",
    character: "Millium Orion",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7050&game_id=7#418",
  },
  {
    id: "120",
    quote:
      "Maybe joining the Gardening Club'll make her a bit more ladylike, too...",
    quoteJp: "園芸部なんかにも入って 少しはお淑やかにも──",
    character: "Xeno",
    game: "CS2",
    recipient: "Rean Schwarzer (about Fie)",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7050&game_id=7#418",
  },
  {
    id: "121",
    quote:
      "Hamburgers, fries, and onion rings, huh? I was expecting something more fancy like I had last night.",
    quoteJp:
      "ハンバーガーにフライドポテト、オニオンリング……てっきり、昨日の夜みたいな 宮廷風の料理かと思ったよ。",
    character: "Rean Schwarzer",
    game: "CS2",
    recipient: "Crow Armbrust",
    recipientImage: "/images/characterSquares/crow.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#63",
  },
  {
    id: "122",
    quote:
      "Heh. Indeed. There are few even among royals whose palate is so refined as his.",
    quoteJp:
      "フッ、皇族でありながら あそこまで洒落の判る人間は そうそういるものではないだろう。",
    character: "Bleublanc",
    game: "CS2",
    recipient: "Rean Schwarzer (about Olivier)",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#173",
  },
  {
    id: "123",
    quote:
      "That magnificent floating city was quite the sight to behold, let me tell you. Oh, how I wish I could have shown it to you!",
    quoteJp: "フフ、あの壮麗な空中都市は 君にも見せてやりたかった。",
    character: "Bleublanc",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#175",
  },
  {
    id: "124",
    quote:
      "Have you no shame? Is it perhaps normal for you to barge into a lady's room unannounced?",
    quoteJp: "くっ、まさか気配を断って この部屋に忍び込むとは……",
    character: "Duvalie",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#202",
  },
  {
    id: "125",
    quote: "And, oh, she's simply DIVINE!",
    quoteJp: "超絶、素晴らしい方ですわっ！",
    character: "Duvalie",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#212",
  },
  {
    id: "126",
    quote:
      "I'll th-thank you not to spout such nauseating drivel in my presence!",
    quoteJp: "って、何をしれっと 歯の浮くようなことを……！",
    character: "Duvalie",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#231",
  },
  {
    id: "127",
    quote:
      "So you claim to have no inappropriate motives for sneaking into this room?",
    quoteJp: "──それでは不埒な目的で 部屋に入ったわけではないと？",
    character: "Altina Orion",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#260",
  },
  {
    id: "128",
    quote:
      "I trust this is simply me being paranoid...but you haven't tried making any moves on her, have you?",
    quoteJp: "……まさかとは思うが。 手を出すような真似はしていないだろうな……？",
    character: "Leonidas",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#313",
  },
  {
    id: "129",
    quote: "...All of me.",
    quoteJp: "──ぜ・ん・ぶ・だ・。",
    character: "McBurn",
    game: "CS2",
    recipient: "Rean Schwarzer",
    recipientImage: "/images/characterSquares/rean.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=e7110&game_id=7#363",
  },
  {
    id: "130",
    quote:
      "Can you at least let me finish before you wind up passed out on the floor?",
    quoteJp: "ってマイペースに 飲まないで下さい。",
    character: "Rean Schwarzer",
    game: "CS2",
    recipient: "Sara Valestein",
    recipientImage: "/images/characterSquares/sara.webp",
    trailsDbUrl:
      "https://trailsinthedatabase.com/game-scripts?fname=t4030&game_id=7#207",
  },
];
// 129 in array as of 24.04
export const MUSIC = [
  {
    id: "1",
    title: "Silver Will",
    displayTitle: "Silver Will - Trails in the Sky FC",
    game: "FC",
    type: "Battle / Event Theme",
    audioUrl: "/music/silver_will.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=d-7zjsM5nQA",
    spotifyUrl:
      "https://open.spotify.com/track/4OfOIkSJ8cNyP2lj2McStC?si=b617da4659b14dab",
  },

  {
    id: "2",
    title: "Spiral of Erebos",
    displayTitle: "Spiral of Erebos - Trails of Cold Steel 3",
    game: "CS3",
    type: "Dungeon Theme",
    audioUrl: "/music/spiral_of_erebos.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/wHvnwxAg5ww",
    spotifyUrl:
      "https://open.spotify.com/track/4wd6sTqMVfoRRR45zvJUp3?si=b81f4ff40bb64de8",
  },
  {
    id: "3",
    title: "Afterschool Hours",
    displayTitle: "Afterschool Hours - Trails of Cold Steel 1",
    game: "CS1",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/afterschool_hours.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/qVP_nCK0tXU",
    spotifyUrl:
      "https://open.spotify.com/track/5jgr5ODrF1vGaDymzRaeqN?si=abd6a1d80ee243bf",
  },
  {
    id: "4",
    title: "Blade Game",
    displayTitle: "Blade Game - Trails of Cold Steel 1",
    game: "CS1",
    type: "Minigame Theme",
    audioUrl: "/music/blade_game.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/56Mn2mvlyNQ",
    spotifyUrl:
      "https://open.spotify.com/track/5EfH3lM6Gq7NMeYpRmatFI?si=6fed56fa11484bf2",
  },
  {
    id: "5",
    title: "The Glint of Cold Steel",
    displayTitle: "The Glint of Cold Steel - Trails of Cold Steel 1",
    game: "CS1",
    type: "Battle Theme",
    audioUrl: "/music/the_glint_of_cold_steel.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/R1tI_idiwnQ",
    spotifyUrl:
      "https://open.spotify.com/track/7oTmmIF2zwxSUwzprPYvHw?si=9115f065b61d4594",
  },
  {
    id: "6",
    title: "A Cat Relaxing in the Sun",
    displayTitle: "A Cat Relaxing in the Sun - Trails in the Sky FC",
    game: "FC",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/a_cat_relaxing_in_the_sun.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://youtu.be/G01LEdKV9VU",
    spotifyUrl:
      "https://open.spotify.com/track/4B7OypxHvqBg2DDtGZKByC?si=711e8bb9a87d4d34",
  },
  {
    id: "7",
    title: "Factory City of Zeiss",
    displayTitle: "Factory City of Zeiss - Trails in the Sky FC",
    game: "FC",
    type: "City Theme",
    audioUrl: "/music/factory_city_of_zeiss.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://youtu.be/k9kvtsdIZTQ",
    spotifyUrl:
      "https://open.spotify.com/track/3q2Tmr3WtQ4umjtHYfWMSh?si=26edbedf47354244",
  },
  {
    id: "8",
    title: "Sophisticated Fight",
    displayTitle: "Sophisticated Fight - Trails in the Sky FC",
    game: "FC",
    type: "Battle Theme",
    audioUrl: "/music/sophisticated_fight.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://youtu.be/Um5EbReY7rA",
    spotifyUrl:
      "https://open.spotify.com/track/0FVqFeyED5diKE3GSSWErU?si=7f61c750ab68479b",
  },
  {
    id: "9",
    title: "Floating City Liber Ark",
    displayTitle: "Floating City Liber Ark - Trails in the Sky SC",
    game: "SC",
    type: "Dungeon Theme",
    audioUrl: "/music/floating_city_liber_ark.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/sta_Lb5sx64",
    spotifyUrl:
      "https://open.spotify.com/track/1Joi0EFJ2tm87okqN99RRS?si=baeaf01b5a644a50",
  },
  {
    id: "10",
    title: "Infiltration",
    displayTitle: "Infiltration - Trails in the Sky SC",
    game: "SC",
    type: "Event / Story Theme",
    audioUrl: "/music/infiltration.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/JqOto9_2G84",
    spotifyUrl:
      "https://open.spotify.com/track/2arHLlSdb4ZlzKecDxXOgP?si=11d77e750f4c4ea9",
  },
  {
    id: "11",
    title: "Obstructive Existence",
    displayTitle: "Obstructive Existence - Trails in the Sky SC",
    game: "SC",
    type: "Battle Theme",
    audioUrl: "/music/obstructive_existence.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/pHo86x7jLWM",
    spotifyUrl:
      "https://open.spotify.com/track/0jpmaUzIbT3Q0goeMVgaUZ?si=52bdaf366fe04b48",
  },
  {
    id: "12",
    title: "Strepitoso Fight",
    displayTitle: "Strepitoso Fight - Trails in the Sky SC",
    game: "SC",
    type: "Battle Theme",
    audioUrl: "/music/strepitoso_fight.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/onogsnnLe2o",
    spotifyUrl:
      "https://open.spotify.com/track/1St4yQN3UlpuS1J8tNFSHb?si=d847ae1afc9e462a",
  },
  {
    id: "13",
    title: "The Dream Continues",
    displayTitle: "The Dream Continues - Trails in the Sky SC",
    game: "SC",
    type: "Event / Story Theme",
    audioUrl: "/music/the_dream_continues.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/YHCLsd0wsMU",
    spotifyUrl:
      "https://open.spotify.com/track/44142B3gjhrmFCvkR7IRDP?si=2f94ca7e97634df3",
  },
  {
    id: "14",
    title: "The Fate of the Fairies",
    displayTitle: "The Fate of the Fairies - Trails in the Sky SC",
    game: "SC",
    type: "Battle Theme",
    audioUrl: "/music/the_fate_of_the_fairies.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/3GB-xej4GFc",
    spotifyUrl:
      "https://open.spotify.com/track/0lvQsLTvpliFqq4FinLbcE?si=ab66050494664b2b",
  },
  {
    id: "15",
    title: "Cradle Where Feelings Rest",
    displayTitle: "Cradle Where Feelings Rest - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Event / Story Theme",
    audioUrl: "/music/cradle_where_feelings_rest.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://youtu.be/ydu3N3EZl5A",
    spotifyUrl:
      "https://open.spotify.com/track/17kMeO0LEiuoxfzeZEC6o3?si=bd240320fa74464e",
  },
  {
    id: "16",
    title: "Determination of Fight",
    displayTitle: "Determination of Fight - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Battle Theme",
    audioUrl: "/music/determination_of_fight.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://youtu.be/c_WfQ_JsDq8",
    spotifyUrl:
      "https://open.spotify.com/track/5iRJBtBjL0ZCZr4odwvTxx?si=b4bea4457d1c4698",
  },
  {
    id: "17",
    title: "Fighting Right On",
    displayTitle: "Fighting Right On - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Battle Theme",
    audioUrl: "/music/fighting_right_on.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://youtu.be/3c63Szu2SOg",
    spotifyUrl:
      "https://open.spotify.com/track/7lRXHcDzUfHLcicxlIGrYp?si=5fb498cc858b4497",
  },
  {
    id: "18",
    title: "Looking Up at the Sky (Ending Version)",
    displayTitle:
      "Looking Up at the Sky (Ending Version) - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Title / Ending Theme",
    audioUrl: "/music/looking_up_at_the_sky_ending_version.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://youtu.be/D3TqH9ileB8",
    spotifyUrl:
      "https://open.spotify.com/track/6pJqV1UvNHBlLtDNzVjG71?si=48f10a171e264063",
  },
  {
    id: "19",
    title: "Overdosing Heavenly Bliss",
    displayTitle: "Overdosing Heavenly Bliss - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Battle Theme",
    audioUrl: "/music/overdosing_heavenly_bliss.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://youtu.be/BUFqkmB5SSA",
    spotifyUrl:
      "https://open.spotify.com/track/792JyxJSmezN5p5uPmhHuP?si=97b486383d5e4577",
  },
  {
    id: "20",
    title: "Get Over the Barrier!",
    displayTitle: "Get Over the Barrier! - Trails from Zero",
    game: "Zero",
    type: "Battle Theme",
    audioUrl: "/music/get_over_the_barrier.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/-azjB3lsUTU",
    spotifyUrl:
      "https://open.spotify.com/track/2NeyefdT6dbqk0lvrzOdU9?si=e17e0fffc5724745",
  },
  {
    id: "21",
    title: "Inevitable Struggle",
    displayTitle: "Inevitable Struggle - Trails from Zero",
    game: "Zero",
    type: "Battle Theme",
    audioUrl: "/music/inevitable_struggle.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/6XUzvISRwUQ",
    spotifyUrl:
      "https://open.spotify.com/track/4AK711MZVAH85CFLL6XkaV?si=d33ade28e2b44887",
  },
  {
    id: "22",
    title: "Setting Off",
    displayTitle: "Setting Off - Trails in the Sky FC",
    game: "FC",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/setting_off.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://youtu.be/F7Lh7RlJVC0",
    spotifyUrl:
      "https://open.spotify.com/track/7sQZDJI9fSG6q9GvQPJs73?si=6b00d7551e354f5f",
  },
  {
    id: "23",
    title: "C.S.P.D. −Crossbell State Police Department−",
    displayTitle:
      "C.S.P.D. −Crossbell State Police Department− - Trails from Zero",
    game: "Zero",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/cspd_crossbell_state_police_department.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/ULzCJfEuXfU",
    spotifyUrl:
      "https://open.spotify.com/track/6cI0PxRYvKYPDCVjG5cbnP?si=97b4a737d938499b",
  },
  {
    id: "24",
    title: "St. Ursula Medical College",
    displayTitle: "St. Ursula Medical College - Trails from Zero",
    game: "Zero",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/st_ursula_medical_college.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/GfFLf_PcJYI",
    spotifyUrl:
      "https://open.spotify.com/track/3DdknDQF82h9pjA8hn60hr?si=7ed7739277cc49da",
  },
  {
    id: "25",
    title: "Arc-en-ciel",
    displayTitle: "Arc-en-ciel - Trails from Zero",
    game: "Zero",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/arc_en_ciel.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/0To8SJiRUKw",
    spotifyUrl:
      "https://open.spotify.com/track/0oSwmf32bUjm5bOTTDH9H6?si=b0b71b1abe36446d",
  },
  {
    id: "26",
    title: "Balloons and Confetti",
    displayTitle: "Balloons and Confetti - Trails from Zero",
    game: "Zero",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/balloons_and_confetti.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/D4OCglD2ZM0",
    spotifyUrl:
      "https://open.spotify.com/track/73SmWewa4sQlT2WFQez7ff?si=e470aceb357442e3",
  },
  {
    id: "27",
    title: "Intense Chase",
    displayTitle: "Intense Chase - Trails from Zero",
    game: "Zero",
    type: "Battle Theme",
    audioUrl: "/music/intense_chase.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/-OciAAIlivA",
    spotifyUrl:
      "https://open.spotify.com/track/3Z4pMlU3OyLjTQempbxwc3?si=53d949e174024fc7",
  },
  {
    id: "28",
    title: "Seize The Truth!",
    displayTitle: "Seize The Truth! - Trails to Azure",
    game: "Azure",
    type: "Battle Theme",
    audioUrl: "/music/seize_the_truth.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://youtu.be/s358AQzHMCU",
    spotifyUrl:
      "https://open.spotify.com/track/5GehxxI7RAaNIH9niRu6KH?si=e69566d695af4642",
  },
  {
    id: "29",
    title: "West Zemuria Trade Conference",
    displayTitle: "West Zemuria Trade Conference - Trails to Azure",
    game: "Azure",
    type: "Event / Story Theme",
    audioUrl: "/music/west_zemuria_trade_conference.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://youtu.be/FNiwtXSLwxg",
    spotifyUrl:
      "https://open.spotify.com/track/0IhoBzndkBKj7LFQpS9A97?si=b5530fcc100f4f9e",
  },
  {
    id: "30",
    title: "Demon's Yell",
    displayTitle: "Demon's Yell - Trails to Azure",
    game: "Azure",
    type: "Battle Theme",
    audioUrl: "/music/demons_yell.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://youtu.be/_2mgIDNqnZY",
    spotifyUrl:
      "https://open.spotify.com/track/7J4L2fMF1IIxxQoCNOUGRL?si=e0fe1dbf4f4941f8",
  },
  {
    id: "31",
    title: "Miss You",
    displayTitle: "Miss You - Trails to Azure",
    game: "Azure",
    type: "Event / Story Theme",
    audioUrl: "/music/miss_you.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://youtu.be/UKYjqbt0E70",
    spotifyUrl:
      "https://open.spotify.com/track/0yxxf3S2If5TFWc7X11jdk?si=8ba6854662d64de7",
  },
  {
    id: "32",
    title: "The Azure Arbitrator",
    displayTitle: "The Azure Arbitrator - Trails to Azure",
    game: "Azure",
    type: "Battle Theme",
    audioUrl: "/music/the_azure_arbitrator.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://youtu.be/h8CmfRgxvVQ",
    spotifyUrl:
      "https://open.spotify.com/track/4ExMCPkIwNPv6Z3w88O6Cm?si=e7264b1aac3440c7",
  },
  {
    id: "33",
    title: "Suburban Town of Trista",
    displayTitle: "Suburban Town of Trista - Trails of Cold Steel 1",
    game: "CS1",
    type: "City Theme",
    audioUrl: "/music/suburban_town_of_trista.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/Iw2bBCbYTXw",
    spotifyUrl:
      "https://open.spotify.com/track/3ecjKfGgq3XbceJvOIoKNZ?si=e1c24a5e99244866",
  },
  {
    id: "34",
    title: "Refreshing Morning",
    displayTitle: "Refreshing Morning - Trails of Cold Steel 1",
    game: "CS1",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/refreshing_morning.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/LPGzldL1uJE",
    spotifyUrl:
      "https://open.spotify.com/track/3fbtq1pKqr8ZLdexp7L0Ct?si=bc8aeb14135b46a5",
  },
  {
    id: "35",
    title: "Tie a Link of ARCUS!",
    displayTitle: "Tie a Link of ARCUS! - Trails of Cold Steel 1",
    game: "CS1",
    type: "Battle Theme",
    audioUrl: "/music/tie_a_link_of_arcus.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/Qnpg9Zc3_iE",
    spotifyUrl:
      "https://open.spotify.com/track/6gawZssAokKFDmK0iA3sCQ?si=a31d3080248446d2",
  },
  {
    id: "36",
    title: "Wintry Arrival",
    displayTitle: "Wintry Arrival - Trails of Cold Steel 2",
    game: "CS2",
    type: "City Theme",
    audioUrl: "/music/wintry_arrival.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://youtu.be/pjqhd33ZblE",
    spotifyUrl:
      "https://open.spotify.com/track/3j2usBLt0LvWEy73Q8KgN8?si=226398dc305e48a3",
  },
  {
    id: "37",
    title: "Heated Mind",
    displayTitle: "Heated Mind - Trails of Cold Steel 2",
    game: "CS2",
    type: "Battle Theme",
    audioUrl: "/music/heated_mind.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://youtu.be/q8QM6kSR9-Q",
    spotifyUrl:
      "https://open.spotify.com/track/42C2HMiRawZsj0AnFodIaL?si=78bec985c6a24359",
  },
  {
    id: "38",
    title: "Altina",
    displayTitle: "Altina - Trails of Cold Steel 2",
    game: "CS2",
    type: "Event / Story Theme",
    audioUrl: "/music/altina.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://youtu.be/TOMIAhcXtXc",
    spotifyUrl:
      "https://open.spotify.com/track/0DW6i0UcxPYLOf1n0zM3Ci?si=445c72238d764969",
  },
  {
    id: "39",
    title: "Blue Destination",
    displayTitle: "Blue Destination - Trails of Cold Steel 2",
    game: "CS2",
    type: "Event / Story Theme",
    audioUrl: "/music/blue_destination.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://youtu.be/Goj8hyy_L0M",
    spotifyUrl:
      "https://open.spotify.com/track/6W7yaY86BbTWjlnIBOSxNt?si=ab4fa3ab22da4a75",
  },
  {
    id: "40",
    title: "Courageous Launch!",
    displayTitle: "Courageous Launch! - Trails of Cold Steel 2",
    game: "CS2",
    type: "Event / Story Theme",
    audioUrl: "/music/courageous_launch.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://youtu.be/KGBm6F9TNAw",
    spotifyUrl:
      "https://open.spotify.com/track/5kmMDWSQm3LpS1IiXv3ZRX?si=a212500893a049e8",
  },
  {
    id: "41",
    title: "A New Morning",
    displayTitle: "A New Morning - Trails of Cold Steel 3",
    game: "CS3",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/a_new_morning.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/VnTuqfczoLU",
    spotifyUrl:
      "https://open.spotify.com/track/5kzFh4DY77m3LnJya1BE49?si=29e2dbaef1bd4aa2",
  },
  {
    id: "42",
    title: "Step Ahead",
    displayTitle: "Step Ahead - Trails of Cold Steel 3",
    game: "CS3",
    type: "Battle Theme",
    audioUrl: "/music/step_ahead.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/l8wbS0nDHzo",
    spotifyUrl:
      "https://open.spotify.com/track/59Pq7CkZszEGWMHp8nmJmY?si=b7d54ac083a74021",
  },
  {
    id: "43",
    title: "Parm, the Spinning Town",
    displayTitle: "Parm, the Spinning Town - Trails of Cold Steel 3",
    game: "CS3",
    type: "City Theme",
    audioUrl: "/music/parm_the_spinning_town.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/daXY1PE98So",
    spotifyUrl:
      "https://open.spotify.com/track/2GfDK36D3NJRbXSR3g1OGO?si=87cd2f69aee94bac",
  },
  {
    id: "44",
    title: "Brave Steel",
    displayTitle: "Brave Steel - Trails of Cold Steel 3",
    game: "CS3",
    type: "Battle Theme",
    audioUrl: "/music/brave_steel.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/zciFSXZdxfk",
    spotifyUrl:
      "https://open.spotify.com/track/4EQScmStHppzx2F76MQtfY?si=9e409f0147324dca",
  },
  {
    id: "45",
    title: "Sword of Biting Gale",
    displayTitle: "Sword of Biting Gale - Trails of Cold Steel 3",
    game: "CS3",
    type: "Battle Theme",
    audioUrl: "/music/sword_of_biting_gale.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/_r_tEhzh5X0",
    spotifyUrl:
      "https://open.spotify.com/track/30aWQiV7UM2BfKWXHgAN1C?si=cfc88138d1394166",
  },
  {
    id: "46",
    title: "Eryn, the Hidden Village",
    displayTitle: "Eryn, the Hidden Village - Trails of Cold Steel 4",
    game: "CS4",
    type: "City Theme",
    audioUrl: "/music/eryn_the_hidden_village.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/vyuJRJ6GQ5k",
    spotifyUrl:
      "https://open.spotify.com/track/1t5GQklCXeqICPZ8CsmmXi?si=2d2e25d19449497a",
  },
  {
    id: "47",
    title: "Twilight Green Passage",
    displayTitle: "Twilight Green Passage - Trails of Cold Steel 4",
    game: "CS4",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/twilight_green_passage.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/gMrevu1FKYg",
    spotifyUrl:
      "https://open.spotify.com/track/43rfcFg6u1IllpdI8HLt7e?si=21b07706181c4b68",
  },
  {
    id: "48",
    title: "Burning Throb",
    displayTitle: "Burning Throb - Trails of Cold Steel 4",
    game: "CS4",
    type: "Battle Theme",
    audioUrl: "/music/burning_throb.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/pulPN_-3y1s",
    spotifyUrl:
      "https://open.spotify.com/track/1qBf31qZqIp09JCWCczy1l?si=3423e925f5754d6b",
  },
  {
    id: "49",
    title: "Lyrical Amber",
    displayTitle: "Lyrical Amber - Trails of Cold Steel 4",
    game: "CS4",
    type: "City Theme",
    audioUrl: "/music/lyrical_amber.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/VekMorjnRuk",
    spotifyUrl:
      "https://open.spotify.com/track/7LnyYhTyk2oJfJUSFg2FOd?si=924c5c76df804cec",
  },
  {
    id: "50",
    title: "With Our Own Hands!!",
    displayTitle: "With Our Own Hands!! - Trails of Cold Steel 4",
    game: "CS4",
    type: "Event / Story Theme",
    audioUrl: "/music/with_our_own_hands.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/KGCjwqiUPMQ",
    spotifyUrl:
      "https://open.spotify.com/track/6aKHDd3NmYsfgPWCOF0zG3?si=7c5664a9d974476d",
  },
  {
    id: "51",
    title: "Endure Grief",
    displayTitle: "Endure Grief - Trails of Cold Steel 4",
    game: "CS4",
    type: "Battle Theme",
    audioUrl: "/music/endure_grief.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/hqgjqHRa3Kk",
    spotifyUrl:
      "https://open.spotify.com/track/5iRDoOmIKEU4MXNtRski1j?si=45346281820a42bd",
  },
  {
    id: "52",
    title: "The Destination of FATE",
    displayTitle: "The Destination of FATE - Trails into Reverie",
    game: "Reverie",
    type: "Event / Story Theme",
    audioUrl: "/music/the_destination_of_fate.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://youtu.be/mZYwOoK1_2E",
    spotifyUrl:
      "https://open.spotify.com/track/7szfQ6QBmNOB09ia00s4VE?si=ef0f0c2bc3f343cf",
  },
  {
    id: "53",
    title: "Infinity Rage",
    displayTitle: "Infinity Rage - Trails into Reverie",
    game: "Reverie",
    type: "Battle Theme",
    audioUrl: "/music/infinity_rage.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://youtu.be/BZulD5IpVD8",
    spotifyUrl:
      "https://open.spotify.com/track/5J9MuJKfQNNxzYa6FPuJG1?si=4fb3f48faaba47cb",
  },
  {
    id: "54",
    title: "Wind-Up Yesterday!",
    displayTitle: "Wind-Up Yesterday! - Trails into Reverie",
    game: "Reverie",
    type: "Battle Theme",
    audioUrl: "/music/wind_up_yesterday.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://youtu.be/yPlYKPAM8WM",
    spotifyUrl:
      "https://open.spotify.com/track/23L498ULOgTRzke0TrB2Sz?si=d758c000b0364594",
  },
  {
    id: "55",
    title: "Elegant Prowess",
    displayTitle: "Elegant Prowess - Trails into Reverie",
    game: "Reverie",
    type: "Battle Theme",
    audioUrl: "/music/elegant_prowess.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://youtu.be/0kfBsGJjyrs",
    spotifyUrl:
      "https://open.spotify.com/track/1liOtT40y2W0ADb8gM24la?si=1476215ae1d4441e",
  },
  {
    id: "56",
    title: "A Relaxing Time",
    displayTitle: "A Relaxing Time - Trails into Reverie",
    game: "Reverie",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/a_relaxing_time.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://youtu.be/WJsbtOi9-8w",
    spotifyUrl:
      "https://open.spotify.com/track/6EBQmgpwzlPj2ESMLetWNy?si=6d3af6c86d0d476c",
  },
  {
    id: "57",
    title: "Edith Old Town",
    displayTitle: "Edith Old Town - Trails through Daybreak",
    game: "Daybreak",
    type: "City Theme",
    audioUrl: "/music/edith_old_town.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/KES40VdEtQg",
    spotifyUrl:
      "https://open.spotify.com/track/7bevSxLB8zchg32dsfKc94?si=6213b8b52d824358",
  },
  {
    id: "58",
    title: "Arkride Solutions Office",
    displayTitle: "Arkride Solutions Office - Trails through Daybreak",
    game: "Daybreak",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/arkride_solutions_office.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/DJhzZNSCnBk",
    spotifyUrl:
      "https://open.spotify.com/track/1dgEKUGPo7QDn9ABZ8RcvW?si=6c7b20d5701a4d09",
  },
  {
    id: "59",
    title: "Open the Shard!",
    displayTitle: "Open the Shard! - Trails through Daybreak",
    game: "Daybreak",
    type: "Battle Theme",
    audioUrl: "/music/open_the_shard.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/lDHn4amThs0",
    spotifyUrl:
      "https://open.spotify.com/track/2S1tNIb4nRalt655vKDDhB?si=ecc0b24c9637483d",
  },
  {
    id: "60",
    title: "What Is Ahead of You",
    displayTitle: "What Is Ahead of You - Trails through Daybreak",
    game: "Daybreak",
    type: "Event / Story Theme",
    audioUrl: "/music/what_is_ahead_of_you.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/QuwszdAUYwg",
    spotifyUrl:
      "https://open.spotify.com/track/25P2EGBua6ryqwlDqzpA8W?si=cf75cfa167044c7f",
  },
  {
    id: "61",
    title: "Rise of the Grendel",
    displayTitle: "Rise of the Grendel - Trails through Daybreak",
    game: "Daybreak",
    type: "Battle Theme",
    audioUrl: "/music/rise_of_the_grendel.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/6CrR7WsJ_3c",
    spotifyUrl:
      "https://open.spotify.com/track/3ledWj9jbWef8LpWrDPzlD?si=923449a111f249ec",
  },
  {
    id: "62",
    title: "Work Out a Solution! –Command Battle–",
    displayTitle:
      "Work Out a Solution! –Command Battle– - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "Battle Theme",
    audioUrl: "/music/work_out_a_solution_command_battle.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=V7UNlr98r30",
    spotifyUrl:
      "https://open.spotify.com/track/68D90axJPG8CprIPMoynXk?si=44fad8a81e5b43e4",
  },
  {
    id: "63",
    title: "Cut Off the Retreat",
    displayTitle: "Cut Off the Retreat - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "Battle Theme",
    audioUrl: "/music/cut_off_the_retreat.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://youtu.be/V8xSR0Dt9G8",
    spotifyUrl:
      "https://open.spotify.com/track/59PYlFTPmwtKLcqWhavuEk?si=26b36ef180f646bb",
  },
  {
    id: "64",
    title: "Solid-State Shard Blow",
    displayTitle: "Solid-State Shard Blow - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "Battle Theme",
    audioUrl: "/music/solid_state_shard_blow.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://youtu.be/2yJcKDM9STo",
    spotifyUrl:
      "https://open.spotify.com/track/5b3joPVY2BrxLKuhfvDKeZ?si=9de37d89f22440d4",
  },
  {
    id: "65",
    title: "Welcome to Marduk Support",
    displayTitle: "Welcome to Marduk Support - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/welcome_to_marduk_support.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://youtu.be/gmJEPtA3SUw",
    spotifyUrl:
      "https://open.spotify.com/track/4pRmoNqa4eDceHTwpAklFY?si=bb991a97fcaf441f",
  },
  {
    id: "66",
    title: "Skip to the Edith",
    displayTitle: "Skip to the Edith - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "City Theme",
    audioUrl: "/music/skip_to_the_edith.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://youtu.be/PIpVwG2Mwl4",
    spotifyUrl:
      "https://open.spotify.com/track/15l5i5YH4PrKojQcd1lfzw?si=db596ae3c5c54254",
  },
  {
    id: "67",
    title: "Atrocious Raid",
    displayTitle: "Atrocious Raid - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story Theme",
    audioUrl: "/music/atrocious_raid.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/YbXAqwxwamE",
    spotifyUrl:
      "https://open.spotify.com/track/0xmKGKpQyVbIaouyKfi96I?si=49c4588c0e7745c5",
  },
  {
    id: "68",
    title: "To Grasp Tomorrow",
    displayTitle: "To Grasp Tomorrow - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story Theme",
    audioUrl: "/music/to_grasp_tomorrow.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/DzDG5PeXgVk",
    spotifyUrl:
      "https://open.spotify.com/track/0KgcVWtqNAm08mxgMXv94e?si=b0afe0c3fac84464",
  },
  {
    id: "69",
    title: "Firm Strength",
    displayTitle: "Firm Strength - Trails from Zero",
    game: "Zero",
    type: "Event / Story Theme",
    audioUrl: "/music/firm_strength.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://youtu.be/pmgApuXuBm8",
    spotifyUrl:
      "https://open.spotify.com/track/6uTmSpen4hG5YiJbqunmdL?si=9ff1afdd442443d4",
  },
  {
    id: "70",
    title: "The Decisive Collision",
    displayTitle: "The Decisive Collision - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story Theme",
    audioUrl: "/music/the_decisive_collision.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/hB-APrkmSdw",
    spotifyUrl:
      "https://open.spotify.com/track/694zLbJURRrhXxNHzLqBbb?si=b40a6dffdaa44c14",
  },
  {
    id: "71",
    title: "Castle of the Saint",
    displayTitle: "Castle of the Saint - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story Theme",
    audioUrl: "/music/castle_of_the_saint.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://youtu.be/wlUDzkQxqLE",
    spotifyUrl:
      "https://open.spotify.com/track/5Wq9utvgkwRCBA5BUrCCov?si=093c6029257c47be",
  },
  {
    id: "72",
    title: "I'm Grimcats!",
    displayTitle: "I'm Grimcats! - Trails through Daybreak",
    game: "Daybreak",
    type: "Event / Story Theme",
    audioUrl: "/music/im_grimcats.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/qXAGiy2JHjA",
    spotifyUrl:
      "https://open.spotify.com/track/37yhobgi2iwfJOMnywghQf?si=d3a365c28d234517",
  },
  {
    id: "73",
    title: "Till the Night of Glory",
    displayTitle: "Till the Night of Glory - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Battle Theme",
    audioUrl: "/music/till_the_night_of_glory.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://youtu.be/G2hlAYsNWs4",
    spotifyUrl:
      "https://open.spotify.com/track/3M0RYs4WBdZ1y5kVcKyBJS?si=50c98108d15948c0",
  },
  {
    id: "74",
    title: "Where the Bonds Are",
    displayTitle: "Where the Bonds Are - Trails in the Sky SC",
    game: "SC",
    type: "Event / Story Theme",
    audioUrl: "/music/where_the_bonds_are.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/bvaKsVWm9l8",
    spotifyUrl:
      "https://open.spotify.com/track/1OKlqb6xpdY3RJFkUBWAxO?si=17c298ddbeb9412a",
  },
  {
    id: "75",
    title: "The Enforcers",
    displayTitle: "The Enforcers - Trails in the Sky SC",
    game: "SC",
    type: "Event / Story Theme",
    audioUrl: "/music/the_enforcers.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://youtu.be/z07WdBYBEe0",
    spotifyUrl:
      "https://open.spotify.com/track/3QXtODuokmi5R3CaqmKACg?si=efc9ee756c9740f3",
  },
  {
    id: "76",
    title: "Challenger Invited",
    displayTitle: "Challenger Invited - Trails in the Sky FC",
    game: "FC",
    type: "Battle / Event Theme",
    audioUrl: "/music/challenger_invited.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://youtu.be/1miii690HKE",
    spotifyUrl:
      "https://open.spotify.com/track/5r8VZWAKyub6v4TjJznIZQ?si=9b98661b8bfc42fa",
  },
  {
    id: "77",
    title: "How to Walk in Liberl",
    displayTitle: "How to Walk in Liberl - Trails in the Sky FC",
    game: "FC",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/how_to_walk_in_liberl.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://youtu.be/vJii4niqc78",
    spotifyUrl:
      "https://open.spotify.com/track/05zHMmfASjEHUTdmYSARQh?si=c1e13c9479a84546",
  },
  {
    id: "78",
    title: "Silver Sword Saint",
    displayTitle: "Silver Sword Saint - Trails through Daybreak",
    game: "Daybreak",
    type: "Event / Story Theme",
    audioUrl: "/music/silver_sword_saint.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://youtu.be/fK0pebmW6A0",
    spotifyUrl:
      "https://open.spotify.com/track/0g1rFhEVMMsqXG2OVUnCh6?si=27d656432e434e88",
  },
  {
    id: "79",
    title: "Pom's Paradise",
    displayTitle: "Pom's Paradise - Trails into Reverie",
    game: "Reverie",
    type: "Event / Battle / Dungeon(?) Theme",
    audioUrl: "/music/poms_paradise.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://youtu.be/q-oOl_KUSUU",
    spotifyUrl:
      "https://open.spotify.com/track/0NyRMfP4u7ebBMuOqqIF7d?si=8b7360ad1d944390",
  },
  {
    id: "80",
    title: "Mishelam Wonderland",
    displayTitle: "Mishelam Wonderland - Trails to Azure",
    game: "Azure",
    type: "City Theme",
    audioUrl: "/music/mishelam_wonderland.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://youtu.be/My65d903Y6Y",
    spotifyUrl:
      "https://open.spotify.com/track/72wrAmrqbZ6VwSAwlrS1y9?si=59932778e0cc4531",
  },
  {
    id: "81",
    title: "Severe Blow",
    displayTitle: "Severe Blow - Trails of Cold Steel 2",
    game: "CS2",
    type: "Battle Theme",
    audioUrl: "/music/severe_blow.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://youtu.be/_VjA3y87qMg",
    spotifyUrl:
      "https://open.spotify.com/track/5aFLCqdjWMDMUoLK5hD9cn?si=fdbf6c9331144051",
  },
  {
    id: "82",
    title: "Briefing Time",
    displayTitle: "Briefing Time - Trails of Cold Steel 3",
    game: "CS3",
    type: "Event / Story Theme",
    audioUrl: "/music/briefing_time.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://youtu.be/nhYIsz8aSPc",
    spotifyUrl:
      "https://open.spotify.com/track/29C1pXa7vcFo1wEqABoAc4?si=20a5bb31bd2c401d",
  },
  {
    id: "83",
    title: "Pleasure Smile",
    displayTitle: "Pleasure Smile - Trails of Cold Steel 4",
    game: "CS4",
    type: "Event / Story Theme",
    audioUrl: "/music/pleasure_smile.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://youtu.be/Z6j1qKDuHBc",
    spotifyUrl:
      "https://open.spotify.com/track/2JhI7v7YLcrbJxdfzXYXuL?si=0478c19097c34b23",
  },
  {
    id: "84",
    title: "Line of Non-Negotiable",
    displayTitle: "Line of Non-Negotiable - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "Battle Theme",
    audioUrl: "/music/line_of_non_negotiable.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://youtu.be/DzuShubN3ko",
    spotifyUrl:
      "https://open.spotify.com/track/7y2yY0zc5uMmWR71p8pDjP?si=8bc3328a667b429c",
  },
  {
    id: "85",
    title: "Class VII",
    displayTitle: "Class VII - Trails of Cold Steel 1",
    game: "CS1",
    type: "Menu Theme",
    audioUrl: "/music/class_vii.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "86",
    title: "Aoki Shizuku",
    displayTitle: "Aoki Shizuku - Trails to Azure",
    game: "Azure",
    type: "Menu Theme",
    audioUrl: "/music/aoki_shizuku.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "87",
    title: "Now, at the Beginning",
    displayTitle: "Now, at the Beginning - Trails into Reverie",
    game: "Reverie",
    type: "Menu Theme",
    audioUrl: "/music/now_at_the_beginning.mp3",
    albumArt: "/images/albumArt/reverie.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "88",
    title: "The Cradle by Starlight",
    displayTitle: "The Cradle by Starlight - Trails Beyond The Horizon",
    game: "Horizon",
    type: "Menu Theme",
    audioUrl: "/music/the_cradle_by_starlight.mp3",
    albumArt: "/images/albumArt/horizon.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "89",
    title: "At the End of My Beloved Time Limit",
    displayTitle:
      "At the End of My Beloved Time Limit - Trails through Daybreak 2",
    game: "Daybreak 2",
    type: "Menu Theme",
    audioUrl: "/music/at_the_end_of_my_beloved_time_limit.mp3",
    albumArt: "/images/albumArt/daybreak2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "90",
    title: "In the Dawn",
    displayTitle: "In the Dawn - Trails through Daybreak",
    game: "Daybreak",
    type: "Menu Theme",
    audioUrl: "/music/in_the_dawn.mp3",
    albumArt: "/images/albumArt/daybreak.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "91",
    title: "Forward, Relentlessly",
    displayTitle: "Forward, Relentlessly - Trails of Cold Steel 2",
    game: "CS2",
    type: "Menu Theme",
    audioUrl: "/music/forward_relentlessly.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "92",
    title: "Start Line",
    displayTitle: "Start Line - Trails of Cold Steel 3",
    game: "CS3",
    type: "Menu Theme",
    audioUrl: "/music/start_line.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "93",
    title: "Bonds -Relations-",
    displayTitle: "Bonds -Relations- - Trails of Cold Steel 4",
    game: "CS4",
    type: "Menu Theme",
    audioUrl: "/music/bonds_relations.mp3",
    albumArt: "/images/albumArt/cs4.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "94",
    title: "Feelings Soar with the Wind",
    displayTitle: "Feelings Soar with the Wind - Trails in the Sky FC",
    game: "FC",
    type: "Menu Theme",
    audioUrl: "/music/feelings_soar_with_the_wind.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "95",
    title: "Shine of Aidios ~Sora no Kiseki~",
    displayTitle: "Shine of Aidios ~Sora no Kiseki~ - Trails in the Sky SC",
    game: "SC",
    type: "Menu Theme",
    audioUrl: "/music/shine_of_aidios_sora_no_kiseki.mp3",
    albumArt: "/images/albumArt/sky_sc.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "96",
    title: "A Faint Glitter of Light",
    displayTitle: "A Faint Glitter of Light - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Menu Theme",
    audioUrl: "/music/a_faint_glitter_of_light.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "97",
    title: "Zero no Kiseki",
    displayTitle: "Zero no Kiseki - Trails from Zero",
    game: "Zero",
    type: "Menu Theme",
    audioUrl: "/music/zero_no_kiseki.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "98",
    title: "Back to the Dorm",
    displayTitle: "Back to the Dorm - Trails of Cold Steel 1",
    game: "CS1",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/back_to_the_dorm.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "99",
    title: "Celdic, The Market Town",
    displayTitle: "Celdic, The Market Town - Trails of Cold Steel 1",
    game: "CS1",
    type: "City Theme",
    audioUrl: "/music/celdic_the_market_town.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "100",
    title: "Path of Spirits",
    displayTitle: "Path of Spirits - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story / Dungeon Theme",
    audioUrl: "/music/path_of_spirits.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "101",
    title: "The Sound of Rainfall in the Academy",
    displayTitle:
      "The Sound of Rainfall in the Academy - Trails of Cold Steel 1",
    game: "CS1",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/the_sound_of_rainfall_in_the_academy.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "102",
    title: "Land of Blue Skies",
    displayTitle: "Land of Blue Skies - Trails of Cold Steel 1",
    game: "CS1",
    type: "Exploration Theme",
    audioUrl: "/music/land_of_blue_skies.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "103",
    title: "The Night Sky On That Day",
    displayTitle: "The Night Sky On That Day - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story Theme",
    audioUrl: "/music/the_night_sky_on_that_day.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "104",
    title: "Legram, The Lakeside Town",
    displayTitle: "Legram, The Lakeside Town - Trails of Cold Steel 1",
    game: "CS1",
    type: "City Theme",
    audioUrl: "/music/legram_the_lakeside_town.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "105",
    title: "Roer, The Industrial Metropolis",
    displayTitle: "Roer, The Industrial Metropolis - Trails of Cold Steel 1",
    game: "CS1",
    type: "City Theme",
    audioUrl: "/music/roer_the_industrial_metropolis.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "106",
    title: "Not Yet...",
    displayTitle: "Not Yet... - Trails of Cold Steel 1",
    game: "CS1",
    type: "Event / Story Theme",
    audioUrl: "/music/not_yet.mp3",
    albumArt: "/images/albumArt/cs1.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "107",
    title: "A New Daily Life",
    displayTitle: "A New Daily Life - Trails to Azure",
    game: "Azure",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/a_new_daily_life.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "108",
    title: "The Tree at the Farthest End",
    displayTitle: "The Tree at the Farthest End - Trails to Azure",
    game: "Azure",
    type: "Event / Story Theme",
    audioUrl: "/music/the_tree_at_the_farthest_end.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "109",
    title: "The Truth of the Rainy Day",
    displayTitle: "The Truth of the Rainy Day - Trails to Azure",
    game: "Azure",
    type: "Event / Story Theme",
    audioUrl: "/music/the_truth_of_the_rainy_day.mp3",
    albumArt: "/images/albumArt/azure.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "110",
    title: "Still Countryside",
    displayTitle: "Still Countryside - Trails of Cold Steel 2",
    game: "CS2",
    type: "Exploration Theme",
    audioUrl: "/music/still_countryside.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "111",
    title: "The Warmth of Soaking One's Feet",
    displayTitle: "The Warmth of Soaking One's Feet - Trails of Cold Steel 2",
    game: "CS2",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/the_warmth_of_soaking_ones_feet.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "112",
    title: "To the Irreplaceable People",
    displayTitle: "To the Irreplaceable People - Trails of Cold Steel 2",
    game: "CS2",
    type: "Event / Story Theme",
    audioUrl: "/music/to_the_irreplaceable_people.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "113",
    title: "Ymir Canyon",
    displayTitle: "Ymir Canyon - Trails of Cold Steel 2",
    game: "CS2",
    type: "Exploration Theme",
    audioUrl: "/music/ymir_canyon.mp3",
    albumArt: "/images/albumArt/cs2.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "114",
    title: "Saint-Arkh, the Old Capital",
    displayTitle: "Saint-Arkh, the Old Capital - Trails of Cold Steel 3",
    game: "CS3",
    type: "City Theme",
    audioUrl: "/music/saint_arkh_the_old_capital.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "115",
    title: "Behind the Lore",
    displayTitle: "Behind the Lore - Trails of Cold Steel 3",
    game: "CS3",
    type: "Event / Story / Dungeon Theme",
    audioUrl: "/music/behind_the_lore.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "116",
    title: "Ordis, the Azure Port Town",
    displayTitle: "Ordis, the Azure Port Town - Trails of Cold Steel 3",
    game: "CS3",
    type: "City Theme",
    audioUrl: "/music/ordis_the_azure_port_town.mp3",
    albumArt: "/images/albumArt/cs3.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "117",
    title: "Rock on the Road",
    displayTitle: "Rock on the Road - Trails in the Sky FC",
    game: "FC",
    type: "Exploration Theme",
    audioUrl: "/music/rock_on_the_road.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "118",
    title: "Royal Capital of Grancel",
    displayTitle: "Royal Capital of Grancel - Trails in the Sky FC",
    game: "FC",
    type: "City Theme",
    audioUrl: "/music/royal_capital_of_grancel.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "119",
    title: "Under the Moonlight",
    displayTitle: "Under the Moonlight - Trails in the Sky FC",
    game: "FC",
    type: "Event / Story Theme",
    audioUrl: "/music/under_the_moonlight.mp3",
    albumArt: "/images/albumArt/sky.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "120",
    title: "Aster House",
    displayTitle: "Aster House - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Event / Story Theme",
    audioUrl: "/music/aster_house.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "121",
    title: "Primal Ground",
    displayTitle: "Primal Ground - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Event / Story Theme",
    audioUrl: "/music/primal_ground.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "122",
    title: "The Hermit's Garden",
    displayTitle: "The Hermit's Garden - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Daily Life / Casual / Story Theme",
    audioUrl: "/music/the_hermits_garden.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "123",
    title: "The Mood of the Goddess Depends on Luck",
    displayTitle:
      "The Mood of the Goddess Depends on Luck - Trails in the Sky the 3rd",
    game: "3rd",
    type: "Event / Story Theme",
    audioUrl: "/music/the_mood_of_the_goddess_depends_on_luck.mp3",
    albumArt: "/images/albumArt/sky_3rd.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "124",
    title: "Afternoon in Crossbell",
    displayTitle: "Afternoon in Crossbell - Trails from Zero",
    game: "Zero",
    type: "Daily Life / Casual Theme",
    audioUrl: "/music/afternoon_in_crossbell.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "125",
    title: "Armorica Village",
    displayTitle: "Armorica Village - Trails from Zero",
    game: "Zero",
    type: "City Theme",
    audioUrl: "/music/armorica_village.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "126",
    title: "Crossing the Iron Bridge",
    displayTitle: "Crossing the Iron Bridge - Trails from Zero",
    game: "Zero",
    type: "Exploration Theme",
    audioUrl: "/music/crossing_the_iron_bridge.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "127",
    title: "Scene of a Street Corner",
    displayTitle: "Scene of a Street Corner - Trails from Zero",
    game: "Zero",
    type: "Daily Life / Casual / City Theme",
    audioUrl: "/music/scene_of_street_corner.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "128",
    title: "The Way of the Tree Spirit",
    displayTitle: "The Way of the Tree Spirit - Trails from Zero",
    game: "Zero",
    type: "Event / Exploration Theme",
    audioUrl: "/music/the_way_of_the_tree_spirit.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
  {
    id: "129",
    title: "Water, Plants and the Blue Sky",
    displayTitle: "Water, Plants and the Blue Sky - Trails from Zero",
    game: "Zero",
    type: "Exploration Theme",
    audioUrl: "/music/water_plants_and_the_blue_sky.mp3",
    albumArt: "/images/albumArt/zero.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=placeholder",
    spotifyUrl: "https://open.spotify.com/track/placeholder",
  },
];
// 58 in array as of 11.04
export const LOCATIONS = [
  // Sky Locations (1-15)
  {
    id: "1",
    locationName: "Rolent",
    locationNation: "Liberl",
    locationSearchTerms: ["City", "Town", "Cassius"],
    wikiUrl: "https://falcom.wiki/wiki/Rolent",
    mapCoords: { x: 28.95, y: 68.52 },
    imageFilePaths: [
      "/images/location/1/image-1.webp",
      "/images/location/1/image-2.webp",
      "/images/location/1/image-3.webp",
      "/images/location/1/image-4.webp",
      "/images/location/1/image-5.webp",
    ],
  },
  {
    id: "2",
    locationName: "Perzel Farm",
    locationNation: "Liberl",
    locationSearchTerms: ["Farm", "Countryside", "Perzel"],
    wikiUrl: "https://falcom.wiki/wiki/Perzel_Farm",
    mapCoords: { x: 27.19, y: 69.79 },
    imageFilePaths: [
      "/images/location/2/image-1.webp",
      "/images/location/2/image-2.webp",
      "/images/location/2/image-3.webp",
      "/images/location/2/image-4.webp",
      "/images/location/2/image-5.webp",
    ],
  },
  {
    id: "3",
    locationName: "Mistwald",
    locationNation: "Liberl",
    locationSearchTerms: ["Forest", "Mistwald", "Woods", "Mist"],
    wikiUrl: "https://falcom.wiki/wiki/Mistwald",
    mapCoords: { x: 28.86, y: 70.82 },
    imageFilePaths: [
      "/images/location/3/image-1.webp",
      "/images/location/3/image-2.webp",
      "/images/location/3/image-3.webp",
      "/images/location/3/image-4.webp",
      "/images/location/3/image-5.webp",
    ],
  },
  {
    id: "4",
    locationName: "Bose",
    locationNation: "Liberl",
    locationSearchTerms: ["City", "Town", "Market"],
    wikiUrl: "https://falcom.wiki/wiki/Bose",
    mapCoords: { x: 23.35, y: 66.36 },
    imageFilePaths: [
      "/images/location/4/image-1.webp",
      "/images/location/4/image-2.webp",
      "/images/location/4/image-3.webp",
      "/images/location/4/image-4.webp",
      "/images/location/4/image-5.webp",
    ],
  },
  {
    id: "5",
    locationName: "Valleria Lakeshore",
    locationNation: "Liberl",
    locationSearchTerms: ["Lake", "Valleria", "Shore", "Beach"],
    wikiUrl: "https://falcom.wiki/wiki/Lake_Valleria",
    mapCoords: { x: 24.05, y: 68.45 },
    imageFilePaths: [
      "/images/location/5/image-1.webp",
      "/images/location/5/image-2.webp",
      "/images/location/5/image-3.webp",
      "/images/location/5/image-4.webp",
      "/images/location/5/image-5.webp",
    ],
  },
  {
    id: "6",
    locationName: "Nebel Valley",
    locationNation: "Liberl",
    locationSearchTerms: ["Valley", "Nebel", "Mountains"],
    wikiUrl: "https://falcom.wiki/wiki/Nebel_Valley",
    mapCoords: { x: 26.35, y: 66.57 },
    imageFilePaths: [
      "/images/location/6/image-1.webp",
      "/images/location/6/image-2.webp",
      "/images/location/6/image-3.webp",
      "/images/location/6/image-4.webp",
      "/images/location/6/image-5.webp",
    ],
  },
  {
    id: "7",
    locationName: "Ravennue Village",
    locationNation: "Liberl",
    locationSearchTerms: ["Village", "Ravennue", "Hot Springs"],
    wikiUrl: "https://falcom.wiki/wiki/Ravennue_Village",
    mapCoords: { x: 21.61, y: 65.73 },
    imageFilePaths: [
      "/images/location/7/image-1.webp",
      "/images/location/7/image-2.webp",
      "/images/location/7/image-3.webp",
      "/images/location/7/image-4.webp",
      "/images/location/7/image-5.webp",
    ],
  },
  {
    id: "8",
    locationName: "Ruan",
    locationNation: "Liberl",
    locationSearchTerms: ["City", "Town", "Harbor", "Port"],
    wikiUrl: "https://falcom.wiki/wiki/Ruan",
    mapCoords: { x: 20.1, y: 72.91 },
    imageFilePaths: [
      "/images/location/8/image-1.webp",
      "/images/location/8/image-2.webp",
      "/images/location/8/image-3.webp",
      "/images/location/8/image-4.webp",
      "/images/location/8/image-5.webp",
    ],
  },
  {
    id: "9",
    locationName: "Manoria Village",
    locationNation: "Liberl",
    locationSearchTerms: ["Village", "Manoria", "Beach"],
    wikiUrl: "https://falcom.wiki/wiki/Manoria_Village",
    mapCoords: { x: 17.93, y: 71.51 },
    imageFilePaths: [
      "/images/location/9/image-1.webp",
      "/images/location/9/image-2.webp",
      "/images/location/9/image-3.webp",
      "/images/location/9/image-4.webp",
      "/images/location/9/image-5.webp",
    ],
  },
  {
    id: "10",
    locationName: "Jenis Royal Academy",
    locationNation: "Liberl",
    locationSearchTerms: ["Academy", "School", "Jenis", "Royal"],
    wikiUrl: "https://falcom.wiki/wiki/Jenis_Royal_Academy",
    mapCoords: { x: 22.01, y: 70.61 },
    imageFilePaths: [
      "/images/location/10/image-1.webp",
      "/images/location/10/image-2.webp",
      "/images/location/10/image-3.webp",
      "/images/location/10/image-4.webp",
      "/images/location/10/image-5.webp",
    ],
  },
  {
    id: "11",
    locationName: "Zeiss",
    locationNation: "Liberl",
    locationSearchTerms: ["City", "Town", "Factory", "Technology"],
    wikiUrl: "https://falcom.wiki/wiki/Zeiss",
    mapCoords: { x: 23.44, y: 75.41 },
    imageFilePaths: [
      "/images/location/11/image-1.webp",
      "/images/location/11/image-2.webp",
      "/images/location/11/image-3.webp",
      "/images/location/11/image-4.webp",
      "/images/location/11/image-5.webp",
    ],
  },
  {
    id: "12",
    locationName: "Elmo Village",
    locationNation: "Liberl",
    locationSearchTerms: ["Village", "Elmo", "Hot Springs"],
    wikiUrl: "https://falcom.wiki/wiki/Elmo_Village",
    mapCoords: { x: 24.61, y: 77.5 },
    imageFilePaths: [
      "/images/location/12/image-1.webp",
      "/images/location/12/image-2.webp",
      "/images/location/12/image-3.webp",
      "/images/location/12/image-4.webp",
      "/images/location/12/image-5.webp",
    ],
  },
  {
    id: "13",
    locationName: "Grancel",
    locationNation: "Liberl",
    locationSearchTerms: ["Capital", "City", "Royal"],
    wikiUrl: "https://falcom.wiki/wiki/Grancel",
    mapCoords: { x: 25.43, y: 71.31 },
    imageFilePaths: [
      "/images/location/13/image-1.webp",
      "/images/location/13/image-2.webp",
      "/images/location/13/image-3.webp",
      "/images/location/13/image-4.webp",
      "/images/location/13/image-5.webp",
    ],
  },
  {
    id: "14",
    locationName: "Grancel Castle",
    locationNation: "Liberl",
    locationSearchTerms: ["Castle", "Palace", "Royal", "Queen"],
    wikiUrl: "https://falcom.wiki/wiki/Grancel_Castle",
    mapCoords: { x: 25.09, y: 71.24 },
    imageFilePaths: [
      "/images/location/14/image-1.webp",
      "/images/location/14/image-2.webp",
      "/images/location/14/image-3.webp",
      "/images/location/14/image-4.webp",
      "/images/location/14/image-5.webp",
    ],
  },
  {
    id: "15",
    locationName: "Sealed Area",
    locationNation: "Liberl",
    locationSearchTerms: ["Dungeon", "Final", "Sealed", "Aureole"],
    wikiUrl: "https://falcom.wiki/wiki/Sealed_Area",
    mapCoords: { x: 25.09, y: 71.24 },
    imageFilePaths: [
      "/images/location/15/image-1.webp",
      "/images/location/15/image-2.webp",
      "/images/location/15/image-3.webp",
      "/images/location/15/image-4.webp",
      "/images/location/15/image-5.webp",
    ],
  },
  // CS4 Locations (16-28)
  {
    id: "16",
    locationName: "Courageous II",
    locationNation: "Erebonia",
    locationSearchTerms: ["Airship", "Ship", "Courageous", "Vessel"],
    wikiUrl: "https://falcom.wiki/wiki/Courageous_II",
    mapCoords: { x: 40.97, y: 4.39 },
    imageFilePaths: [
      "/images/location/16/image-1.webp",
      "/images/location/16/image-2.webp",
      "/images/location/16/image-3.webp",
      "/images/location/16/image-4.webp",
      "/images/location/16/image-5.webp",
    ],
  },
  {
    id: "17",
    locationName: "Saint-Arkh",
    locationNation: "Erebonia",
    locationSearchTerms: ["City", "Town", "Saint", "Cathedral"],
    wikiUrl: "https://falcom.wiki/wiki/Saint-Arkh",
    mapCoords: { x: 18.75, y: 53.69 },
    imageFilePaths: [
      "/images/location/17/image-1.webp",
      "/images/location/17/image-2.webp",
      "/images/location/17/image-3.webp",
      "/images/location/17/image-4.webp",
      "/images/location/17/image-5.webp",
    ],
  },
  {
    id: "18",
    locationName: "Parm",
    locationNation: "Erebonia",
    locationSearchTerms: ["Town", "Village", "Parm"],
    wikiUrl: "https://falcom.wiki/wiki/Parm",
    mapCoords: { x: 22.48, y: 58.28 },
    imageFilePaths: [
      "/images/location/18/image-1.webp",
      "/images/location/18/image-2.webp",
      "/images/location/18/image-3.webp",
      "/images/location/18/image-4.webp",
      "/images/location/18/image-5.webp",
    ],
  },
  {
    id: "19",
    locationName: "Eryn",
    locationNation: "Erebonia",
    locationSearchTerms: ["Village", "Eryn", "Elf"],
    wikiUrl: "https://falcom.wiki/wiki/Eryn",
    mapCoords: { x: 14.8, y: 52.02 },
    imageFilePaths: [
      "/images/location/19/image-1.webp",
      "/images/location/19/image-2.webp",
      "/images/location/19/image-3.webp",
      "/images/location/19/image-4.webp",
      "/images/location/19/image-5.webp",
    ],
  },
  {
    id: "20",
    locationName: "Ordis",
    locationNation: "Erebonia",
    locationSearchTerms: ["City", "Town", "Ordis"],
    wikiUrl: "https://falcom.wiki/wiki/Ordis",
    mapCoords: { x: 8.38, y: 40.46 },
    imageFilePaths: [
      "/images/location/20/image-1.webp",
      "/images/location/20/image-2.webp",
      "/images/location/20/image-3.webp",
      "/images/location/20/image-4.webp",
      "/images/location/20/image-5.webp",
    ],
  },
  {
    id: "21",
    locationName: "Alster",
    locationNation: "Erebonia",
    locationSearchTerms: ["Town", "Village", "Alster"],
    wikiUrl: "https://falcom.wiki/wiki/Alster",
    mapCoords: { x: 19.4, y: 36.49 },
    imageFilePaths: [
      "/images/location/21/image-1.webp",
      "/images/location/21/image-2.webp",
      "/images/location/21/image-3.webp",
      "/images/location/21/image-4.webp",
      "/images/location/21/image-5.webp",
    ],
  },
  {
    id: "22",
    locationName: "Leeves",
    locationNation: "Erebonia",
    locationSearchTerms: ["City", "Town", "Leeves", "Capital"],
    wikiUrl: "https://falcom.wiki/wiki/Leeves",
    mapCoords: { x: 21.83, y: 44.77 },
    imageFilePaths: [
      "/images/location/22/image-1.webp",
      "/images/location/22/image-2.webp",
      "/images/location/22/image-3.webp",
      "/images/location/22/image-4.webp",
      "/images/location/22/image-5.webp",
    ],
  },
  {
    id: "23",
    locationName: "Milsante",
    locationNation: "Erebonia",
    locationSearchTerms: ["Town", "Village", "Milsante"],
    wikiUrl: "https://falcom.wiki/wiki/Milsante",
    mapCoords: { x: 17.01, y: 42.13 },
    imageFilePaths: [
      "/images/location/23/image-1.webp",
      "/images/location/23/image-2.webp",
      "/images/location/23/image-3.webp",
      "/images/location/23/image-4.webp",
      "/images/location/23/image-5.webp",
    ],
  },
  {
    id: "24",
    locationName: "Crossbell City",
    locationNation: "Crossbell",
    locationSearchTerms: ["City", "State", "Downtown", "Capital"],
    wikiUrl: "https://falcom.wiki/wiki/Crossbell_City",
    mapCoords: { x: 37.98, y: 46.1 },
    imageFilePaths: [
      "/images/location/24/image-1.webp",
      "/images/location/24/image-2.webp",
      "/images/location/24/image-3.webp",
      "/images/location/24/image-4.webp",
      "/images/location/24/image-5.webp",
    ],
  },
  {
    id: "25",
    locationName: "St. Ursula Medical College",
    locationNation: "Crossbell",
    locationSearchTerms: ["Hospital", "Medical", "College", "Ursula", "School"],
    wikiUrl: "https://falcom.wiki/wiki/St._Ursula_Medical_College",
    mapCoords: { x: 37.72, y: 47.28 },
    imageFilePaths: [
      "/images/location/25/image-1.webp",
      "/images/location/25/image-2.webp",
      "/images/location/25/image-3.webp",
      "/images/location/25/image-4.webp",
      "/images/location/25/image-5.webp",
    ],
  },
  {
    id: "26",
    locationName: "Mishelam Resort",
    locationNation: "Crossbell",
    locationSearchTerms: ["Resort", "Amusement Park", "Mishelam", "Theme Park"],
    wikiUrl: "https://falcom.wiki/wiki/Mishelam_Wonderland",
    mapCoords: { x: 38.63, y: 47.14 },
    imageFilePaths: [
      "/images/location/26/image-1.webp",
      "/images/location/26/image-2.webp",
      "/images/location/26/image-3.webp",
      "/images/location/26/image-4.webp",
      "/images/location/26/image-5.webp",
    ],
  },
  {
    id: "27",
    locationName: "Stargazer Tower",
    locationNation: "Crossbell",
    locationSearchTerms: ["Tower", "Stargazer", "Observatory"],
    wikiUrl: "https://falcom.wiki/wiki/Stargazer%27s_Tower",
    mapCoords: { x: 37.46, y: 47.0 },
    imageFilePaths: [
      "/images/location/27/image-1.webp",
      "/images/location/27/image-2.webp",
      "/images/location/27/image-3.webp",
      "/images/location/27/image-4.webp",
      "/images/location/27/image-5.webp",
    ],
  },
  {
    id: "28",
    locationName: "Raquel",
    locationNation: "Erebonia",
    locationSearchTerms: ["Village", "Town", "Raquel"],
    wikiUrl: "https://falcom.wiki/wiki/Raquel",
    mapCoords: { x: 12.67, y: 41.71 },
    imageFilePaths: [
      "/images/location/28/image-1.webp",
      "/images/location/28/image-2.webp",
      "/images/location/28/image-3.webp",
      "/images/location/28/image-4.webp",
      "/images/location/28/image-5.webp",
    ],
  },
  // CS1/CS2 Locations (29-42)
  {
    id: "29",
    locationName: "Thors Military Academy",
    locationNation: "Erebonia",
    locationSearchTerms: ["School", "Academy", "Thors", "Military"],
    wikiUrl: "https://falcom.wiki/wiki/Thors_Military_Academy",
    mapCoords: { x: 26.09, y: 45.19 },
    imageFilePaths: [
      "/images/location/29/image-1.webp",
      "/images/location/29/image-2.webp",
      "/images/location/29/image-3.webp",
      "/images/location/29/image-4.webp",
      "/images/location/29/image-5.webp",
    ],
  },
  {
    id: "30",
    locationName: "Trista",
    locationNation: "Erebonia",
    locationSearchTerms: ["Town", "City", "Trista"],
    wikiUrl: "https://falcom.wiki/wiki/Trista",
    mapCoords: { x: 26.04, y: 45.89 },
    imageFilePaths: [
      "/images/location/30/image-1.webp",
      "/images/location/30/image-2.webp",
      "/images/location/30/image-3.webp",
      "/images/location/30/image-4.webp",
      "/images/location/30/image-5.webp",
    ],
  },
  {
    id: "31",
    locationName: "Bareahard",
    locationNation: "Erebonia",
    locationSearchTerms: ["City", "Town", "Bareahard"],
    wikiUrl: "https://falcom.wiki/wiki/Bareahard",
    mapCoords: { x: 30.03, y: 51.46 },
    imageFilePaths: [
      "/images/location/31/image-1.webp",
      "/images/location/31/image-2.webp",
      "/images/location/31/image-3.webp",
      "/images/location/31/image-4.webp",
      "/images/location/31/image-5.webp",
    ],
  },
  {
    id: "32",
    locationName: "Nord",
    locationNation: "Erebonia",
    locationSearchTerms: ["Village", "Town", "Nord", "Highlands"],
    wikiUrl: "https://falcom.wiki/wiki/Nord",
    mapCoords: { x: 35.98, y: 28.97 },
    imageFilePaths: [
      "/images/location/32/image-1.webp",
      "/images/location/32/image-2.webp",
      "/images/location/32/image-3.webp",
      "/images/location/32/image-4.webp",
      "/images/location/32/image-5.webp",
    ],
  },
  {
    id: "33",
    locationName: "Heimdallr",
    locationNation: "Erebonia",
    locationSearchTerms: ["City", "Capital", "Heimdallr"],
    wikiUrl: "https://falcom.wiki/wiki/Heimdallr",
    mapCoords: { x: 24.0, y: 44.98 },
    imageFilePaths: [
      "/images/location/33/image-1.webp",
      "/images/location/33/image-2.webp",
      "/images/location/33/image-3.webp",
      "/images/location/33/image-4.webp",
      "/images/location/33/image-5.webp",
    ],
  },
  {
    id: "34",
    locationName: "Legram",
    locationNation: "Erebonia",
    locationSearchTerms: ["Village", "Town", "Legram"],
    wikiUrl: "https://falcom.wiki/wiki/Legram",
    mapCoords: { x: 28.6, y: 55.99 },
    imageFilePaths: [
      "/images/location/34/image-1.webp",
      "/images/location/34/image-2.webp",
      "/images/location/34/image-3.webp",
      "/images/location/34/image-4.webp",
      "/images/location/34/image-5.webp",
    ],
  },
  {
    id: "35",
    locationName: "Roer",
    locationNation: "Erebonia",
    locationSearchTerms: ["City", "Town", "Roer"],
    wikiUrl: "https://falcom.wiki/wiki/Roer",
    mapCoords: { x: 29.9, y: 37.39 },
    imageFilePaths: [
      "/images/location/35/image-1.webp",
      "/images/location/35/image-2.webp",
      "/images/location/35/image-3.webp",
      "/images/location/35/image-4.webp",
      "/images/location/35/image-5.webp",
    ],
  },
  {
    id: "36",
    locationName: "Lunaria Nature Park",
    locationNation: "Erebonia",
    locationSearchTerms: ["Park", "Nature", "Lunaria"],
    wikiUrl: "https://falcom.wiki/wiki/Lunaria_Nature_Park",
    mapCoords: { x: 29.12, y: 44.43 },
    imageFilePaths: [
      "/images/location/36/image-1.webp",
      "/images/location/36/image-2.webp",
      "/images/location/36/image-3.webp",
      "/images/location/36/image-4.webp",
      "/images/location/36/image-5.webp",
    ],
  },
  {
    id: "37",
    locationName: "Garrelia Fortress",
    locationNation: "Erebonia",
    locationSearchTerms: ["Fortress", "Military", "Garrelia", "Proving Ground"],
    wikiUrl: "https://falcom.wiki/wiki/Garrelia_Fortress",
    mapCoords: { x: 36.46, y: 46.31 },
    imageFilePaths: [
      "/images/location/37/image-1.webp",
      "/images/location/37/image-2.webp",
      "/images/location/37/image-3.webp",
      "/images/location/37/image-4.webp",
      "/images/location/37/image-5.webp",
    ],
  },
  {
    id: "38",
    locationName: "Eisengard Range",
    locationNation: "Erebonia",
    locationSearchTerms: ["Mountain", "Range", "Eisengard"],
    wikiUrl: "https://falcom.wiki/wiki/Eisengard_Range",
    mapCoords: { x: 27.99, y: 31.82 },
    imageFilePaths: [
      "/images/location/38/image-1.webp",
      "/images/location/38/image-2.webp",
      "/images/location/38/image-3.webp",
      "/images/location/38/image-4.webp",
      "/images/location/38/image-5.webp",
    ],
  },
  {
    id: "39",
    locationName: "Sachsen Iron Mine",
    locationNation: "Erebonia",
    locationSearchTerms: ["Mine", "Iron", "Sachsen"],
    wikiUrl: "https://falcom.wiki/wiki/Sachsen_Iron_Mine",
    mapCoords: { x: 29.51, y: 34.96 },
    imageFilePaths: [
      "/images/location/39/image-1.webp",
      "/images/location/39/image-2.webp",
      "/images/location/39/image-3.webp",
      "/images/location/39/image-4.webp",
      "/images/location/39/image-5.webp",
    ],
  },
  {
    id: "40",
    locationName: "Twin Dragons Bridge",
    locationNation: "Erebonia",
    locationSearchTerms: ["Bridge", "Twin Dragons"],
    wikiUrl: "https://falcom.wiki/wiki/Twin_Dragons_Bridge",
    mapCoords: { x: 32.51, y: 46.93 },
    imageFilePaths: [
      "/images/location/40/image-1.webp",
      "/images/location/40/image-2.webp",
      "/images/location/40/image-3.webp",
      "/images/location/40/image-4.webp",
      "/images/location/40/image-5.webp",
    ],
  },
  {
    id: "41",
    locationName: "Ancient Quarry",
    locationNation: "Erebonia",
    locationSearchTerms: ["Quarry", "Ancient", "Dungeon"],
    wikiUrl: "https://falcom.wiki/wiki/Ancient_Quarry",
    mapCoords: { x: 37.33, y: 25.83 },
    imageFilePaths: [
      "/images/location/41/image-1.webp",
      "/images/location/41/image-2.webp",
      "/images/location/41/image-3.webp",
      "/images/location/41/image-4.webp",
      "/images/location/41/image-5.webp",
    ],
  },
  {
    id: "42",
    locationName: "Celdic",
    locationNation: "Erebonia",
    locationSearchTerms: ["Town", "City", "Celdic"],
    wikiUrl: "https://falcom.wiki/wiki/Celdic",
    mapCoords: { x: 29.47, y: 46.45 },
    imageFilePaths: [
      "/images/location/42/image-1.webp",
      "/images/location/42/image-2.webp",
      "/images/location/42/image-3.webp",
      "/images/location/42/image-4.webp",
      "/images/location/42/image-5.webp",
    ],
  },
  // Daybreak Locations (43-55)
  {
    id: "43",
    locationName: "Creil",
    locationNation: "Calvard",
    locationSearchTerms: ["Village", "Town", "Creil"],
    wikiUrl: "https://falcom.wiki/wiki/Creil",
    mapCoords: { x: 45.31, y: 36.56 },
    imageFilePaths: [
      "/images/location/43/image-1.webp",
      "/images/location/43/image-2.webp",
      "/images/location/43/image-3.webp",
      "/images/location/43/image-4.webp",
      "/images/location/43/image-5.webp",
    ],
  },
  {
    id: "44",
    locationName: "Langport",
    locationNation: "Calvard",
    locationSearchTerms: ["City", "Town", "Langport", "Port"],
    wikiUrl: "https://falcom.wiki/wiki/Langport",
    mapCoords: { x: 43.45, y: 69.42 },
    imageFilePaths: [
      "/images/location/44/image-1.webp",
      "/images/location/44/image-2.webp",
      "/images/location/44/image-3.webp",
      "/images/location/44/image-4.webp",
      "/images/location/44/image-5.webp",
    ],
  },
  {
    id: "45",
    locationName: "Tharbad",
    locationNation: "Calvard",
    locationSearchTerms: ["City", "Town", "Tharbad"],
    wikiUrl: "https://falcom.wiki/wiki/Tharbad",
    mapCoords: { x: 53.04, y: 68.45 },
    imageFilePaths: [
      "/images/location/45/image-1.webp",
      "/images/location/45/image-2.webp",
      "/images/location/45/image-3.webp",
      "/images/location/45/image-4.webp",
      "/images/location/45/image-5.webp",
    ],
  },
  {
    id: "46",
    locationName: "Basel",
    locationNation: "Calvard",
    locationSearchTerms: ["City", "Town", "Basel"],
    wikiUrl: "https://falcom.wiki/wiki/Basel",
    mapCoords: { x: 39.71, y: 61.9 },
    imageFilePaths: [
      "/images/location/46/image-1.webp",
      "/images/location/46/image-2.webp",
      "/images/location/46/image-3.webp",
      "/images/location/46/image-4.webp",
      "/images/location/46/image-5.webp",
    ],
  },
  {
    id: "47",
    locationName: "Longlai",
    locationNation: "Calvard",
    locationSearchTerms: ["City", "Town", "Longlai"],
    wikiUrl: "https://falcom.wiki/wiki/Longlai",
    mapCoords: { x: 58.85, y: 53.48 },
    imageFilePaths: [
      "/images/location/47/image-1.webp",
      "/images/location/47/image-2.webp",
      "/images/location/47/image-3.webp",
      "/images/location/47/image-4.webp",
      "/images/location/47/image-5.webp",
    ],
  },
  {
    id: "48",
    locationName: "Old Town",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Old Town", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Old_Town_(Edith)",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/48/image-1.webp",
      "/images/location/48/image-2.webp",
      "/images/location/48/image-3.webp",
      "/images/location/48/image-4.webp",
      "/images/location/48/image-5.webp",
    ],
  },
  {
    id: "49",
    locationName: "Riverside",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Riverside", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Riverside_(Edith)",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/49/image-1.webp",
      "/images/location/49/image-2.webp",
      "/images/location/49/image-3.webp",
      "/images/location/49/image-4.webp",
      "/images/location/49/image-5.webp",
    ],
  },
  {
    id: "50",
    locationName: "Station Street",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Station Street", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Station_Street_(Edith)",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/50/image-1.webp",
      "/images/location/50/image-2.webp",
      "/images/location/50/image-3.webp",
      "/images/location/50/image-4.webp",
      "/images/location/50/image-5.webp",
    ],
  },
  {
    id: "51",
    locationName: "Tyrell District",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Tyrell", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Tyrell_District",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/51/image-1.webp",
      "/images/location/51/image-2.webp",
      "/images/location/51/image-3.webp",
      "/images/location/51/image-4.webp",
      "/images/location/51/image-5.webp",
    ],
  },
  {
    id: "52",
    locationName: "Seiden District",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Seiden", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Seiden_District",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/52/image-1.webp",
      "/images/location/52/image-2.webp",
      "/images/location/52/image-3.webp",
      "/images/location/52/image-4.webp",
      "/images/location/52/image-5.webp",
    ],
  },
  {
    id: "53",
    locationName: "Blacklight District",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Blacklight", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Blacklight_District",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/53/image-1.webp",
      "/images/location/53/image-2.webp",
      "/images/location/53/image-3.webp",
      "/images/location/53/image-4.webp",
      "/images/location/53/image-5.webp",
    ],
  },
  {
    id: "54",
    locationName: "Auber District",
    locationNation: "Calvard",
    locationSearchTerms: ["District", "Auber", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Auber_District",
    mapCoords: { x: 48.22, y: 53.2 },
    imageFilePaths: [
      "/images/location/54/image-1.webp",
      "/images/location/54/image-2.webp",
      "/images/location/54/image-3.webp",
      "/images/location/54/image-4.webp",
      "/images/location/54/image-5.webp",
    ],
  },
  {
    id: "55",
    locationName: "Dirke Memorial Park",
    locationNation: "Calvard",
    locationSearchTerms: ["Park", "Memorial", "Dirke", "Edith"],
    wikiUrl: "https://falcom.wiki/wiki/Dirke_Memorial_Park",
    mapCoords: { x: 47.87, y: 57.03 },
    imageFilePaths: [
      "/images/location/55/image-1.webp",
      "/images/location/55/image-2.webp",
      "/images/location/55/image-3.webp",
      "/images/location/55/image-4.webp",
      "/images/location/55/image-5.webp",
    ],
  },
  {
    id: "56",
    locationName: "Oración",
    locationNation: "Calvard",
    locationSearchTerms: ["Village", "Town", "Oracion"],
    wikiUrl: "https://falcom.wiki/wiki/Oraci%C3%B3n",
    mapCoords: { x: 54.95, y: 39.34 },
    imageFilePaths: [
      "/images/location/56/image-1.webp",
      "/images/location/56/image-2.webp",
      "/images/location/56/image-3.webp",
      "/images/location/56/image-4.webp",
      "/images/location/56/image-5.webp",
    ],
  },
  {
    id: "57",
    locationName: "Ymir",
    locationNation: "Erebonia",
    locationSearchTerms: ["Village", "Town", "Ymir"],
    wikiUrl: "https://falcom.wiki/wiki/Ymir",
    mapCoords: { x: 27.04, y: 34.33 },
    imageFilePaths: [
      "/images/location/57/image-1.webp",
      "/images/location/57/image-2.webp",
      "/images/location/57/image-3.webp",
      "/images/location/57/image-4.webp",
      "/images/location/57/image-5.webp",
    ],
  },
  {
    id: "58",
    locationName: "Nomadic Settlement",
    locationNation: "Erebonia",
    locationSearchTerms: ["Village", "Town", "Nomadic", "Settlement"],
    wikiUrl: "https://falcom.wiki/wiki/Nomadic_Settlement",
    mapCoords: { x: 35.59, y: 26.95 },
    imageFilePaths: [
      "/images/location/58/image-1.webp",
      "/images/location/58/image-2.webp",
      "/images/location/58/image-3.webp",
      "/images/location/58/image-4.webp",
      "/images/location/58/image-5.webp",
    ],
  },
  {
    id: "59",
    locationName: "Amberl Tower",
    locationNation: "Liberl",
    locationSearchTerms: ["Tower", "Amberl", "Bose"],
    wikiUrl: "https://falcom.wiki/wiki/Amberl_Tower",
    mapCoords: { x: 23.21, y: 67.99 },
    imageFilePaths: [
      "/images/location/59/image-1.webp",
      "/images/location/59/image-2.webp",
      "/images/location/59/image-3.webp",
      "/images/location/59/image-4.webp",
      "/images/location/59/image-5.webp",
    ],
  },
  {
    id: "60",
    locationName: "Ancient Dragon's Dwelling",
    locationNation: "Liberl",
    locationSearchTerms: ["Ancient", "Dragon", "Dwelling", "Bose"],
    wikiUrl: "https://falcom.wiki/wiki/Ancient_Dragon%27s_Dwelling",
    mapCoords: { x: 27.5, y: 65.78 },
    imageFilePaths: [
      "/images/location/60/image-1.webp",
      "/images/location/60/image-2.webp",
      "/images/location/60/image-3.webp",
      "/images/location/60/image-4.webp",
      "/images/location/60/image-5.webp",
    ],
  },
  {
    id: "61",
    locationName: "Aster House",
    locationNation: "Emerose City",
    locationSearchTerms: ["House", "Aster", "Mansion"],
    wikiUrl: "https://falcom.wiki/wiki/Aster_House",
    mapCoords: { x: 58.88, y: 27.83 },
    imageFilePaths: [
      "/images/location/61/image-1.webp",
      "/images/location/61/image-2.webp",
      "/images/location/61/image-3.webp",
      "/images/location/61/image-4.webp",
      "/images/location/61/image-5.webp",
    ],
  },
  {
    id: "62",
    locationName: "Axis Pillar",
    locationNation: "Liber Ark",
    locationSearchTerms: ["Axis", "Pillar", "Liber Ark"],
    wikiUrl: "https://falcom.wiki/wiki/Axis_Pillar",
    mapCoords: { x: 23.77, y: 70.31 },
    imageFilePaths: [
      "/images/location/62/image-1.webp",
      "/images/location/62/image-2.webp",
      "/images/location/62/image-3.webp",
      "/images/location/62/image-4.webp",
      "/images/location/62/image-5.webp",
    ],
  },
  {
    id: "63",
    locationName: "Calmare",
    locationNation: "Liber Ark",
    locationSearchTerms: ["Calmare", "Liber Ark", "Ship"],
    wikiUrl: "https://falcom.wiki/wiki/Calmare",
    mapCoords: { x: 23.77, y: 70.31 },
    imageFilePaths: [
      "/images/location/63/image-1.webp",
      "/images/location/63/image-2.webp",
      "/images/location/63/image-3.webp",
      "/images/location/63/image-4.webp",
      "/images/location/63/image-5.webp",
    ],
  },
  {
    id: "64",
    locationName: "Carnelia Tower",
    locationNation: "Liberl",
    locationSearchTerms: ["Tower", "Carnelia", "Zeiss"],
    wikiUrl: "https://falcom.wiki/wiki/Carnelia_Tower",
    mapCoords: { x: 24.86, y: 75.25 },
    imageFilePaths: [
      "/images/location/64/image-1.webp",
      "/images/location/64/image-2.webp",
      "/images/location/64/image-3.webp",
      "/images/location/64/image-4.webp",
      "/images/location/64/image-5.webp",
    ],
  },
  {
    id: "65",
    locationName: "Rolent City Sewers",
    locationNation: "Liberl",
    locationSearchTerms: ["Sewers", "Rolent", "City"],
    wikiUrl: "https://falcom.wiki/wiki/Rolent_Sewers",
    mapCoords: { x: 28.94, y: 68.5 },
    imageFilePaths: [
      "/images/location/65/image-1.webp",
      "/images/location/65/image-2.webp",
      "/images/location/65/image-3.webp",
      "/images/location/65/image-4.webp",
      "/images/location/65/image-5.webp",
    ],
  },
  {
    id: "66",
    locationName: "Grand Arena",
    locationNation: "Liberl",
    locationSearchTerms: ["City", "Grancel", "Capital"],
    wikiUrl: "https://falcom.wiki/wiki/Grancel",
    mapCoords: { x: 25.07, y: 71.28 },
    imageFilePaths: [
      "/images/location/66/image-1.webp",
      "/images/location/66/image-2.webp",
      "/images/location/66/image-3.webp",
      "/images/location/66/image-4.webp",
      "/images/location/66/image-5.webp",
    ],
  },
  {
    id: "67",
    locationName: "Cradle",
    locationNation: "Liber Ark",
    locationSearchTerms: ["Cradle", "Liber Ark"],
    wikiUrl: "https://falcom.wiki/wiki/Cradle",
    mapCoords: { x: 23.77, y: 70.31 },
    imageFilePaths: [
      "/images/location/67/image-1.webp",
      "/images/location/67/image-2.webp",
      "/images/location/67/image-3.webp",
      "/images/location/67/image-4.webp",
      "/images/location/67/image-5.webp",
    ],
  },
  {
    id: "68",
    locationName: "Erbe Scenic Route",
    locationNation: "Liberl",
    locationSearchTerms: ["Scenic", "Route", "Erbe", "Grancel"],
    wikiUrl: "https://falcom.wiki/wiki/Erbe_Scenic_Route",
    mapCoords: { x: 25.77, y: 72.81 },
    imageFilePaths: [
      "/images/location/68/image-1.webp",
      "/images/location/68/image-2.webp",
      "/images/location/68/image-3.webp",
      "/images/location/68/image-4.webp",
      "/images/location/68/image-5.webp",
    ],
  },
  {
    id: "69",
    locationName: "Esmelas Tower",
    locationNation: "Liberl",
    locationSearchTerms: ["Tower", "Esmelas", "Rolent"],
    wikiUrl: "https://falcom.wiki/wiki/Esmelas_Tower",
    mapCoords: { x: 28.02, y: 67.45 },
    imageFilePaths: [
      "/images/location/69/image-1.webp",
      "/images/location/69/image-2.webp",
      "/images/location/69/image-3.webp",
      "/images/location/69/image-4.webp",
      "/images/location/69/image-5.webp",
    ],
  },
  {
    id: "70",
    locationName: "Factoria",
    locationNation: "Liber Ark",
    locationSearchTerms: ["Factoria", "Factory", "Liber Ark"],
    wikiUrl: "https://falcom.wiki/wiki/Factoria",
    mapCoords: { x: 23.77, y: 70.31 },
    imageFilePaths: [
      "/images/location/70/image-1.webp",
      "/images/location/70/image-2.webp",
      "/images/location/70/image-3.webp",
      "/images/location/70/image-4.webp",
      "/images/location/70/image-5.webp",
    ],
  },
  {
    id: "71",
    locationName: "Grancel Sewers",
    locationNation: "Liberl",
    locationSearchTerms: ["Sewers", "Grancel"],
    wikiUrl: "https://falcom.wiki/wiki/Grancel_Sewers",
    mapCoords: { x: 25.29, y: 71.49 },
    imageFilePaths: [
      "/images/location/71/image-1.webp",
      "/images/location/71/image-2.webp",
      "/images/location/71/image-3.webp",
      "/images/location/71/image-4.webp",
      "/images/location/71/image-5.webp",
    ],
  },
  {
    id: "72",
    locationName: "Grimsel Fortress",
    locationNation: "Leman",
    locationSearchTerms: ["Fortress", "Grimsel", "Le Locle"],
    wikiUrl: "https://falcom.wiki/wiki/Grimsel_Fortress",
    mapCoords: { x: 53.28, y: 19.61 },
    imageFilePaths: [
      "/images/location/72/image-1.webp",
      "/images/location/72/image-2.webp",
      "/images/location/72/image-3.webp",
      "/images/location/72/image-4.webp",
      "/images/location/72/image-5.webp",
    ],
  },
  {
    id: "73",
    locationName: "Le Locle Guild Lodge",
    locationNation: "Leman",
    locationSearchTerms: ["Guild", "Lodge", "Le Locle"],
    wikiUrl: "https://falcom.wiki/wiki/Le_Locle_Guild_Lodge",
    mapCoords: { x: 53.28, y: 19.61 },
    imageFilePaths: [
      "/images/location/73/image-1.webp",
      "/images/location/73/image-2.webp",
      "/images/location/73/image-3.webp",
      "/images/location/73/image-4.webp",
      "/images/location/73/image-5.webp",
    ],
  },
  {
    id: "74",
    locationName: "Haken Gate",
    locationNation: "Liberl",
    locationSearchTerms: ["Gate", "Haken", "Bose"],
    wikiUrl: "https://falcom.wiki/wiki/Haken_Gate",
    mapCoords: { x: 22.99, y: 62.79 },
    imageFilePaths: [
      "/images/location/74/image-1.webp",
      "/images/location/74/image-2.webp",
      "/images/location/74/image-3.webp",
      "/images/location/74/image-4.webp",
      "/images/location/74/image-5.webp",
    ],
  },
  {
    id: "75",
    locationName: "Lakeside Laboratory",
    locationNation: "Liberl",
    locationSearchTerms: ["Laboratory", "Lakeside", "Liberl"],
    wikiUrl: "https://falcom.wiki/wiki/Lakeside_Laboratory",
    mapCoords: { x: 22.69, y: 69.19 },
    imageFilePaths: [
      "/images/location/75/image-1.webp",
      "/images/location/75/image-2.webp",
      "/images/location/75/image-3.webp",
      "/images/location/75/image-4.webp",
      "/images/location/75/image-5.webp",
    ],
  },
  {
    id: "76",
    locationName: "Leiston Fortress",
    locationNation: "Liberl",
    locationSearchTerms: ["Fortress", "Leiston", "Zeiss"],
    wikiUrl: "https://falcom.wiki/wiki/Leiston_Fortress",
    mapCoords: { x: 23.6, y: 72.4 },
    imageFilePaths: [
      "/images/location/76/image-1.webp",
      "/images/location/76/image-2.webp",
      "/images/location/76/image-3.webp",
      "/images/location/76/image-4.webp",
      "/images/location/76/image-5.webp",
    ],
  },
  {
    id: "77",
    locationName: "Malga Mine",
    locationNation: "Liberl",
    locationSearchTerms: ["Mine", "Malga", "Rolent"],
    wikiUrl: "https://falcom.wiki/wiki/Malga_Mine",
    mapCoords: { x: 28.72, y: 65.78 },
    imageFilePaths: [
      "/images/location/77/image-1.webp",
      "/images/location/77/image-2.webp",
      "/images/location/77/image-3.webp",
      "/images/location/77/image-4.webp",
      "/images/location/77/image-5.webp",
    ],
  },
  {
    id: "78",
    locationName: "Mercia Orphanage",
    locationNation: "Liberl",
    locationSearchTerms: ["Orphanage", "Mercia", "Ruan"],
    wikiUrl: "https://falcom.wiki/wiki/Mercia_Orphanage",
    mapCoords: { x: 18.3, y: 70.03 },
    imageFilePaths: [
      "/images/location/78/image-1.webp",
      "/images/location/78/image-2.webp",
      "/images/location/78/image-3.webp",
      "/images/location/78/image-4.webp",
      "/images/location/78/image-5.webp",
    ],
  },
  {
    id: "79",
    locationName: "Ravennue Mine",
    locationNation: "Liberl",
    locationSearchTerms: ["Mine", "Ravennue", "Bose"],
    wikiUrl: "https://falcom.wiki/wiki/Ravennue_Mine",
    mapCoords: { x: 21.25, y: 64.74 },
    imageFilePaths: [
      "/images/location/79/image-1.webp",
      "/images/location/79/image-2.webp",
      "/images/location/79/image-3.webp",
      "/images/location/79/image-4.webp",
      "/images/location/79/image-5.webp",
    ],
  },
  {
    id: "80",
    locationName: "Saint-Croix Forest",
    locationNation: "Leman",
    locationSearchTerms: ["Forest", "Saint-Croix", "Le Locle"],
    wikiUrl: "https://falcom.wiki/wiki/Saint-Croix_Forest",
    mapCoords: { x: 53.28, y: 19.61 },
    imageFilePaths: [
      "/images/location/80/image-1.webp",
      "/images/location/80/image-2.webp",
      "/images/location/80/image-3.webp",
      "/images/location/80/image-4.webp",
      "/images/location/80/image-5.webp",
    ],
  },
  {
    id: "81",
    locationName: "Sapphirl Tower",
    locationNation: "Liberl",
    locationSearchTerms: ["Tower", "Sapphirl", "Ruan"],
    wikiUrl: "https://falcom.wiki/wiki/Sapphirl_Tower",
    mapCoords: { x: 20.21, y: 74.07 },
    imageFilePaths: [
      "/images/location/81/image-1.webp",
      "/images/location/81/image-2.webp",
      "/images/location/81/image-3.webp",
      "/images/location/81/image-4.webp",
      "/images/location/81/image-5.webp",
    ],
  },
  {
    id: "82",
    locationName: "Sky Bandit's Hideout",
    locationNation: "Liberl",
    locationSearchTerms: ["Hideout", "Sky Bandit", "Bose"],
    wikiUrl: "https://falcom.wiki/wiki/Sky_Bandit%27s_Hideout",
    mapCoords: { x: 25.98, y: 63.76 },
    imageFilePaths: [
      "/images/location/82/image-1.webp",
      "/images/location/82/image-2.webp",
      "/images/location/82/image-3.webp",
      "/images/location/82/image-4.webp",
      "/images/location/82/image-5.webp",
    ],
  },
  {
    id: "83",
    locationName: "Varenne Lighthouse",
    locationNation: "Liberl",
    locationSearchTerms: ["Lighthouse", "Varenne", "Ruan"],
    wikiUrl: "https://falcom.wiki/wiki/Varenne_Lighthouse",
    mapCoords: { x: 17.87, y: 73.09 },
    imageFilePaths: [
      "/images/location/83/image-1.webp",
      "/images/location/83/image-2.webp",
      "/images/location/83/image-3.webp",
      "/images/location/83/image-4.webp",
      "/images/location/83/image-5.webp",
    ],
  },
  {
    id: "84",
    locationName: "Air Letten",
    locationNation: "Liberl",
    locationSearchTerms: ["Letten", "Air", "Ruan"],
    wikiUrl: "https://falcom.wiki/wiki/Air_Letten",
    mapCoords: { x: 21.17, y: 74.76 },
    imageFilePaths: [
      "/images/location/84/image-1.webp",
      "/images/location/84/image-2.webp",
      "/images/location/84/image-3.webp",
      "/images/location/84/image-4.webp",
      "/images/location/84/image-5.webp",
    ],
  },
  {
    id: "85",
    locationName: "Erbe Royal Villa",
    locationNation: "Liberl",
    locationSearchTerms: ["Villa", "Erbe", "Royal", "Grancel"],
    wikiUrl: "https://falcom.wiki/wiki/Erbe_Royal_Villa",
    mapCoords: { x: 26.33, y: 72.4 },
    imageFilePaths: [
      "/images/location/85/image-1.webp",
      "/images/location/85/image-2.webp",
      "/images/location/85/image-3.webp",
      "/images/location/85/image-4.webp",
      "/images/location/85/image-5.webp",
    ],
  },
  {
    id: "86",
    locationName: "Limestone Cave",
    locationNation: "Liberl",
    locationSearchTerms: ["Cave", "Limestone", "Zeiss"],
    wikiUrl: "https://falcom.wiki/wiki/Limestone_Cave",
    mapCoords: { x: 22.42, y: 74.07 },
    imageFilePaths: [
      "/images/location/86/image-1.webp",
      "/images/location/86/image-2.webp",
      "/images/location/86/image-3.webp",
      "/images/location/86/image-4.webp",
      "/images/location/86/image-5.webp",
    ],
  },
];
// 188 in array as of 05.25
export const TRIVIA = [
  {
    id: 1,
    question: "Who is the first user of the Vander style?",
    options: [
      "Zechs Vander",
      "Mueller Vander",
      "Roland Vander",
      "Matteus Vander",
      "Kurt Vander",
      "Werner Vander",
    ],
    answer: "Roland Vander",
    submittedBy: "New Creator",
  },
  {
    id: 2,
    question:
      "What character has had the longest streak of games where they were playable until now?",
    options: [
      "Lloyd Bannings",
      "Rean Schwarzer",
      "Tita Russell",
      "Estelle Bright",
      "Fie Claussell",
      "Renne Bright",
    ],
    answer: "Fie Claussell",
    submittedBy: "Original Creator",
  },
  {
    id: 3,
    question: "How many Memory Doors are there in Trails in the Sky the 3rd?",
    options: ["10", "15", "20", "25", "30", "35"],
    answer: "25",
    submittedBy: "Code_Name_Shiva",
  },
  {
    id: 4,
    question:
      "Which character's breasts get bigger every single time she appears in the series in a new game?",
    options: [
      "Emma Millstein",
      "Scherazard Harvey",
      "Rixia Mao",
      "Elie MacDowell",
      "Shirley Orlando",
      "Aurelia Le Guin",
    ],
    answer: "Rixia Mao",
    submittedBy: "sossa",
  },
  {
    id: 5,
    question:
      "One non-Class VII branch campus student gets their own Daydream in Reverie, who is it?",
    options: ["Wayne", "Jessica", "Stark", "Sidney", "Freddy", "Gustaf"],
    answer: "Freddy",
    submittedBy: "KurtJuna",
  },
  {
    id: 6,
    question:
      "Which of the following islands is the actual location of the D:G cult lodge, Paradise?",
    options: [
      "Bryonia Island",
      "Altair Island",
      "Epstein Island",
      "Nemeth Island",
      "Remnant Island",
      "Mishy Island",
    ],
    answer: "Nemeth Island",
    submittedBy: "Asy",
  },
  {
    id: 7,
    question:
      "Which Trails character has a doppelgänger counterpart in another Nihon Falcom title?",
    options: [
      "Alisa Reinford",
      "Rean Schwarzer",
      "Towa Herschel",
      "Altina Orion",
      "Fie Claussell",
      "Crow Armbrust",
    ],
    answer: "Towa Herschel",
    submittedBy: "Xaven Cross",
  },
  {
    id: 8,
    question: "Who is the last member to join the SSS in Zero?",
    options: [
      "Wazy Hemisphere",
      "Noel Seeker",
      "Dudley",
      "Zeit",
      "Rixia Mao",
      "Randy Orlando",
    ],
    answer: "Zeit",
    submittedBy: "Original Creator",
  },
  {
    id: 9,
    question:
      "In Trails in the Sky FC, Lighthouse keeper Mr. Vogt compares Estelle and Joshua to a certain bracer. What is the name of this bracer?",
    options: [
      "Zin Vathek",
      "Arios MacLaine",
      "Cassius Bright",
      "Scherazard Harvey",
      "Agate Crosner",
      "Anton",
    ],
    answer: "Cassius Bright",
    submittedBy: "Oğuzhan G.",
  },
  {
    id: 10,
    question: "Who is the first member of Class VII to meet Rean Schwarzer?",
    options: [
      "Elliot Craig",
      "Gaius Worzel",
      "Laura S. Arseid",
      "Alisa Reinford",
      "Machias Regnitz",
      "Jusis Albarea",
    ],
    answer: "Alisa Reinford",
    submittedBy: "> Souad <",
  },
  {
    id: 11,
    question:
      "In Trails in the Sky FC, the Grancelan NPC named Kitty shares her 'Guide to Savoring Delicious Tea.' How many rules does her guide contain?",
    options: ["3", "4", "5", "7", "10", "12"],
    answer: "7",
    submittedBy: "Oğuzhan G.",
  },
  {
    id: 12,
    question:
      "Fill the blank: When an enemy suffers the Break status condition in Cold Steel 3 and later games, they lose all their _____.",
    options: ["HP", "EP", "CP", "Items", "Buffs", "AT Bonus"],
    answer: "Buffs",
    submittedBy: "RaIshtar",
  },
  {
    id: 13,
    question:
      "What was Kevin Graham's alias as the No. 5 Dominion before the events of Sky 3rd?",
    options: [
      "Thousand Armed",
      "The Stigma",
      "Heretic Hunter",
      "Carnelia",
      "Roaring Lion",
      "Shadow Striker",
    ],
    answer: "Heretic Hunter",
    submittedBy: "Klaust",
  },
  {
    id: 14,
    question:
      "How many Phantom Thief B sidequests are there in Trails in the Sky SC?",
    options: ["2", "3", "4", "5", "6", "7"],
    answer: "4",
    submittedBy: "DemiFly",
  },
  {
    id: 15,
    question: "In Cold Steel 1, whose unique dish is the White Cookie?",
    options: [
      "Emma Millstein",
      "Elliot Craig",
      "Laura S. Arseid",
      "Rean Schwarzer",
      "Alisa Reinford",
      "Fie Claussell",
    ],
    answer: "Alisa Reinford",
    submittedBy: "TyberiusCXV",
  },
  {
    id: 16,
    question:
      "What was the name of Ouroboros's first plan in Trails in the Sky?",
    options: [
      "The Phantasmal Blaze Plan",
      "The Gospel Plan",
      "The Sept-Terrion Plan",
      "The Orpheus Final Plan",
      "The Great Twilight",
      "The Ouroboros Plan",
    ],
    answer: "The Gospel Plan",
    submittedBy: "nisshisora",
  },
  {
    id: 17,
    question:
      "What does the name of Rean's S-Craft Breaking Dawn change to while using Spirit Unification in Trails into Reverie?",
    options: [
      "Luminous Zenith",
      "Nebulous Zenith",
      "Twilight Zenith",
      "Ashen Zenith",
      "Void Zenith",
      "Abyssal Zenith",
    ],
    answer: "Nebulous Zenith",
    submittedBy: "Xaven Cross",
  },
  {
    id: 18,
    question:
      "Which rank does Bleublanc claim when first meeting Class VII in Trails Of Cold Steel 1?",
    options: ["Duke", "Marquis", "Lord", "Baron", "Count", "Viscount"],
    answer: "Baron",
    submittedBy: "IvyLeather",
  },
  {
    id: 19,
    question: "Who lived in room 203 in the Class VII Dormitory?",
    options: [
      "Machias Regnitz",
      "Jusis Albarea",
      "Elliot Craig",
      "Gaius Worzel",
      "Rean Schwarzer",
      "Crow Armbrust",
    ],
    answer: "Jusis Albarea",
    submittedBy: "poperboy",
  },
  {
    id: 20,
    question:
      "What was the name of the airship hijacked by the Capua family in Trails in the Sky FC?",
    options: ["Arseille", "Lusitania", "Bobcat", "Linde", "Cecilia", "Elnops"],
    answer: "Linde",
    submittedBy: "Blake",
  },
  {
    id: 21,
    question:
      "What is the name of the stuffed animal owned by Fran Seeker, the ever-reliable receptionist at the Crossbell Police Department?",
    options: ["Mishy", "Pecky", "Banban", "Pom", "Cerberus", "Colin"],
    answer: "Banban",
    submittedBy: "Oğuzhan G.",
  },
  {
    id: 22,
    question:
      "How many different model Panzer Soldats are there in the series?",
    options: ["5", "7", "9", "11", "13", "15"],
    answer: "11",
    submittedBy: "Original Creator",
  },
  {
    id: 23,
    question:
      "Of what element are the Impede quartz in the games Trails from Zero and Trails to Azure?",
    options: ["Space", "Earth", "Mirage", "Wind", "Time", "Fire"],
    answer: "Time",
    submittedBy: "Siphons57",
  },
  {
    id: 24,
    question: "What is the Enforcer number for Walter? (In Roman numerals)",
    options: ["VI", "VII", "VIII", "IX", "X", "XI"],
    answer: "VIII",
    submittedBy: "KurtJuna",
  },
  {
    id: 25,
    question:
      "What is the name of the combat orbment used in the Crossbell games?",
    options: ["ARCUS", "Orbment", "RAMDA", "Enigma", "Xipha", "Artes"],
    answer: "Enigma",
    submittedBy: "GkStelar",
  },
  {
    id: 26,
    question:
      "In the finale of Trails In The Sky, what alias did Julia Schwarz use while in hiding?",
    options: [
      "Sister Margaret",
      "Sister Ellen",
      "Sister Lily",
      "Sister Rosine",
      "Sister Ries",
      "Sister Mary",
    ],
    answer: "Sister Ellen",
    submittedBy: "IvyLeather",
  },
  {
    id: 27,
    question:
      "What is the name of the only damage dealing mirage art in Trails in the Sky SC?",
    options: [
      "Ascension",
      "Chaos Brand",
      "Phantom Pain",
      "Arch Drain",
      "Silver Thorn",
      "Galion Tower",
    ],
    answer: "Silver Thorn",
    submittedBy: "Original Creator",
  },
  {
    id: 28,
    question: "What was the fifth Trails game to be localized in the West?",
    options: [
      "Trails of Cold Steel 2",
      "Trails to Azure",
      "Trails from Zero",
      "Trails in the Sky the 3rd",
      "Trails of Cold Steel",
      "Trails of Cold Steel 3",
    ],
    answer: "Trails in the Sky the 3rd",
    submittedBy: "Swanima",
  },
  {
    id: 29,
    question:
      "Which color are Lapis Rosenberg's panties in Kai no Kiseki / Farewell, O Zemuria?",
    options: ["White", "Red", "Black", "Pink", "Blue", "Green"],
    answer: "White",
    submittedBy: "Original Creator",
  },
  {
    id: 30,
    question: "What does 'D' stand for in the name of the D∴G cult?",
    options: ["Diabolos", "Deity", "Demiourgos", "Dunan", "Demon", "Dark"],
    answer: "Demiourgos",
    submittedBy: "ShardZin1048596",
  },
  {
    id: 31,
    question: "What weapon does Estelle Bright use?",
    options: [
      "Tonfa",
      "Twin Swords",
      "Bo Staff",
      "Halberd",
      "Greatsword",
      "Whip",
    ],
    answer: "Bo Staff",
    submittedBy: "Original Creator",
  },
  {
    id: 32,
    question: "What is the title of Valimar?",
    options: [
      "The Azure Knight",
      "The Palatinate Knight",
      "The Vermillion Knight",
      "The Silver Knight",
      "The Ashen Knight",
      "The Ebon Knight",
    ],
    answer: "The Ashen Knight",
    submittedBy: "Original Creator",
  },
  {
    id: 33,
    question:
      "Trails to Azure's rerelease adds a scene where Towa is talking to another person on her ARCUS. Who is she talking to?",
    options: [
      "Rean Schwarzer",
      "Angelica Rogner",
      "Giliath Osborne",
      "George Nome",
      "Crow Armbrust",
      "Vita Clotilde",
    ],
    answer: "Angelica Rogner",
    submittedBy: "ShardZin7777777",
  },
  {
    id: 34,
    question:
      "What school of swordsmanship does Shizuna Rem Misurugi practice?",
    options: [
      "Eight Leaves One Blade",
      "Taito Style",
      "Vander Style",
      "Black God One Blade",
      "Arseid Style",
      "Court Fencing",
    ],
    answer: "Black God One Blade",
    submittedBy: "Timmie and Sky",
  },
  {
    id: 35,
    question:
      "What was the name of Dieter Crois' replacement to the CGF when Crossbell declared its independence?",
    options: [
      "Crossbell Guardian Force",
      "Crossbell State Army",
      "Crossbell Liberation Front",
      "Crossbell Military Police",
      "Crossbell Defense Force",
      "Crossbell Security Guard",
    ],
    answer: "Crossbell Defense Force",
    submittedBy: "ChaosEater",
  },
  {
    id: 36,
    question:
      "Which playable character can inflict status effects with normal attacks regardless of their quartz and equipment?",
    options: [
      "Joshua Bright",
      "Fie Claussell",
      "Kurt Vander",
      "Swin Abel",
      "Renne Bright",
      "Crow Armbrust",
    ],
    answer: "Swin Abel",
    submittedBy: "ShardZin39",
  },
  {
    id: 37,
    question:
      "Of the Original Class VII, how many of them were not fought as bosses at some point during Trails of Cold Steel 1?",
    options: ["0", "1", "2", "3", "4", "5"],
    answer: "0",
    submittedBy: "hb",
  },
  {
    id: 38,
    question: "Which character uses the alias 'Mille Chaton'?",
    options: [
      "Bleublanc",
      "Renne Bright",
      "Mariabell Crois",
      "Vita Clotilde",
      "Anton",
      "Lucrezia Isselee",
    ],
    answer: "Renne Bright",
    submittedBy: "ShardZin2053",
  },
  {
    id: 39,
    question:
      "When the Divine Knight Testa-Rossa was cursed because of the miasma from the Dark Dragon, what title did the Demon receive?",
    options: [
      "Vermillion Calamity",
      "Crimson Curse",
      "Blood Knight",
      "Scarlet Fiend",
      "Vermillion Apocalypse",
      "Ruby Disaster",
    ],
    answer: "Vermillion Apocalypse",
    submittedBy: "Original Creator",
  },
  {
    id: 40,
    question:
      "What is the pseudonym used to refer to the character based on Toval Randonneur in the novel series Carnelia?",
    options: ["Tom", "Trevor", "Toby", "Troy", "Toval", "Anton"],
    answer: "Toby",
    submittedBy: "erika",
  },
  {
    id: 41,
    question:
      "What is the name of Bleublanc's technique where he immobilizes opponents by throwing daggers at their shadow?",
    options: [
      "Shadow Stitch",
      "Dark Chains",
      "Phantom Bind",
      "Shadow Weaving",
      "Illusion Pin",
      "Midnight Hold",
    ],
    answer: "Shadow Weaving",
    submittedBy: "ShardZin666",
  },
  {
    id: 42,
    question: "What color is Fie Claussell’s scarf in Trails of Cold Steel 2?",
    options: ["Red", "White", "Blue", "Green", "Yellow", "Black"],
    answer: "Green",
    submittedBy: "Code_Name_Shiva",
  },
  {
    id: 43,
    question: "Where is Thors Military Academy's main campus located?",
    options: ["Leeves", "Heimdallr", "Bareahard", "Trista", "Roer", "Legram"],
    answer: "Trista",
    submittedBy: "Original Creator",
  },
  {
    id: 44,
    question: "What element are Joshua's restricted slots in Sky?",
    options: ["Space", "Fire", "Mirage", "Wind", "Time", "Water"],
    answer: "Time",
    submittedBy: "poperboy",
  },
  {
    id: 45,
    question:
      "Who stole Van's limited edition pastry and then later returned with a normal inferior edition of the same pastry?",
    options: [
      "Anton",
      "Feri Al-Fayed",
      "Shizuna Rem Misurugi",
      "Elaine Auclair",
      "Renne Bright",
      "Judith Lanster",
    ],
    answer: "Shizuna Rem Misurugi",
    submittedBy: "hiromell",
  },
  {
    id: 46,
    question:
      "What kind of liquor do Randy and Lloyd drink during Randy's Azure bonding event?",
    options: ["Whiskey", "Vodka", "Wine", "Beer", "Rum", "Gin"],
    answer: "Rum",
    submittedBy: "Grey",
  },
  {
    id: 47,
    question:
      "How many games in the franchise feature a Gralsritter Merkabah ship?",
    options: ["2", "3", "4", "5", "6", "7"],
    answer: "4",
    submittedBy: "Emilia",
  },
  {
    id: 48,
    question: "Who invented the Manway method?",
    options: [
      "Makarov",
      "Vandyck",
      "Beatrix",
      "Neithardt",
      "Anton",
      "Heinrich",
    ],
    answer: "Neithardt",
    submittedBy: "Arondight",
  },
  {
    id: 49,
    question:
      "Which Orbal Art has no cast time and no delay after use? (Lost Arts do not count)",
    options: [
      "Chrono Down",
      "Tearal",
      "Accelerate",
      "Crescent Shell",
      "Chrono Burst",
      "Zodiac",
    ],
    answer: "Chrono Burst",
    submittedBy: "ShardZin98765",
  },
  {
    id: 50,
    question: "Who is the first person seen in the games using combat shells?",
    options: [
      "Millium Orion",
      "Ouroboros Grunt",
      "Altina Orion",
      "Novartis",
      "Georg Weissman",
      "Campanella",
    ],
    answer: "Georg Weissman",
    submittedBy: "Verols",
  },
  {
    id: 51,
    question:
      "Who of these is not a playable character in Trails in the Sky SC AND Trails in the Sky the 3rd.",
    options: ["Anelace", "Kurt", "Grant", "Renne", "Richard", "Julia"],
    answer: "Grant",
    submittedBy: "Cyrus",
  },
  {
    id: 52,
    question:
      "This character graduated from a private school, worked for the government and an international organization, wrote a book, and commanded a military squad. Who is it?",
    options: [
      "Kevin Graham",
      "Lechter Arundel",
      "Rufus Albarea",
      "Gilbert Stein",
      "Mueller Vander",
      "Anton",
    ],
    answer: "Gilbert Stein",
    submittedBy: "ShardZin404",
  },
  {
    id: 53,
    question: "Which character is the most passionate about music.",
    options: [
      "Elliot Craig",
      "Mint Braun",
      "Claire Rieveldt",
      "Wallace Bardias",
      "Aurelia Le Guin",
      "Anton",
    ],
    answer: "Elliot Craig",
    submittedBy: "Original Creator",
  },
  {
    id: 54,
    question:
      "What is the term given to areas in the series that exist in a separate dimension to Zemuria?",
    options: [
      "Phantasma",
      "The Beyond",
      "Phase Space",
      "Higher Dimension",
      "Gehenna",
      "Astral Plane",
    ],
    answer: "Phase Space",
    submittedBy: "Original Creator",
  },
  {
    id: 55,
    question:
      "How many characters are playable in the true final boss fight in Cold Steel 4?",
    options: ["38", "39", "40", "41", "42", "43"],
    answer: "41",
    submittedBy: "Original Creator",
  },
  {
    id: 56,
    question: "What is the name of the ship used by the Red Constellation?",
    options: [
      "Gargantua",
      "Courageous",
      "Glorious",
      "Beowulf",
      "Pantagruel",
      "Anton",
    ],
    answer: "Beowulf",
    submittedBy: "Original Creator",
  },
  {
    id: 57,
    question:
      "What's the name of the lady who gives Lloyd lemonade on the train at the beginning of Trails from Zero?",
    options: ["Cecile", "Marte", "Parla", "Clarice", "Shanshan", "Anton"],
    answer: "Parla",
    submittedBy: "poperboy",
  },
  {
    id: 58,
    question:
      "Which character had the longest streak of games they've appeared in including as NPC (in a row)?",
    options: [
      "Anton",
      "Bleublanc",
      "Olivier Lenheim",
      "Campanella",
      "Lechter Arundel",
      "Lloyd Bannings",
    ],
    answer: "Lechter Arundel",
    submittedBy: "Original Creator",
  },
  {
    id: 59,
    question: "Why does Aurelia Le Guin wear glasses?",
    options: [
      "She is farsighted",
      "For fashion",
      "To look intimidating",
      "To suppress her vision",
      "To hide a scar",
      "A gift from Victor",
    ],
    answer: "To suppress her vision",
    submittedBy: "Xaven Cross",
  },
  {
    id: 60,
    question:
      "Riddle me this: The first one came back from the dead, the second one never died, and the third one died twice. Who is this about?",
    options: ["V", "C", "W", "S", "G", "Anton"],
    answer: "C",
    submittedBy: "ShardZin111",
  },
  {
    id: 61,
    question: "Who hosts the 2nd iteration of 'Who Wants to be a Mirannaire?'",
    options: ["Campanella", "Anton", "Margarita", "Beryl", "Ferris", "Linde"],
    answer: "Beryl",
    submittedBy: "Mixwatcher265",
  },
  {
    id: 62,
    question:
      "What was the identity of Kevin Graham's first target, after he took up the position of 'Heretic Hunter'?",
    options: [
      "Joachim Guenter",
      "Wazy Hemisphere",
      "Marcel Nielsen",
      "Weissmann",
      "Bishop Owen",
      "Anton",
    ],
    answer: "Bishop Owen",
    submittedBy: "Kate/X-pert74",
  },
  {
    id: 63,
    question: "What craft in Cold Steel 1 delays the enemy the most?",
    options: [
      "Arc Slash",
      "Gale",
      "Megaton Press",
      "Autumn Leaf Cutter",
      "Howling Bullet",
      "Impede Blade",
    ],
    answer: "Megaton Press",
    submittedBy: "Original Creator",
  },
  {
    id: 64,
    question:
      "Which Master did Lieutenant General Wallace Bardias train under?",
    options: [
      "Aurelia Le Guin",
      "Victor S. Arseid",
      "Matteus Vander",
      "Father Barkhorn",
      "Anton",
      "Lianne Sandlot",
    ],
    answer: "Father Barkhorn",
    submittedBy: "Gen Boss Jr",
  },
  {
    id: 65,
    question:
      "Who is the first vestige whose identity gets uncovered in Kai no Kiseki?",
    options: ["Giacomo", "Anton", "Tyrant", "Aida", "Hamilton", "Melchior"],
    answer: "Giacomo",
    submittedBy: "masked instigator",
  },
  {
    id: 66,
    question:
      "In Trails of Cold Steel 4, there is a young girl named Noa who lives in the hidden village of Eryn. What is the name of her familiar?",
    options: ["Fenrir", "Siegfried", "Thor", "Loki", "Odin", "Hati"],
    answer: "Loki",
    submittedBy: "Code_Name_Shiva",
  },
  {
    id: 67,
    question:
      "Besides Rean Schwarzer, who is the other character that can use Spirit Unification?",
    options: [
      "Aurelia Le Guin",
      "Arios MacLaine",
      "Cassius Bright",
      "Anton",
      "Shizuna Rem Misurugi",
      "Victor S. Arseid",
    ],
    answer: "Shizuna Rem Misurugi",
    submittedBy: "Original Creator",
  },
  {
    id: 68,
    question: "Which character can use the S-Craft 'Eternal Ruination'?",
    options: [
      "Jusis Albarea",
      "Giliath Osborne",
      "Crow Armbrust",
      "Rufus Albarea",
      "Anton",
      "Cedric Reise Arnor",
    ],
    answer: "Rufus Albarea",
    submittedBy: "ShardZin12345",
  },
  {
    id: 69,
    question: "What year was the Liberl Kingdom established?",
    options: ["S.100", "S.200", "S.300", "S.400", "S.500", "S.700"],
    answer: "S.300",
    submittedBy: "Original Creator",
  },
  {
    id: 70,
    question: "How do you spell the castle in Legram?",
    options: [
      "lohengrin",
      "loehingrin",
      "leohnngrin",
      "lehnognin",
      "lohgrnnin",
      "lohilngen",
    ],
    answer: "lohengrin",
    submittedBy: "poperboy",
  },
  {
    id: 71,
    question: "What is the age gap (in years) between Agate and Tita?",
    options: ["8", "10", "12", "14", "16", "18"],
    answer: "12",
    submittedBy: "Junkmaniac",
  },
  {
    id: 72,
    question:
      "In Trails to Azure, against what opponent does the Super Arrange version of Inevitable Struggle play?",
    options: [
      "Joachim Guenter",
      "Anton",
      "Yin",
      "Sigmund Orlando",
      "Arios MacLaine",
      "Ernest",
    ],
    answer: "Arios MacLaine",
    submittedBy: "nisshisora",
  },
  {
    id: 73,
    question: "How many S-rank bracers are on the Zemurian continent?",
    options: ["2", "3", "4", "5", "6", "7"],
    answer: "4",
    submittedBy: "Original Creator",
  },
  {
    id: 74,
    question:
      "How many Dominions of the Gralsritter were present during the events of Trails to Azure?",
    options: ["0", "1", "2", "3", "4", "5"],
    answer: "2",
    submittedBy: "Luxzio",
  },
  {
    id: 75,
    question: "Name the character Tio Plato is obsessed with.",
    options: ["Pom", "Mee-shee", "Pecky", "Mishy", "Mishette", "Anton"],
    answer: "Mishy",
    submittedBy: "Original Creator",
  },
  {
    id: 76,
    question:
      "What year of the Septian Calendar did the Orbal Revolution take place?",
    options: ["1100", "1120", "1150", "1170", "1180", "1200"],
    answer: "1150",
    submittedBy: "Original Creator",
  },
  {
    id: 77,
    question:
      "In Trails in the Sky FC, the art Earth Wall requires what elemental value among your quartz loadout?",
    options: ["2 Earth", "3 Earth", "4 Earth", "5 Earth", "6 Earth", "7 Earth"],
    answer: "4 Earth",
    submittedBy: "DemiFly",
  },
  {
    id: 78,
    question: "What is Rean Schwarzer's birthname?",
    options: [
      "Rean Teese",
      "Rean Vandal",
      "Rean Arnor",
      "Rean Schwarzer",
      "Rean Osborne",
      "Rean Sandlot",
    ],
    answer: "Rean Osborne",
    submittedBy: "New Creator",
  },
  {
    id: 79,
    question: "What does '∴' stand for in the name of the D∴G cult?",
    options: ["Trinity", "Truth", "Triangle", "Therefore", "Theos", "Tears"],
    answer: "Therefore",
    submittedBy: "New Creator",
  },
  {
    id: 80,
    question: "What does the 'S.' stand for in the name of the Arseid family?",
    options: ["Schwarzer", "Stahl", "Siegfried", "Silber", "Sandlot", "Sword"],
    answer: "Sandlot",
    submittedBy: "New Creator",
  },
  {
    id: 81,
    question:
      "What is the name of the second-in-command of the Eisenritter and Laura's ancestor?",
    options: [
      "Victor Arseid",
      "Shion Arseid",
      "Aurelia Arseid",
      "Lianne Arseid",
      "Roland Arseid",
      "Klaus Arseid",
    ],
    answer: "Shion Arseid",
    submittedBy: "New Creator",
  },
  {
    id: 82,
    question: "What is the name of Professor Schmidt's first disciple?",
    options: [
      "Gwyn Reinford",
      "Albert Russell",
      "George Nome",
      "Franz Reinford",
      "Towa Herschel",
      "Makarov",
    ],
    answer: "Franz Reinford",
    submittedBy: "New Creator",
  },
  {
    id: 83,
    question:
      "How many highest-level ranks/titles has Cassius Bright held at some point in his life as of Kai no Kiseki? (i.e. S-Rank Bracer etc.)",
    options: ["1", "2", "3", "4", "5", "6"],
    answer: "3",
    submittedBy: "New Creator",
  },
  {
    id: 84,
    question: "Who taught Cassius Bright how to use the Bo staff?",
    options: [
      "Zin Vathek",
      "Anton",
      "Yun Kafai",
      "Kilika Rouran",
      "Dan Russell",
      "Arios MacLaine",
    ],
    answer: "Dan Russell",
    submittedBy: "New Creator",
  },
  {
    id: 85,
    question: "What is the name of Juna's sister?",
    options: ["Ken", "Momo", "Towa", "Nana", "Yuna", "Sara"],
    answer: "Nana",
    submittedBy: "New Creator",
  },
  {
    id: 86,
    question: "Which pair isn't officially dating as of Kai no Kiseki?",
    options: [
      "Agate & Tita",
      "Kenneth & Annabelle",
      "Neithardt & Fiona",
      "Heathcliff & Mercedes",
      "Estelle & Joshua",
      "Nadia & Swin",
    ],
    answer: "Agate & Tita",
    submittedBy: "New Creator",
  },
  {
    id: 87,
    question: "The man who once led the Northern Jaegers was called ___?",
    options: [
      "Colonel Claussell",
      "Colonel Orlando",
      "Colonel Valestein",
      "Colonel Morgan",
      "Colonel Rossi",
      "Colonel Neithardt",
    ],
    answer: "Colonel Valestein",
    submittedBy: "New Creator",
  },
  {
    id: 88,
    question:
      "Which Jaeger Corps gets mentioned the most throughout the entire series?",
    options: [
      "Zephyr",
      "Red Constellation",
      "Nidhoggr",
      "Northern Jaegers",
      "Jester",
      "Kruga",
    ],
    answer: "Red Constellation",
    submittedBy: "New Creator",
  },
  {
    id: 89,
    question: "Who revealed his hidden identity in NG+ of Cold Steel 2?",
    options: [
      "Crow Armbrust",
      "Giliath Osborne",
      "Rufus Albarea",
      "Thomas Lysander",
      "George Nome",
      "Lechter Arundel",
    ],
    answer: "Thomas Lysander",
    submittedBy: "New Creator",
  },
  {
    id: 90,
    question: "In which game does the Eight Leaves School first get mentioned?",
    options: ["Sky FC", "Sky SC", "Sky 3rd", "Zero", "Azure", "CS1"],
    answer: "Sky 3rd",
    submittedBy: "New Creator",
  },
  {
    id: 91,
    question:
      "How many years has it been since Schera saw Luciola last when meeting again in SC?",
    options: ["8", "7", "10", "5", "4", "11"],
    answer: "8",
    submittedBy: "New Creator",
  },
  {
    id: 92,
    question:
      "Which character describes his innate ability as having a very good intuition/gut feeling?",
    options: [
      "Anton",
      "Musse Egret",
      "Campanella",
      "Lechter Arundel",
      "Claire Rieveldt",
      "Lloyd Bannings",
    ],
    answer: "Lechter Arundel",
    submittedBy: "New Creator",
  },
  {
    id: 93,
    question: 'What does "Testa-Rossa" mean when translated into English?',
    options: [
      "Red Demon",
      "Crimson King",
      "Red Head",
      "Burning Rose",
      "Scarlet Sword",
      "Blood Armor",
    ],
    answer: "Red Head",
    submittedBy: "New Creator",
  },
  {
    id: 94,
    question: "What is KeA's nickname?",
    options: [
      "Azure Child",
      "Mirage Child",
      "Zero Child",
      "Divine Child",
      "Star Child",
      "Child of Origin",
    ],
    answer: "Zero Child",
    submittedBy: "New Creator",
  },
  {
    id: 95,
    question:
      "How many people have taught Elise sword techniques according to her own words?",
    options: ["1", "2", "3", "4", "5", "6"],
    answer: "3",
    submittedBy: "New Creator",
  },
  {
    id: 96,
    question: "Which of these is in Leman State?",
    options: [
      "Leiston Fortress",
      "Garrelia Fortress",
      "Grimsel Fortress",
      "Juno Naval Fortress",
      "Aurochs Fort",
      "Bellguard Gate",
    ],
    answer: "Grimsel Fortress",
    submittedBy: "New Creator",
  },
  {
    id: 97,
    question: "Which of these cities has never been seen on screen?",
    options: ["Alster", "Armorica", "Ardent", "Altair", "Creil", "Parm"],
    answer: "Ardent",
    submittedBy: "New Creator",
  },
  {
    id: 98,
    question: "By which family was Leeves ruled in the past?",
    options: [
      "House Schwarzer",
      "House Arseid",
      "House Capua",
      "House Egret",
      "House Florald",
      "House Hyarms",
    ],
    answer: "House Capua",
    submittedBy: "New Creator",
  },
  {
    id: 99,
    question: "The Dis-Orders mechanic first made its debut in which game?",
    options: ["CS1", "CS2", "CS3", "CS4", "Reverie", "Daybreak"],
    answer: "CS4",
    submittedBy: "New Creator",
  },
  {
    id: 100,
    question: "What is the effect of the Scorpio Gem in Sky 3rd?",
    options: ["Impede 6", "Action 6", "Hit 6", "Cast 6", "Mind 6", "EP 6"],
    answer: "Impede 6",
    submittedBy: "New Creator",
  },
  {
    id: 101,
    question: "What is the name of Estelle's mother?",
    options: ["Theresa", "Karin", "Aina", "Lena", "Alicia", "Kasumi"],
    answer: "Lena",
    submittedBy: "New Creator",
  },
  {
    id: 102,
    question:
      "What bracer branch did Lugran work at as receptionist before working at the Bose branch?",
    options: ["Rolent", "Ruan", "Grancel", "Zeiss", "Le Locle", "Crossbell"],
    answer: "Grancel",
    submittedBy: "New Creator",
  },
  {
    id: 103,
    question: "What is the name of the Taito school's ex-master?",
    options: ["Kouga", "Tenkai", "Genzo", "Ryuga", "Shohaku", "Raizo"],
    answer: "Ryuga",
    submittedBy: "New Creator",
  },
  {
    id: 104,
    question: "How many times per day does the Langland Bridge get raised?",
    options: ["1 time", "2 times", "3 times", "4 times", "5 times", "6 times"],
    answer: "3 times",
    submittedBy: "New Creator",
  },
  {
    id: 105,
    question: "What is the name of the final boss in CS2?",
    options: [
      "End of Vermillion",
      "Loa Erebonius",
      "Loa Luciferia",
      "Vermillion Apocalypse",
      "Ishmelga",
      "Zoro-Agruga",
    ],
    answer: "Loa Luciferia",
    submittedBy: "New Creator",
  },
  {
    id: 106,
    question:
      "How many Enforcers do we know of dead or alive as of Kai no Kiseki?",
    options: ["14", "15", "16", "17", "18", "19"],
    answer: "16",
    submittedBy: "New Creator",
  },
  {
    id: 107,
    question: "How many Enforcers are in ACTIVE duty as of Kai no Kiseki?",
    options: ["8", "9", "10", "11", "12", "13"],
    answer: "10",
    submittedBy: "New Creator",
  },
  {
    id: 108,
    question:
      "Which Enforcer does Kondo like the least even though he created the character?",
    options: [
      "Campanella",
      "McBurn",
      "Luciola",
      "Walter",
      "Bleublanc",
      "Shirley",
    ],
    answer: "Bleublanc",
    submittedBy: "New Creator",
  },
  {
    id: 109,
    question: "How many women did Anton get rejected by as far as we know?",
    options: ["2", "3", "4", "5", "6", "7"],
    answer: "4",
    submittedBy: "New Creator",
  },
  {
    id: 110,
    question: "What is the name of the fishing group in Liberl?",
    options: [
      "Angler's Guild",
      "Liberl Fishing Association",
      "Fisherman's Guild",
      "Lakelord Society",
      "Zemurian Fishing Club",
      "Fish & Rod Society",
    ],
    answer: "Fisherman's Guild",
    submittedBy: "New Creator",
  },
  {
    id: 111,
    question:
      "Why did Alan, who works at Rolent's landing port, rate Kloe 100 points?",
    options: [
      "Her polite manners",
      "Her beautiful smile",
      "Her pet falcon",
      "Her Jenis uniform",
      "Her immaculate hair",
      "Her noble aura",
    ],
    answer: "Her Jenis uniform",
    submittedBy: "New Creator",
  },
  {
    id: 112,
    question:
      "What was the airship that Estelle and Anelace used to get to Le Locle in Leman?",
    options: ["Arseille", "Linde", "Cecilia", "Gretna", "Bobcat", "Lusitania"],
    answer: "Gretna",
    submittedBy: "New Creator",
  },
  {
    id: 113,
    question: "In what game does Crossbell first get mentioned?",
    options: ["Sky FC", "Sky SC", "Sky 3rd", "Zero", "CS1", "CS2"],
    answer: "Sky SC",
    submittedBy: "New Creator",
  },
  {
    id: 114,
    question:
      "What vintage was the Grand Chardonnay that Olivier drank in Chapter 1 of Sky FC?",
    options: ["1181", "1182", "1183", "1184", "1185", "1186"],
    answer: "1183",
    submittedBy: "New Creator",
  },
  {
    id: 115,
    question:
      "What are the two courses people can study at Jenis Royal Academy?",
    options: [
      "Military Arts & Political Science",
      "Orbal Sciences & Humanities",
      "Social Studies & Natural Sciences",
      "Liberal Arts & Applied Engineering",
      "Economics & International Law",
      "General Education & Advanced Tactics",
    ],
    answer: "Social Studies & Natural Sciences",
    submittedBy: "New Creator",
  },
  {
    id: 116,
    question: "Where is the family residence of General Morgan located?",
    options: [
      "East block of Grancel City",
      "Leiston Fortress",
      "West block of Grancel City",
      "North block of Grancel City",
      "South block of Grancel City",
      "City of Bose",
    ],
    answer: "West block of Grancel City",
    submittedBy: "New Creator",
  },
  {
    id: 117,
    question:
      "When can you first find out the birthdays of both Estelle and Joshua?",
    options: [
      "Chapter 1 of Sky FC",
      "Chapter 2 of Sky FC",
      "Chapter 3 of Sky FC",
      "Chapter 1 of Sky SC",
      "Chapter 2 of Sky SC",
      "Chapter 3 of Sky SC",
    ],
    answer: "Chapter 2 of Sky FC",
    submittedBy: "New Creator",
  },
  {
    id: 118,
    question: "In what game do you meet a Lloyd for the first time?",
    options: ["Sky FC", "Sky SC", "Sky 3rd", "Zero", "Azure", "CS1"],
    answer: "Sky FC",
    submittedBy: "New Creator",
  },
  {
    id: 119,
    question:
      "How many fur-colour variants of Creepy Sheep exist throughout the series?",
    options: ["5", "6", "7", "8", "9", "10"],
    answer: "7",
    submittedBy: "New Creator",
  },
  {
    id: 120,
    question:
      "How many Lost Arts exist throughout the series (not counting upgraded versions in Reverie)?",
    options: ["9", "10", "11", "12", "13", "14"],
    answer: "11",
    submittedBy: "New Creator",
  },
  {
    id: 121,
    question: "How many Master Arts exist in Azure?",
    options: ["5", "6", "7", "8", "9", "10"],
    answer: "7",
    submittedBy: "New Creator",
  },
  {
    id: 122,
    question: "What is Tio's default Master Quartz in Azure?",
    options: ["Scepter", "Magius", "Aegis", "Aries", "Orochi", "Canon"],
    answer: "Canon",
    submittedBy: "New Creator",
  },
  {
    id: 123,
    question: "What is Randy's default Master Quartz in Azure?",
    options: ["Force", "Axe", "Chevalier", "Brave", "Kusanagi", "Keeper"],
    answer: "Axe",
    submittedBy: "New Creator",
  },
  {
    id: 124,
    question:
      "What is Master Quartz do you get as a reward for catching the Elder King in Azure?",
    options: ["Magius", "Juggler", "Chevalier", "Wing", "Kusanagi", "Criminal"],
    answer: "Chevalier",
    submittedBy: "New Creator",
  },
  {
    id: 125,
    question:
      "Which Master Quartz can you buy in Micht's Pawn Shop in CS1 if you miss them?",
    options: [
      "Juggler, Tauros & Katze",
      "Magius, Moebius & Chevalier",
      "Raven, Cypher & Calamity",
      "Juggler, Pandora & Murakumo",
      "Iron, Aegis & Megalith",
      "Criminal, Tauros & Orochi",
    ],
    answer: "Juggler, Tauros & Katze",
    submittedBy: "New Creator",
  },
  {
    id: 126,
    question: "What is Rean's starting Master Quartz in CS1?",
    options: ["Falco", "Raven", "Force", "Iron", "Brave", "Aegis"],
    answer: "Force",
    submittedBy: "New Creator",
  },
  {
    id: 127,
    question: "What is Gaius's starting Master Quartz in CS1?",
    options: ["Mistral", "Raven", "Wing", "Falco", "Iron", "Brave"],
    answer: "Falco",
    submittedBy: "New Creator",
  },
  {
    id: 128,
    question: "What is Elliot's starting Master Quartz in CS1?",
    options: ["Aries", "Mirage", "Angel", "Canon", "Scepter", "Moebius"],
    answer: "Canon",
    submittedBy: "New Creator",
  },
  {
    id: 129,
    question: "What is Laura's starting Master Quartz in CS1?",
    options: ["Force", "Tauros", "Chevalier", "Brave", "Murakumo", "Aegis"],
    answer: "Brave",
    submittedBy: "New Creator",
  },
  {
    id: 130,
    question: "What is Machias's starting Master Quartz in CS1?",
    options: ["Aegis", "Iron", "Megalith", "Tauros", "Keeper", "Genesis"],
    answer: "Iron",
    submittedBy: "New Creator",
  },
  {
    id: 131,
    question: "What is Emma's starting Master Quartz in CS1?",
    options: ["Pandora", "Criminal", "Mirage", "Aries", "Canon", "Magius"],
    answer: "Mirage",
    submittedBy: "New Creator",
  },
  {
    id: 132,
    question: "What is Jusis's starting Master Quartz in CS1?",
    options: ["Wing", "Ariel", "Mistral", "Moebius", "Falco", "Zephyr"],
    answer: "Mistral",
    submittedBy: "New Creator",
  },
  {
    id: 133,
    question: "What is Fie's starting Master Quartz in CS1?",
    options: ["Cypher", "Juggler", "Murakumo", "Katze", "Raven", "Skuld"],
    answer: "Raven",
    submittedBy: "New Creator",
  },
  {
    id: 134,
    question: "What is Alisa's starting Master Quartz in CS1?",
    options: ["Canon", "Scepter", "Moebius", "Angel", "Aries", "Emblem"],
    answer: "Angel",
    submittedBy: "New Creator",
  },
  {
    id: 135,
    question: "What is Millium's starting Master Quartz in CS1?",
    options: ["Iron", "Megalith", "Tauros", "Aegis", "Keeper", "Genesis"],
    answer: "Aegis",
    submittedBy: "New Creator",
  },
  {
    id: 136,
    question: "What is Crow's starting Master Quartz in CS1?",
    options: ["Katze", "Murakumo", "Cypher", "Juggler", "Raven", "Criminal"],
    answer: "Cypher",
    submittedBy: "New Creator",
  },
  {
    id: 137,
    question: "What is Sara's starting Master Quartz in CS2?",
    options: ["Zephyr", "Force", "Thor", "Chevalier", "Murakumo", "Brave"],
    answer: "Thor",
    submittedBy: "New Creator",
  },
  {
    id: 138,
    question: "What is Toval's starting Master Quartz in CS2?",
    options: ["Falco", "Mistral", "Wing", "Criminal", "Pandora", "Rebellion"],
    answer: "Wing",
    submittedBy: "New Creator",
  },
  {
    id: 139,
    question: "What is Claire's starting Master Quartz in CS2?",
    options: ["Aries", "Moebius", "Canon", "Scepter", "Angel", "Emblem"],
    answer: "Moebius",
    submittedBy: "New Creator",
  },
  {
    id: 140,
    question: "What is Sharon's starting Master Quartz in CS2?",
    options: ["Raven", "Cypher", "Katze", "Juggler", "Murakumo", "Calamity"],
    answer: "Juggler",
    submittedBy: "New Creator",
  },
  {
    id: 141,
    question: "What is Juna's starting Master Quartz in CS3?",
    options: ["Sirius", "Keeper", "Aegis", "Skuld", "Minotauros", "Brigid"],
    answer: "Skuld",
    submittedBy: "New Creator",
  },
  {
    id: 142,
    question: "What is Kurt's starting Master Quartz in CS3?",
    options: ["Zephyr", "Tempest", "Thor", "Sirius", "Falco", "Oberon"],
    answer: "Sirius",
    submittedBy: "New Creator",
  },
  {
    id: 143,
    question: "What is Altina's starting Master Quartz in CS3?",
    options: ["Katze", "Titania", "Deva", "Pandora", "Gloom", "Zephyr"],
    answer: "Deva",
    submittedBy: "New Creator",
  },
  {
    id: 144,
    question: "What is Musse's starting Master Quartz in CS3?",
    options: ["Canon", "Magius", "Virgo", "Kaleido", "Titania", "Sophia"],
    answer: "Virgo",
    submittedBy: "New Creator",
  },
  {
    id: 145,
    question: "What is Ash's starting Master Quartz in CS3?",
    options: [
      "Regulus",
      "Minotauros",
      "Beowulf",
      "Chevalier",
      "Scorpio",
      "Brigid",
    ],
    answer: "Scorpio",
    submittedBy: "New Creator",
  },
  {
    id: 146,
    question: "What are the titles of the leaders of the Four Great Houses?",
    options: [
      "Duke, Duke, Duke & Duke",
      "Duke, Marquis, Marquis & Count",
      "Duke, Duke, Count & Count",
      "Archduke, Duke, Marquis & Marquis",
      "Duke, Duke, Marquis & Marquis",
      "Marquis, Marquis, Count & Count",
    ],
    answer: "Duke, Duke, Marquis & Marquis",
    submittedBy: "New Creator",
  },
  {
    id: 147,
    question: "In which game does Osborne get meantioned for the first time?",
    options: ["Sky FC", "Sky SC", "Sky 3rd", "Zero", "Azure", "CS1"],
    answer: "Sky SC",
    submittedBy: "New Creator",
  },
  {
    id: 148,
    question: "What is the spelling of the name of the Cat living in Zeiss?",
    options: ["Antoin", "Anton", "Antoine", "Aintoni", "Aintoine", "Atenio"],
    answer: "Antoine",
    submittedBy: "New Creator",
  },
  {
    id: 149,
    question: "What was the city of Zeiss known as before the current era?",
    options: [
      "City of Blacksmiths",
      "City of Inventors",
      "City of Alchemists",
      "City of Clockmakers",
      "City of Miners",
      "City of Artisans",
    ],
    answer: "City of Clockmakers",
    submittedBy: "New Creator",
  },
  {
    id: 150,
    question:
      "What rare ingredient does Orvid hire Estelle and Joshua to retrieve from the Malga Trail?",
    options: [
      "Bear Claw",
      "Monster Bird Egg",
      "Firefly Fungus",
      "Acerbic Tomato",
      "Pine Mushroom",
      "Crimson Eye",
    ],
    answer: "Firefly Fungus",
    submittedBy: "New Creator",
  },
  {
    id: 151,
    question:
      "Where exactly must Estelle and Joshua go to find the Acerbic Tomato?",
    options: [
      "The Central Factory",
      "The Kaldia Tunnel",
      "Dropped by the Nepenthes monster on the Tratt Plains",
      "Given by an NPC at the Elmo Hot Springs",
      "A locked safe in Professor Russell's workshop",
      "Purchased from a traveling merchant in Grancel",
    ],
    answer: "The Central Factory",
    submittedBy: "New Creator",
  },
  {
    id: 152,
    question: "Which of these music tracks has the longest runtime?",
    options: [
      "Silver Will, Golden Wings",
      "Blue Destination",
      "To the Future",
      "The Azure Arbitrator",
      "Spiral of Erebos",
      "E.O.V.",
    ],
    answer: "The Azure Arbitrator",
    submittedBy: "New Creator",
  },
  {
    id: 153,
    question:
      "Which element has the highest number of arts across the entire series?",
    options: ["Water", "Earth", "Fire", "Wind", "Space", "Mirage", "Time"],
    answer: "Water",
    submittedBy: "New Creator",
  },
  {
    id: 154,
    question:
      "Which element has the fewest number of arts across the entire series?",
    options: ["Water", "Earth", "Fire", "Wind", "Space", "Mirage", "Time"],
    answer: "Space",
    submittedBy: "New Creator",
  },
  {
    id: 155,
    question: "Which game has the shortest Arts list?",
    options: ["Sky FC", "Zero", "CS1", "CS3", "Daybreak", "Horizon"],
    answer: "Sky FC",
    submittedBy: "New Creator",
  },
  {
    id: 156,
    question: "Which game has the longest Arts list?",
    options: ["Sky SC", "Sky 3rd", "Azure", "Reverie", "Daybreak 2", "Horizon"],
    answer: "Sky 3rd",
    submittedBy: "New Creator",
  },
  {
    id: 157,
    question:
      "Which name is said the most through the series up until Reverie?",
    options: [
      "Cassius",
      "KeA",
      "Schera",
      "Tio",
      "Elie",
      "Olivier & Olivert combined",
    ],
    answer: "KeA",
    submittedBy: "New Creator",
  },
  {
    id: 158,
    question:
      "What is the name of the green-haired inventor of the Acerbic Tomato?",
    options: ["Roy", "Ray", "Rayne", "Troy", "Tray", "Anton"],
    answer: "Ray",
    submittedBy: "New Creator",
  },
  {
    id: 159,
    question: "Who is the girl from Paradise?",
    options: ["Tio", "Elie", "Ines", "Renne", "KeA", "Lapis"],
    answer: "Renne",
    submittedBy: "New Creator",
  },
  {
    id: 160,
    question:
      "How many named bracers can you encounter in the series up until Daybreak (incl currently retired ones)?",
    options: ["14", "23", "35", "18", "29", "40"],
    answer: "23",
    submittedBy: "New Creator",
  },
  {
    id: 161,
    question: "In which game has the word 'jaeger' been said the most?",
    options: ["CS3", "CS4", "Azure", "Daybreak", "CS2", "Horizon"],
    answer: "CS3",
    submittedBy: "New Creator",
  },
  {
    id: 162,
    question:
      "Who is the recipient of Campanella's very first line in the series?",
    options: ["Weissmann", "Loewe", "Luciola", "Walter", "Bleublanc", "Anton"],
    answer: "Luciola",
    submittedBy: "New Creator",
  },
];
// 553 in array as of 11.04
export const CRAFTS = [
  {
    id: 1,
    craftName: "Dual Strike",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Unleashes a double slash with dual blades. [2-Hit]",
  },
  {
    id: 2,
    craftName: "Flicker",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Slices defenses, dulls senses. [Penetrate, AT Delay]",
  },
  //{
  //id: 3,
  //craftName: "Taunt",
  //character: "Joshua Bright",
  //gender: "Male",
  //game: "Trails in the Sky",
  //description: "Temporarily focuses enemy attention on self. [Rage]",
  //},
  {
    id: 4,
    craftName: "Cloak & Dagger",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A surprise attack aimed at an enemy's weak spot. [K.O. 20%]",
  },
  {
    id: 5,
    craftName: "Evil Eye",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Penetrating golden glare. Scares foes senseless. [AT Delay]",
  },
  {
    id: 6,
    craftName: "Sever",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A feinting assassin's attack.",
  },
  {
    id: 7,
    craftName: "Black Fang",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Cuts down enemies with an instantaneous attack.",
  },
  {
    id: 8,
    craftName: "Morale",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky",
    description: "A shout to encourage allies. [STR+20%]",
  },
  //{
  //id: 9,
  //craftName: "Taunt",
  //character: "Estelle Bright",
  //gender: "Female",
  //game: "Trails in the Sky",
  //description: "Temporarily focuses enemy attention on self. [Rage]",
  //},
  {
    id: 10,
    craftName: "Hurricane",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Spins and strikes enemies in the area.",
  },
  {
    id: 11,
    craftName: "Comet",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Launches a ballistic wave of energy. [Penetrate]",
  },
  {
    id: 12,
    craftName: "Hard Break",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Hits an enemy's weak spot. Cancels arts and crafts. [Impede]",
  },
  {
    id: 13,
    craftName: "Pummel",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Beats an enemy senseless with a series of attacks.",
  },
  {
    id: 14,
    craftName: "Barrage",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky",
    description: "An extended, more powerful version of Pummel.",
  },
  {
    id: 15,
    craftName: "Sylphen Whip",
    character: "Scherazard Harvey",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Cuts through wind, delivering a powerful lashing.",
  },
  {
    id: 16,
    craftName: "Bind Whip",
    character: "Scherazard Harvey",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Hits weak spot, cancelling arts and crafts. [Impede]",
  },
  {
    id: 17,
    craftName: "Heaven's Kiss",
    character: "Scherazard Harvey",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Whips allies into shape. [AT Advance]",
  },
  {
    id: 18,
    craftName: "Sadist Whip",
    character: "Scherazard Harvey",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Envelops an enemy in a fierce flogging storm.",
  },
  {
    id: 19,
    craftName: "Quick Draw",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Fires off several rounds in the blink of an eye.",
  },
  {
    id: 20,
    craftName: "Sniper Shot",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A precision shot, cancelling arts and crafts. [Impede]",
  },
  {
    id: 21,
    craftName: "Happy Trigger",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Casts bouquet away and heals 800HP for allies.",
  },
  {
    id: 22,
    craftName: "Howling Bullet",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Fires off an explosive energy shot.",
  },
  {
    id: 23,
    craftName: "Kämpfer",
    character: "Kloe Rinz",
    gender: "Female",
    game: "Trails in the Sky",
    description: "A preemptive air strike. [STR&DEF-50%]",
  },
  {
    id: 24,
    craftName: "Sturm",
    character: "Kloe Rinz",
    gender: "Female",
    game: "Trails in the Sky",
    description: "A continuous strike, cancelling arts and crafts. [Impede]",
  },
  {
    id: 25,
    craftName: "Lichtkreis",
    character: "Kloe Rinz",
    gender: "Female",
    game: "Trails in the Sky",
    description:
      "A Radiant Flash. Revives K.O.ed and heals 1500HP. [DEF+50% if 200CP]",
  },
  {
    id: 26,
    craftName: "Wild Rage",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Lets out a forceful yell. [CP+50, MaxHP-30%]",
  },
  {
    id: 27,
    craftName: "Flame Smash",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A powerful attack emitting flames.",
  },
  {
    id: 28,
    craftName: "Draguna Edge",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Sends out a flaming wave attack. [Penetrate, Impede]",
  },
  {
    id: 29,
    craftName: "Spiral Edge",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Sideswipes an enemy. [AT Delay]",
  },
  {
    id: 30,
    craftName: "Beat Down",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A series of sword slashes followed by a heavy blow.",
  },
  {
    id: 31,
    craftName: "Final Break",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Rips through enemies with an explosion of flame.",
  },
  {
    id: 32,
    craftName: "Smoke Cannon",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Hits enemies with a smokescreen. [Blind]",
  },
  {
    id: 33,
    craftName: "Vital Cannon",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails in the Sky",
    description: "Fires off a recovery round, healing allies 500HP.",
  },
  {
    id: 34,
    craftName: "Cannon Impulse",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails in the Sky",
    description: "A wild fusillade of rounds fired at enemies.",
  },
  //{
  //id: 35,
  //craftName: "Taunt",
  // character: "Zin Vathek",
  // gender: "Male",
  //game: "Trails in the Sky",
  //description: "Temporarily focuses all enemy attention on self. [Rage]",
  //},
  {
    id: 36,
    craftName: "Distend",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Parameter-boosting breathing technique. [STR&DEF+30%]",
  },
  {
    id: 37,
    craftName: "Composure",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky",
    description: "Cures all abnormal status except K.O. and heals 800HP.",
  },
  {
    id: 38,
    craftName: "Smite",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A mighty thrusting assault. [Confuse 50%]",
  },
  {
    id: 39,
    craftName: "Disable",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A tremendous multi-stage assault.",
  },
  {
    id: 40,
    craftName: "Aural Blast",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky",
    description: "A burst of drawn-in energy released from both hands.",
  },
  {
    id: 41,
    craftName: "Wheel of Time",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Ultimate smash technique using centrifugal energy.",
  },
  {
    id: 42,
    craftName: "Eight-Leaf Blitz",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Slashes the enemy with chaotic sword strikes.",
  },
  {
    id: 43,
    craftName: "Swordwind Slash",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "A high-speed sword technique that creates a vacuum blade.",
  },
  {
    id: 44,
    craftName: "Fallen Leaves",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Kick followed by a mid-air strike. [AT Delay]",
  },
  {
    id: 45,
    craftName: "Petal Dance",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Move that sacrifices defense for offense. [STR+50%&DEF-30%]",
  },
  {
    id: 46,
    craftName: "Piercing Wave",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Gathers energy, before unleashing a blade of light.",
  },
  {
    id: 47,
    craftName: "True Piercing Wave",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Gathers energy, before unleashing two blades of light.",
  },
  {
    id: 48,
    craftName: "Judgment Card",
    character: "Scherazard Harvey",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "A card of fate. Inflicts one of four random status effects.",
  },
  {
    id: 49,
    craftName: "Dragon Dive",
    character: "Agate Crosner",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A charged attack wreathed in flame from an inhuman jump.",
  },
  {
    id: 50,
    craftName: "Crossgear Rage",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Combo attack with a concealed blade and arrows.",
  },
  {
    id: 51,
    craftName: "Sacrifice Arrow",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Sacrifices own CP to raise the CP of others by 40.",
  },
  {
    id: 52,
    craftName: "Sacred Breath",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A prayer for succor. Heals all allies in range for 2500 HP.",
  },
  {
    id: 53,
    craftName: "Grail Sphere",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Prayer and proferrel grail block 1 attack (2 with full CP).",
  },
  {
    id: 54,
    craftName: "Requiem Hearts",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A raging barrage of shots that shatter the silence.",
  },
  {
    id: 55,
    craftName: "Sanctus Nova",
    character: "Kloe Rinz",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Prayers to Aidios become ribbons of light to defeat foes.",
  },
  {
    id: 56,
    craftName: "Satellite Beam",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "A deadly laser strike fired by a satellite from overhead.",
  },
  {
    id: 57,
    craftName: "Cannon Impulse F",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Upgraded w/ F Parts to increase firepower and range!",
  },
  {
    id: 58,
    craftName: "Thunder God Kick",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A downward kick from the sky like a flash of lightning.",
  },
  {
    id: 59,
    craftName: "Wrath of Genbu",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Ultimate tackle move using earth power to obliterate foes.",
  },
  {
    id: 60,
    craftName: "Phantom Raid",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Stealth technique using high speed to create duplicates.",
  },
  {
    id: 61,
    craftName: "Fangshu: Steel",
    character: "Kurt Nardin",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Uses the power of will to harden the body. [DEF+15%]",
  },
  {
    id: 62,
    craftName: "Fangshu: Whitecaps",
    character: "Kurt Nardin",
    gender: "Male",
    game: "Trails in the Sky SC",
    description:
      "Healing spell that restores 4000 HP to all allies in the area.",
  },
  {
    id: 63,
    craftName: "Fangshu: Renewal",
    character: "Kurt Nardin",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Restores all targets from K.O. and heals 1000 HP.",
  },
  {
    id: 64,
    craftName: "Fangshu: Illusion",
    character: "Kurt Nardin",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Strikes at the enemy's vitals. [K.O. 20%]",
  },
  {
    id: 65,
    craftName: "Sunset Arts",
    character: "Kurt Nardin",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A high-level multi-strike combining a thrust and a sweep.",
  },
  {
    id: 66,
    craftName: "Summon Lightning",
    character: "Kurt Nardin",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A spear thrust followed by a lightning strike.",
  },
  {
    id: 67,
    craftName: "Stampede",
    character: "Josette Capua",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Combination gunfire to the enemy's vitals. [DEF-30%]",
  },
  {
    id: 68,
    craftName: "Anchor Flail",
    character: "Josette Capua",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "Throws out a metal anchor. Yarr! [Faint]",
  },
  {
    id: 69,
    craftName: "Bobcat",
    character: "Josette Capua",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "The beautiful bond between siblings. Summons the Bobcat.",
  },
  {
    id: 70,
    craftName: "Lanzenreiter",
    character: "Julia Schwarz",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "A perfect 4-strike combo. Cancels arts & crafts. [Impede]",
  },
  {
    id: 71,
    craftName: "Mirageberg",
    character: "Julia Schwarz",
    gender: "Female",
    game: "Trails in the Sky SC",
    description: "A shield of illusion and shadow. Negates one attack.",
  },
  {
    id: 72,
    craftName: "Trinity Kleis",
    character: "Julia Schwarz",
    gender: "Female",
    game: "Trails in the Sky SC",
    description:
      "Draws a triangle with their sword, then summons a light pillar.",
  },
  {
    id: 73,
    craftName: "Ragna Bind",
    character: "Mueller Vander",
    gender: "Male",
    game: "Trails in the Sky SC",
    description:
      "Draws foes into range and knocks them unconscious. [Faint 30%]",
  },
  {
    id: 74,
    craftName: "Hound Gale",
    character: "Mueller Vander",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Cuts through enemy lines with fine footwork.",
  },
  {
    id: 75,
    craftName: "Blade Dancer",
    character: "Mueller Vander",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "Befuddles foes with elegant bladework. [Confuse 20%]",
  },
  {
    id: 76,
    craftName: "Mirage Edge",
    character: "Mueller Vander",
    gender: "Male",
    game: "Trails in the Sky SC",
    description:
      "A sealing dagger thrown to prevent arts & crafts. [Impede, Mute]",
  },
  {
    id: 77,
    craftName: "Righteous Witness",
    character: "Mueller Vander",
    gender: "Male",
    game: "Trails in the Sky SC",
    description: "A powerful slash that casts enemies into oblivion.",
  },
  {
    id: 78,
    craftName: "Mortal Punishment",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Attacks foes at speed then impales with spears from below.",
  },
  {
    id: 79,
    craftName: "Gorgon Arrow",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Fires a malevolent arrow to petrify foes. [Petrify]",
  },
  {
    id: 80,
    craftName: "Spear of Loa",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description:
      "Releases Stigma's power in the form of countless time spears.",
  },
  {
    id: 81,
    craftName: "Spear of Ur",
    character: "Kevin Graham",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description:
      "Releases Stigma's power in the form of countless space spears.",
  },
  {
    id: 82,
    craftName: "Arc Fencer",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Raises templar sword and extends it to attack. [Impede]",
  },
  {
    id: 83,
    craftName: "Holy Blessing",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Heals 50% HP, restores 50 CP and cures K.O. with a blessing.",
  },
  {
    id: 84,
    craftName: "Thousand Sparrows",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Templar sword breaks apart, bombarding foes with rapid hits.",
  },
  {
    id: 85,
    craftName: "Arc Fencer 2",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Raises templar sword and extends it to attack. [Impede]",
  },
  {
    id: 86,
    craftName: "Infinity Sparrows",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description:
      "Manipulates templar sword's parts to hit foes in a wide area.",
  },
  {
    id: 87,
    craftName: "Heavenly Strike",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Prays for a valkyrie who mows down foes with a light beam.",
  },
  {
    id: 88,
    craftName: "Heavenly Sphere",
    character: "Ries Argent",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Prays for a valkyrie who crushes foes with a ball of light.",
  },
  {
    id: 89,
    craftName: "Orbal Gear",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description:
      "Special Craft - Mount Orbal Gear - HP+100%, STR/DEF+20%. Removes accessory effects, but nulls many ailments.",
  },
  {
    id: 90,
    craftName: "Attack Orders",
    character: "Julia Schwarz",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Heightens allies' will to fight. [STR+20%/SPD+10%]",
  },
  {
    id: 91,
    craftName: "Pentagrammic Kleis",
    character: "Julia Schwarz",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description:
      "Draws a pentagram with their sword, then summons a light pillar.",
  },
  {
    id: 92,
    craftName: "Plunder",
    character: "Josette Capua",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Commonly steals from foes using a mechanical arm. [Steal]",
  },
  {
    id: 93,
    craftName: "Orbal Bomb",
    character: "Josette Capua",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description:
      "Throws bombs at foes and detonates them with their gun. [Impede]",
  },
  {
    id: 94,
    craftName: "Whirlwind Dance",
    character: "Anelace Elfead",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "A revolving attack that draws enemies close. [Suction]",
  },
  {
    id: 95,
    craftName: "Fox Tail",
    character: "Scherazard Harvey",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Creates an opening during which to steal items. [Steal]",
  },
  {
    id: 96,
    craftName: "Luminous Divider",
    character: "Alan Richard",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Attacks with a flurry of slashes before passing through foe.",
  },
  {
    id: 97,
    craftName: "True Luminous Wheel",
    character: "Alan Richard",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description:
      "Launches a more deadly wheel even farther than before. [Impede]",
  },
  {
    id: 98,
    craftName: "True Luminous Ogre Slash",
    character: "Alan Richard",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Unsheathes sword for a deadly attack. [Faint 30%]",
  },
  {
    id: 99,
    craftName: "Afterglow Smasher",
    character: "Alan Richard",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Unsheathes blade so fast that enemies won't even notice it.",
  },
  {
    id: 100,
    craftName: "Sakura Morning Moon",
    character: "Alan Richard",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "So fast, it leaves no afterimage--only a trail of blood.",
  },
  {
    id: 101,
    craftName: "Calamity Throw",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Throws their scythe, rending foes in its path. [K.O. 10%]",
  },
  {
    id: 102,
    craftName: "Blood Circle 2",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "A spinning attack that hits foes in a wide area. [K.O. 10%]",
  },
  {
    id: 103,
    craftName: "Rennede",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description:
      "Cuts through enemy ranks, taking the lives of foes. [K.O. 50%]",
  },
  {
    id: 104,
    craftName: "Pater-Mater",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails in the Sky the 3rd",
    description: "Summons Pater-Mater which annihilates all with its cannons.",
  },
  {
    id: 105,
    craftName: "Soul Infusion",
    character: "Rocco / Deen / Rais",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Yells abuse, distracting ally from injuries. Heals 3000 HP.",
  },
  {
    id: 106,
    craftName: "Invigorate",
    character: "Rocco / Deen / Rais",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Aggressively stimulates an ally's will to fight. [STR+20%]",
  },
  {
    id: 107,
    craftName: "Embolden",
    character: "Rocco / Deen / Rais",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "An underworld technique that heals 4649 and cures K.O.",
  },
  {
    id: 108,
    craftName: "Shakedown",
    character: "Rocco / Deen / Rais",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Intimidates foes with a glare. [DEF-100%/Seal (30%)]",
  },
  {
    id: 109,
    craftName: "No Mercy",
    character: "Rocco / Deen / Rais",
    gender: "Male",
    game: "Trails in the Sky the 3rd",
    description: "Usable only by the toughest on the streets. 100% Deathblow!",
  },
  {
    id: 110,
    craftName: "Axle Rush",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Whirls around tonfas, making a series of shockwaves.",
  },
  {
    id: 111,
    craftName: "Stun Break",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Shocks with high-power current, canceling arts and crafts.",
  },
  {
    id: 112,
    craftName: "Encourage",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Encourages allies, raising morale. Gives STR+25%.",
  },
  {
    id: 113,
    craftName: "Brave Smash",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Focuses fighting spirit in a line. 75% chance to seal.",
  },
  {
    id: 114,
    craftName: "Burning Heart",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Gains immense power, but suffers faint afterwards.",
  },
  {
    id: 115,
    craftName: "Tiger Charge",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Overwhelms with a barrage, then charges like a tiger.",
  },
  {
    id: 116,
    craftName: "Rising Sun",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Launches foes upward, then attacks like a dragon.",
  },
  {
    id: 117,
    craftName: "Extend Hearts",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails from Zero",
    description: "Encourages allies with burning passion, raising STR and CP.",
  },
  {
    id: 118,
    craftName: "Triple Burst",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "Fires three high-accuracy shots, concentrated on one point.",
  },
  {
    id: 119,
    craftName: "Holy Bullet",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "Recovers allies' HP and CP in an area with a holy shot.",
  },
  {
    id: 120,
    craftName: "Wild Swan",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "With a barrage of shots and a kick, cancels arts and crafts.",
  },
  {
    id: 121,
    craftName: "Cross Mirage",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "Steps forward and shoots down each target.",
  },
  {
    id: 122,
    craftName: "Strike Bell",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "Manifests the time barrier and destroys it, advancing turns.",
  },
  {
    id: 123,
    craftName: "Aura Rain",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "A healing rain upon allies. If max CP, HP is fully healed.",
  },
  {
    id: 124,
    craftName: "Aerial Cannon",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "Fires condensed energy from the air as a bullet of light.",
  },
  {
    id: 125,
    craftName: "Saintly Bullet",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails from Zero",
    description: "Fires a special bullet, restoring health and endurance.",
  },
  {
    id: 126,
    craftName: "Analyze",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Discover enemy vitals, weakening them.",
  },
  {
    id: 127,
    craftName: "Beam Zanber",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Slices foes with a beam extending from an orbal staff.",
  },
  {
    id: 128,
    craftName: "Summon Zeit",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Telepathically calls Zeit with an orbal staff.",
  },
  {
    id: 129,
    craftName: "Energy Circle",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "A recovery field removes ailments from allies' bodies.",
  },
  {
    id: 130,
    craftName: "Absolute Zero",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Fires a frozen blast from a transformed orbal staff.",
  },
  {
    id: 131,
    craftName: "Ether Buster",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Transforms the orbal staff to fire a powerful laser beam.",
  },
  {
    id: 132,
    craftName: "Zero Field",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Protects all allies from one attack. If max CP, two attacks.",
  },
  {
    id: 133,
    craftName: "C-Protection",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails from Zero",
    description: "Extends an orbal barrier and healing field over an area.",
  },
  {
    id: 134,
    craftName: "Power Smash",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description: "Strikes opponent with great force, delaying their next turn.",
  },
  {
    id: 135,
    craftName: "Salamander",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "A dragon-like wave of flames charges to incinerate enemies. [Burn 80%]",
  },
  {
    id: 136,
    craftName: "Crash Bomb",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description: "Throws a flash grenade with 100% chance to blind. [Blind]",
  },
  {
    id: 137,
    craftName: "War Cry",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Strengthens spirit with a battle cry and trades HP for CP. [HP-30%/CP+60]",
  },
  {
    id: 138,
    craftName: "Death Storm",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Overwhelms enemies with a frenzied storm, bringing death. [K.O. 60%]",
  },
  {
    id: 139,
    craftName: "Crimson Gale",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Incinerates foes with a mighty whirlwind of flame. [Burn 100%]",
  },
  {
    id: 140,
    craftName: "Death Scorpion",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description: "Ferociously charges. The blood of the War God boils within.",
  },
  {
    id: 141,
    craftName: "Burning Divider",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Strikes the enemy formation with a burning stun halberd. [Burn 100%]",
  },
  {
    id: 142,
    craftName: "Phantom Rush",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails from Zero",
    description: "Restrains the enemy with rapid strikes. SPD-50%.",
  },
  {
    id: 143,
    craftName: "Broadaxe",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails from Zero",
    description: "A roundhouse kick made with plenty of weight behind it.",
  },
  {
    id: 144,
    craftName: "Trinity Card",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails from Zero",
    description: "Gracefully casts a mystical card to cancel arts and crafts.",
  },
  {
    id: 145,
    craftName: "Deadly Heaven",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails from Zero",
    description: "Unleashes a series of rapid kicks to weaken and rout a foe.",
  },
  {
    id: 146,
    craftName: "Wild Joker",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Deals a mystical card that destroys the time barrier. [SPD+50%, Accelerate]",
  },
  {
    id: 147,
    craftName: "S-Grenade",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails from Zero",
    description:
      "Uses a grenade launcher to shoot a hypnotic gas bomb. [Sleep 75%]",
  },
  {
    id: 148,
    craftName: "Assault Rush",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails from Zero",
    description: "Empties magazine to delay the target's next turn. [Delay]",
  },
  {
    id: 149,
    craftName: "Electromagnetic Net",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails from Zero",
    description: "Deploys a net to apprehend heinous criminals. [MOV-5]",
  },
  {
    id: 150,
    craftName: "Blast Storm",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails from Zero",
    description: "Uses successive heavy weaponry to rain down fire.",
  },
  {
    id: 151,
    craftName: "Electromagnetic Net β",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails from Zero",
    description:
      "Deploys an electromagnetic net to greatly impede movement. [SPD-50%]",
  },
  {
    id: 152,
    craftName: "Shotgun",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description: "Uses a powerful shotgun to eliminate armor. [DEF-25%]",
  },
  {
    id: 153,
    craftName: "Tough Love",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Encourages an ally with clenched fists. [HP Heal (30%)/CP+40]",
  },
  {
    id: 154,
    craftName: "Victory Charge",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Rams foes with a disciplined charge, delaying their turn. [Delay]",
  },
  {
    id: 155,
    craftName: "Judgment Bullet",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Fires a powerful magnum round, prohibited within the city. [K.O. 100%]",
  },
  {
    id: 156,
    craftName: "Attack Orders",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description: "Draws out allies' will to fight. [STR/SPD+25%]",
  },
  {
    id: 157,
    craftName: "Justice Hammer",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description: "Fists of judgment explode with the anger to oppose evil.",
  },
  {
    id: 158,
    craftName: "Resounding Orders",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails from Zero",
    description:
      "Gives out a commanding order to greatly boost morale. [STR/SPD+50%]",
  },
  {
    id: 159,
    craftName: "Dragon Claws",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails from Zero",
    description: "Draws in foes, then slashes with a sword.",
  },
  {
    id: 160,
    craftName: "Exploding Talisman",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails from Zero",
    description:
      "Throws a kunai with a talisman attached and detonates it. [K.O. 90%]",
  },
  {
    id: 161,
    craftName: "Qilingong",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails from Zero",
    description: "Concentrates spirit, raising STR and SPD. [STR/SPD+50%]",
  },
  {
    id: 162,
    craftName: "Falling Moon",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails from Zero",
    description: "Throws sword like a boomerang, eradicating foes.",
  },
  {
    id: 163,
    craftName: "Paraselene Dance",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails from Zero",
    description: "Binds foes with claws and lunar light.",
  },
  {
    id: 164,
    craftName: "Ogre Needles",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails from Zero",
    description:
      "Throws innumerable kunai coated with a deadly poison. [K.O. 50%]",
  },
  {
    id: 165,
    craftName: "Hundred Blows",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails from Zero",
    description: "An overwhelming barrage of blows to knock the foe down.",
  },
  {
    id: 166,
    craftName: "Phoenix Wave",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails from Zero",
    description: "With the spirit of a phoenix, spins with immense power.",
  },
  {
    id: 167,
    craftName: "Swelling Hope",
    character: "Estelle Bright",
    gender: "Female",
    game: "Trails from Zero",
    description:
      "A loud shout of courage to raise allies' DEF and CP. [DEF+25%/CP+30]",
  },
  {
    id: 168,
    craftName: "Lightning Flash",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails from Zero",
    description: "Hits a group with strikes as fierce as a storm.",
  },
  {
    id: 169,
    craftName: "Fang Flicker",
    character: "Joshua Bright",
    gender: "Male",
    game: "Trails from Zero",
    description: "Delay all enemies' turn with a gale of slices.",
  },
  {
    id: 170,
    craftName: "Meteor Breaker",
    character: "Lloyd Bannings",
    gender: "Male",
    game: "Trails to Azure",
    description: "Converts soul into a battle aura, then attacks from above.",
  },
  {
    id: 171,
    craftName: "Divine Crusade",
    character: "Elie MacDowell",
    gender: "Female",
    game: "Trails to Azure",
    description: "Fires a volley from ornate black and white orbal guns.",
  },
  {
    id: 172,
    craftName: "Eidolon Gear",
    character: "Tio Plato",
    gender: "Female",
    game: "Trails to Azure",
    description: "Boards a mech developed by the Epstein Foundation and ZCF.",
  },
  {
    id: 173,
    craftName: "Berserker",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails to Azure",
    description: "Death Scorpion's precursor. Hunts foes with a massive rifle.",
  },
  {
    id: 174,
    craftName: "Heavy Smash",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails to Azure",
    description: "Attacks with a halberd, weakening enemy attacks.",
  },
  {
    id: 175,
    craftName: "Smart Missiles",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails to Azure",
    description: "Incinerates the battlefield with a salvo of missiles.",
  },
  {
    id: 176,
    craftName: "Armed Forces",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails to Azure",
    description: "Razes the battlefield with two armored cars' gunfire.",
  },
  {
    id: 177,
    craftName: "Seventh Shot",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Beats down enemies with an unusual billiard ball technique. [Confuse 25%]",
  },
  {
    id: 178,
    craftName: "Weiss Card",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Throws a shining white card to recover an ally's HP. [HP Heal (L)/Cures Ailments]",
  },
  {
    id: 179,
    craftName: "Akashic Arm",
    character: "Wazy Hemisphere",
    gender: "Male",
    game: "Trails to Azure",
    description: "Manifests an almighty arm using the Stigma's power.",
  },
  {
    id: 180,
    craftName: "Gale",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Thrashes foes with a high-speed slice followed by a whirlwind.",
  },
  {
    id: 181,
    craftName: "Avalanche Cleaver",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails to Azure",
    description: "A single controlled slash beheads enemies. [Confuse (50%)]",
  },
  {
    id: 182,
    craftName: "Crashing Wave",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Draws a sword at legendary speeds, causing a shockwave. [K.O. (50%)]",
  },
  {
    id: 183,
    craftName: "Qinggong",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Harmonizes the spirit to reach absolute selflessness. [STR/SPD+50%]",
  },
  {
    id: 184,
    craftName: "Fujin's Fury",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails to Azure",
    description: "Draws a sword and crashes down with the might of a wind god.",
  },
  {
    id: 185,
    craftName: "Tough Love",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Encourages an ally with clenched fists. [HP Heal (30%)/CP+40]",
  },
  {
    id: 186,
    craftName: "Justice Magnum",
    character: "Alex Dudley",
    gender: "Male",
    game: "Trails to Azure",
    description: "Slam enemies with an iron fist, then sends evil skyward.",
  },
  {
    id: 187,
    craftName: "Moonlight Butterflies",
    character: "Rixia Mao",
    gender: "Female",
    game: "Trails to Azure",
    description:
      "Yin's secret skill, hides in a group of silvery butterflies. [SPD+50% - Stealth]",
  },
  {
    id: 188,
    craftName: "Burst Kick",
    character: "Garcia Rossi",
    gender: "Male",
    game: "Trails to Azure",
    description: "A weighty kick that sends enemies flying. [Faint (25%)]",
  },
  {
    id: 189,
    craftName: "Bear Tackle",
    character: "Garcia Rossi",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Tramples over foes with the charge of a giant body. [Faint (25%)]",
  },
  {
    id: 190,
    craftName: "Whirlwind Kick",
    character: "Garcia Rossi",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Directly strikes the enemy's core with a high-velocity kick. [Faint (50%)]",
  },
  {
    id: 191,
    craftName: "Matchless Power",
    character: "Garcia Rossi",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "A jaeger skill that temporarily enhances the senses. [STR/SPD+50%]",
  },
  {
    id: 192,
    craftName: "Killing Driver",
    character: "Garcia Rossi",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "A close-quarter combat technique that has felled many foes. [Faint (100%)]",
  },
  {
    id: 193,
    craftName: "Phoenix Rush",
    character: "Zeit",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "Charges at enemies whilst clad in flaming spirit. [Burn (25%)]",
  },
  {
    id: 194,
    craftName: "Gale-Force Fang",
    character: "Zeit",
    gender: "Male",
    game: "Trails to Azure",
    description: "Bores through foes with a razor-sharp charge. [K.O. (25%)]",
  },
  {
    id: 195,
    craftName: "Alpha Roar",
    character: "Zeit",
    gender: "Male",
    game: "Trails to Azure",
    description:
      "The Divine Wolf's roar causes enemies to falter. [STR/DEF-25%]",
  },
  {
    id: 196,
    craftName: "Autumn Leaf Cutter",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Slashes foes while dashing by them. [Impede/Delay+15/Unbalance+10%]",
  },
  {
    id: 197,
    craftName: "Motivate",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "An encouraging shout to rouse allies to battle. [STR+25%/CP+10]",
  },
  {
    id: 198,
    craftName: "Arc Slash",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Unleashes an arc-shaped shock wave. [Delay+30/Can unbalance]",
  },
  {
    id: 199,
    craftName: "Gale",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Slices up enemies at high speed. [Seal (50%)/Unbalance+20%]",
  },
  {
    id: 200,
    craftName: "Flame Impact",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "A powerful downward slash. [Burn (50%)/Faint (50%)/Unbalance+30%]",
  },
  {
    id: 201,
    craftName: "Flame Slash",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Bathes sword in flames and slashes enemies. [Burn (100%)]",
  },
  {
    id: 202,
    craftName: "Azure Flame Slash",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Bathes sword in blue flames and slashes enemies. [Burn (100%)]",
  },
  {
    id: 203,
    craftName: "Flamberge",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Pierces enemy with a burning arrow. [Burn (50%)/Unbalance+20%]",
  },
  {
    id: 204,
    craftName: "Blessed Arrow",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Fires a blessed arrow into the air, healing allies in an area. [HP Heal (S)/CP+40]",
  },
  {
    id: 205,
    craftName: "Molten Rain",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Rains burning arrows onto enemies. [Can unbalance]",
  },
  {
    id: 206,
    craftName: "Heavenly Gift",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Grants allies insight status and restores 20CP every turn. [Insight/CP Regen]",
  },
  {
    id: 207,
    craftName: "Rosetta Arrow",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Fires an arrow containing condensed magical energy. [Mute (100%)]",
  },
  {
    id: 208,
    craftName: "Judgment Arrow",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Annihilates enemies with an arrow of judgement. [Mute (100%)]",
  },
  {
    id: 209,
    craftName: "Resounding Beat",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Boosts the DEF of allies by 25% and heals 30% HP every turn. [DEF+25%/HP Regen]",
  },
  {
    id: 210,
    craftName: "Blue Lullaby",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Lulls foes to sleep with soothing sounding bubbles. [Sleep (30%)]",
  },
  {
    id: 211,
    craftName: "Holy Song",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Purifies allies with a holy song. [HP Heal (M)/Cures Ailments]",
  },
  {
    id: 212,
    craftName: "Nocturne Bell",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Steals foes' consciousness with silver bells. [Sleep (50%)/Nightmare (30%)]",
  },
  {
    id: 213,
    craftName: "Seventh Rhapsody",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Utterly destroys foes with the power of music. [Confuse (100%)]",
  },
  {
    id: 214,
    craftName: "Armor Breaker",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Tears the armor from enemies. [DEF-25%/Seal (30%)/Unbalance+30%]",
  },
  {
    id: 215,
    craftName: "Earth Cleaver",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Splits the earth beneath foes' feet. [MOV-50%/Unbalance+10%]",
  },
  {
    id: 216,
    craftName: "Brilliant Spin",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Draws foes into a vortex of light. Can unbalance. [Suction/Faint (30%)]",
  },
  {
    id: 217,
    craftName: "Radiant Wings",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Increases physical abilities at the expense of magical ones. [STR/DEF+50%/Insight/ATS/ADF-50%]",
  },
  {
    id: 218,
    craftName: "Radiant Dance",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Slices up foes with a blade of light.",
  },
  {
    id: 219,
    craftName: "Radiant Waltz",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Cuts up foes with a series of beautiful slashes.",
  },
  {
    id: 220,
    craftName: "Break Shot",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Fires an armor-piercing round. [Impede/DEF-25%/Unbalance+20]",
  },
  {
    id: 221,
    craftName: "Energy Shell",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Launches a special recovery bullet filled with energy. [HP/EP Heal (25%)]",
  },
  {
    id: 222,
    craftName: "Petrification Shell",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Fires a bullet that can petrify. Can unbalance. [Petrify (50%)]",
  },
  {
    id: 223,
    craftName: "Burst Drive",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Breaks the time barrier, allowing allies to act faster. [Accelerate]",
  },
  {
    id: 224,
    craftName: "Ultimate Shot",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Fires a bullet of unimaginable power. [Random abnormal status]",
  },
  {
    id: 225,
    craftName: "Serene Blessing",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Heals an ally with the calm of the moon. [Cures K.O./HP Heal (50%)/CP+20]",
  },
  {
    id: 226,
    craftName: "Ethereal Edge",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Releases several magical blades. [ATS-50%/Unbalance+10%]",
  },
  {
    id: 227,
    craftName: "Crescent Shell",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Strengthens allies with the crescent moon's power. [DEF+50%/Magic Reflect]",
  },
  {
    id: 228,
    craftName: "Aster Flare",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Muddles an enemy's cognitive abilities with flame. [Burn (30%)/Confuse (30%)]",
  },
  {
    id: 229,
    craftName: "Lord Albireon",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Turns all to dust with the light of mighty towers.",
  },
  {
    id: 230,
    craftName: "Rapid Thrust",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "A series of three rapid thrusts. [Impede/Delay+30/Unbalance+20%]",
  },
  {
    id: 231,
    craftName: "Rune Blade",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Cuts enemies in half with a magical slash. [ADF-50%]",
  },
  {
    id: 232,
    craftName: "Noble Command",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Raises the morale of allies with an inspiring shout. [STR/ATS/SPD+25%]",
  },
  {
    id: 233,
    craftName: "Treasure Sword",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Seals foes in ice, then shatters it. [Seal (50%)/Freeze (50%)/Unbalance+20%]",
  },
  {
    id: 234,
    craftName: "Crystal Saber",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Imprisons foes in a barrier, then eliminates them.",
  },
  {
    id: 235,
    craftName: "Sweep",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Mows down foes with twin gunswords. Can unbalance. [Impede/SPD-25%]",
  },
  {
    id: 236,
    craftName: "Flash Grenade",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Throws a grenade which emits bright light. [Blind (30%)/Seal (30%)]",
  },
  {
    id: 237,
    craftName: "Scud Ripper",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Strikes enemies' weak points. Unbalance+20%. [Faint (30%)/K.O. (30%)]",
  },
  {
    id: 238,
    craftName: "Bullet Cyclone",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Dominates foes with rapid attacks. Unbalance+30%. [Seal (50%)/Delay +35]",
  },
  {
    id: 239,
    craftName: "Sylphid Dance",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Overwhelms foes with a dance of death.",
  },
  {
    id: 240,
    craftName: "Gale Stinger",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Launches a blast of wind forwards. Can unbalance. [Seal (50%)]",
  },
  {
    id: 241,
    craftName: "Turbulence",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Envelops foes in turbulent winds. Unbalance+10%. [Blind (50%)]",
  },
  {
    id: 242,
    craftName: "Wild Rage",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Cries out with wild anger, trading HP for CP. [HP-30%/CP+50]",
  },
  {
    id: 243,
    craftName: "Savage Fang",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Skewers foes with great force. Unbalance+20%. [MOV-50%/Delay+35]",
  },
  {
    id: 244,
    craftName: "Calamity Hawk",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Descends upon foes with a hawklike aura.",
  },
  {
    id: 245,
    craftName: "Buster Arm",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Airgetlam attacks with great force. Unbalance+20%. [Impede/Faint (50%)]",
  },
  {
    id: 246,
    craftName: "Ultimate Barrier",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Creates a silver barrier, granting immunity to one attack. [Physical Immunity]",
  },
  {
    id: 247,
    craftName: "Riot Beam",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Airgetlam fires a beam of light. [STR-25%]",
  },
  {
    id: 248,
    craftName: "Megaton Press",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Airgetlam crushes foes as a sphere. Unbalance+30%. [Faint (70%)/Delay+40]",
  },
  {
    id: 249,
    craftName: "Gigant Breaker",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "Turns Airgetlam into a hammer and strikes foes.",
  },
  {
    id: 250,
    craftName: "Rapid Volley",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Fires a series of rapid shots. Can unbalance. [Delay+15]",
  },
  {
    id: 251,
    craftName: "Freezing Bullet",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Fires a magical bullet imbued with the power of ice. [Freeze (50%)]",
  },
  {
    id: 252,
    craftName: "Wild Card",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Draws a card, leaving everything to chance. What will happen? [Random effect]",
  },
  {
    id: 253,
    craftName: "Chaos Trigger",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description:
      "Fires a bullet of pure insanity. Can unbalance. [Confuse (50%)/Nightmare (50%)]",
  },
  {
    id: 254,
    craftName: "Cross Raven",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 1",
    description: "Wildly fires bullets which all hit at once.",
  },
  {
    id: 255,
    craftName: "Thundering Roar",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Attacks with bullets and lightning. Unbalance+10%. [Seal (90%)/SPD-25%]",
  },
  {
    id: 256,
    craftName: "Lightning Charge",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Raises physical abilities with a war cry. [STR/SPD+50%/Insight]",
  },
  {
    id: 257,
    craftName: "Flash",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Overtakes foes like a lightning bolt. Unbalance+30%. [Seal (30%)/Delay+30]",
  },
  {
    id: 258,
    craftName: "Plasma Storm",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Races across the battlefield, dominating foes. [Faint (100%)]",
  },
  {
    id: 259,
    craftName: "Laser Bullet",
    character: "Angelica Rogner",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "A kick that releases a shock wave. Unbalance+10%. [Impede/Delay+20]",
  },
  {
    id: 260,
    craftName: "Zero Impact",
    character: "Angelica Rogner",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "A blast of energy from close range. Unbalance+50%. [Faint (90%)]",
  },
  {
    id: 261,
    craftName: "Dragon Boost",
    character: "Angelica Rogner",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description:
      "Strengthens the body through an explosion of energy. [STR/DEF+50% (3 turns)]",
  },
  {
    id: 262,
    craftName: "Dragon Kick",
    character: "Angelica Rogner",
    gender: "Female",
    game: "Trails of Cold Steel 1",
    description: "An explosive dragon kick from above.",
  },
  {
    id: 263,
    craftName: "Spirit Unification",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Unleashes the power sleeping within Rean. [STR/DEF/SPD+50%/Unleash (3 turns)]",
  },
  {
    id: 264,
    craftName: "Awakener's Call",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description: "Summons Valimar, the Ashen Knight.",
  },
  {
    id: 265,
    craftName: "Termination Slash - Dawn",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description: "Cleaves ignorance and dyes the sky. [Burn (200%)]",
  },
  {
    id: 266,
    craftName: "Mirage Arrow",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Fires a magical arrow forwards. [Blind (50%)]",
  },
  {
    id: 267,
    craftName: "Radiance Arc",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Unleashes a radiant arrow to defeat evil. [Mute (200%)]",
  },
  {
    id: 268,
    craftName: "Remedy Oratorio",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Heals with a holy melody. 2 turns of HP+50% at 200CP. [Cures K.O./HP Heal (Full)]",
  },
  {
    id: 269,
    craftName: "Radiant Blade",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Pierces with a formless light blade. Unbalance+20%. [Mute (90%)]",
  },
  {
    id: 270,
    craftName: "Radiant Lion",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Unleashes the attacker's full might.",
  },
  {
    id: 271,
    craftName: "Shotgun Blast",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Crushes foes with a custom shotgun. Unbalance+50%. [Balance Down (3 turns)]",
  },
  {
    id: 272,
    craftName: "Trinity Cannon",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Imprisons foes, then eliminates them with a laser. [Random ailment (200%)]",
  },
  {
    id: 273,
    craftName: "Zodiac Rain",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Calls the stars above to rain destruction on foes.",
  },
  {
    id: 274,
    craftName: "Platinum Shield",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Creates a holy barrier that blocks one physical attack. [Physical Immunity]",
  },
  {
    id: 275,
    craftName: "Asteion Knight",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description: "An almighty attack from on top of a horse. [Seal (100%)]",
  },
  {
    id: 276,
    craftName: "Concealing Wind",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Surrounds self with an illusory wind, becoming invisible. [Stealth/SPD+50% (2 turns)]",
  },
  {
    id: 277,
    craftName: "Shadow Brigade",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Overwhelms foes with immense speed.",
  },
  {
    id: 278,
    craftName: "Hunter Wing",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Borrows the power of Zeo the hawk. Unbalance+30%. [Impede/DEF/ADF-50% (3 turns)]",
  },
  {
    id: 279,
    craftName: "Twin Cyclones",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description: "Commands raging winds with two spears.",
  },
  {
    id: 280,
    craftName: "Sledge Impact",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Turns Airgetlam into a hammer. Unbalance+10%. [Balance Down/MOV-50% (3 turns)]",
  },
  {
    id: 281,
    craftName: "Galactic Cannon",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Annihilates enemies from orbit with a laser beam.",
  },
  {
    id: 282,
    craftName: "Thunder Vortex",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Gathers foes together, then slashes. Unbalance+10%. [STR-50% (3 turns)]",
  },
  {
    id: 283,
    craftName: "Northern Limits",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Combines a bracer's will and a jaeger's strength. [Faint (100%)]",
  },
  {
    id: 284,
    craftName: "Swallow Tail",
    character: "Elise Schwarzer",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Slashes forcefully, launching a shockwave. [Delay+20]",
  },
  {
    id: 285,
    craftName: "Holy Squall",
    character: "Elise Schwarzer",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Prays to Aidios and summons a healing rain down upon allies. [HP Heal (60%)/Cures ailments/Stat Down]",
  },
  {
    id: 286,
    craftName: "Fragrant Garden",
    character: "Elise Schwarzer",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "A series of slashes that resemble petals.",
  },
  {
    id: 287,
    craftName: "Double Strike",
    character: "Toval Randonneur",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Two rapid strikes that seal movement. Unbalance+30%. [Impede/Seal (100%)]",
  },
  {
    id: 288,
    craftName: "Dizzying Blow",
    character: "Toval Randonneur",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Knocks unconscious with great force. Unbalance+50%. [Faint (30%)/Balance Down (3 turns)]",
  },
  {
    id: 289,
    craftName: "Sphere Break",
    character: "Toval Randonneur",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "A special field that seals arts. Can't unbalance. [Mute (100%)/ADF-50% (3 turns)]",
  },
  {
    id: 290,
    craftName: "Rebellion Storm",
    character: "Toval Randonneur",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description: "Fuses spheres of compressed wind and drops them.",
  },
  {
    id: 291,
    craftName: "Mortal Mirage",
    character: "Claire Rieveldt",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Runs forward and fires a deadly shot. Unbalance+30%. [K.O. (50%)/Delay+25]",
  },
  {
    id: 292,
    craftName: "Frigid Rain",
    character: "Claire Rieveldt",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Summons an ice crystal and shatters it above foes. [Freeze (100%)]",
  },
  {
    id: 293,
    craftName: "Flawless Leadership",
    character: "Claire Rieveldt",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Gives the order to advance, leading allies to victory. [Accelerate/STR/DEF+25% (3 turns)]",
  },
  {
    id: 294,
    craftName: "Kaleido Force",
    character: "Claire Rieveldt",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "A shot with immense power.",
  },
  {
    id: 295,
    craftName: "Binding Chains",
    character: "Sharon Kreuger",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Binds prey, then slashes it. Attacks twice. [Suction/Seal (50%)/Delay +25]",
  },
  {
    id: 296,
    craftName: "Shadow Stitch",
    character: "Sharon Kreuger",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Charges through foes, binding and cutting them. [SPD-50%/MOV-100% (3 turns)]",
  },
  {
    id: 297,
    craftName: "Tea Time",
    character: "Sharon Kreuger",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Delivers a cup of mid-battle tea to refresh body and mind. [Heals 50%/CP+50/Cures ailments]",
  },
  {
    id: 298,
    craftName: "Death's Embrace",
    character: "Sharon Kreuger",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Binds foes, then beckons them to death. [K.O. (100%)]",
  },
  {
    id: 299,
    craftName: "Weakener",
    character: "Towa Herschel",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Analyzes foe's weaknesses and lowers their resistance to arts. [Analysis/Weak (3 turns)]",
  },
  {
    id: 300,
    craftName: "Shooting Stars",
    character: "Towa Herschel",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Fires several magical bullets at one point.",
  },
  {
    id: 301,
    craftName: "Energy Rain",
    character: "Towa Herschel",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Calls rain down on allies, restoring their HP and EP. [HP/EP Heal (25%)]",
  },
  {
    id: 302,
    craftName: "Rainbow Shot",
    character: "Towa Herschel",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Unleashes the power of all seven elements.",
  },
  {
    id: 303,
    craftName: "Purity Ray",
    character: "Alfin Reise Arnor",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Drives away evil with pure light. Can't unbalance. [Blind (50%)]",
  },
  {
    id: 304,
    craftName: "Royal Cheer",
    character: "Alfin Reise Arnor",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "A loving cheer to encourage allies. [STR/ATS/SPD+25% (5 turns)]",
  },
  {
    id: 305,
    craftName: "Sacred Circle",
    character: "Alfin Reise Arnor",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Creates an impenetrable barrier. Adds Magic Reflect at 200CP. [Physical Immunity]",
  },
  {
    id: 306,
    craftName: "Blade Throw",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Throws double saber like a boomerang. Unbalance+20%. [Seal (100%)/Balance Down (3 turns)]",
  },
  {
    id: 307,
    craftName: "Arc Slash",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Cleaves foes with a magical blade. Unbalance+20%. [Impede/ADF-50% (3 turns)]",
  },
  {
    id: 308,
    craftName: "Criminal Edge",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description:
      "Reduces enemies' defenses to dust. Unbalance+30%. [DEF-50% (3 turns)/Delay+50]",
  },
  {
    id: 309,
    craftName: "Deadly Cross",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 2",
    description: "Murders foes with a cross-shaped slash.",
  },
  {
    id: 310,
    craftName: "Dancing Blades",
    character: "Vita Clotilde",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Slices foes to pieces with blades. Unbalance+30%. [Confuse (100%)/Burn (100%)]",
  },
  {
    id: 311,
    craftName: "Frozen Prison",
    character: "Vita Clotilde",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Freezes all in a prison of otherworldly ice. [Seal (100%)/Freeze (100%)]",
  },
  {
    id: 312,
    craftName: "Summon Grianos",
    character: "Vita Clotilde",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Summons Grianos, bringing about chaos. [Random ailment (200%)]",
  },
  {
    id: 313,
    craftName: "Aria of the Abyss",
    character: "Vita Clotilde",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Sinks foes into the depths of despair. [Nightmare (500%)]",
  },
  {
    id: 314,
    craftName: "Maser Arm",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Slashes foes with a spinning attack. Unbalance+20%. [Seal (50%)/Mute (50%)]",
  },
  {
    id: 315,
    craftName: "Brionac",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Cuts all with a laser beam. Unbalance+50%. [DEF/ADF-25% (3 turns)]",
  },
  {
    id: 316,
    craftName: "Black Barrier",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description:
      "Creates a black barrier, reflecting two physical attacks. [Physical Reflect (x2)]",
  },
  {
    id: 317,
    craftName: "Ragna Bringer",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 2",
    description: "Turns Claiomh Solais into a sword.",
  },
  {
    id: 318,
    craftName: "Crimson Slash",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description: "Unleashes a burning shockwave. [Impede (100%)/Burn (30%)]",
  },
  {
    id: 319,
    craftName: "Crescent Flash",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description: "Quickdraws a blade with overwhelming force. Unbalance+25%.",
  },
  {
    id: 320,
    craftName: "Helix",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "A series of burning slashes that end with a tornado of flames. Unbalance+10%. [Critical rate+20%]",
  },
  {
    id: 321,
    craftName: "7th Slash - Fallen Leaves",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Slices through foes in a single, fleeting moment. [SPD Down (L) (5 turns)]",
  },
  {
    id: 322,
    craftName: "Cross Break",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Shocks enemies with an electric discharge. [Impede (100%)/Faint (30%)]",
  },
  {
    id: 323,
    craftName: "Gemini Blast",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Riddles the enemy full of holes with a relentless barrage of bullets. [DEF/SPD Down (S) (3 turns)]",
  },
  {
    id: 324,
    craftName: "Brave Smash",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Fires a highly charged blast of energy. Unbalance+20%. [Seal (30%)]",
  },
  {
    id: 325,
    craftName: "Quick Star",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Breaks the time barrier, allowing allies to act faster. [Accelerate/SPD+ (M) (3 turns)]",
  },
  {
    id: 326,
    craftName: "Excel Breaker",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description: "Barrages the enemy with a great laser beam.",
  },
  {
    id: 327,
    craftName: "Rain Slash",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "A flurry of slashes that cut like driving rain. Unbalance+15%. [Delay+10]",
  },
  {
    id: 328,
    craftName: "Twilit Blades",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Launches shockwaves infused with darkness and light. Hits twice. [Impede (100%)/Blind (50%)]",
  },
  {
    id: 329,
    craftName: "Blade Dance",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Pushes power past human limits, but a price. [Brandish (3 turns)/STR/SPD+ (M) (3 turns)]",
  },
  {
    id: 330,
    craftName: "Tempest Edge",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "A spinning slash that slices through a group of enemies like a whirlwind. Unbalance+30%. [Seal (50%)/Mute (50%)]",
  },
  {
    id: 331,
    craftName: "Ragna Strike",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Slices up foes like a howling storm and rains vicious bolts of lightning down. [Seal (50%)]",
  },
  {
    id: 332,
    craftName: "Argem Heal",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Converts Claiomh Solais' power into healing energy. [HP Heal (20%)/CP+20]",
  },
  {
    id: 333,
    craftName: "Fragarach",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Morphs Claiomh Solais' hand into a sharp blade and brings it down on foes. Unbalance+Yes. [Delay+10]",
  },
  {
    id: 334,
    craftName: "Ebon Shade",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Generates a black barrier that protects and camouflages its user. [Physical Reflect/Stealth (2 turns)]",
  },
  {
    id: 335,
    craftName: "Arcadias Gear",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Altina merges with Claiomh Solais and rains down destruction.",
  },
  {
    id: 336,
    craftName: "Oiseau Bleu",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Fires a blue energy bullet in the shape of a bird. Unbalance+Yes. [Freeze (20%) / Petrify (20%)]",
  },
  {
    id: 337,
    craftName: "Saphir Rain",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Shatters a healing gem to restore health. [HP Heal (20%) / Cures all (except K.O.)]",
  },
  {
    id: 338,
    craftName: "Cutie Bullet",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Shoots through the heart with a charm-filled bullet. Unbalance+30%. [Charm (90%)]",
  },
  {
    id: 339,
    craftName: "Moulin Rouge",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Fires a series of magical blades in an unpredictable arc. Unbalance+10%. [Burn (50%)]",
  },
  {
    id: 340,
    craftName: "Brilliant Shot",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Traps foes in a prism of ice and fires a laser. [Random abnormality (100%)]",
  },
  {
    id: 341,
    craftName: "Rumbling Smash",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Unleashes a powerful strike like a rampaging beast. Unbalance+Yes. [Impede (100%)/Faint (30%)]",
  },
  {
    id: 342,
    craftName: "Reaper's Whirlwind",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Switches to scythe mode to bring death to the battlefield. Unbalance+10%. [K.O. (50%)/Nightmare (50%)]",
  },
  {
    id: 343,
    craftName: "Unbound Rage",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description: "Releases fury buried deep within. [CP+50/STR↑ (L) (2 turns)]",
  },
  {
    id: 344,
    craftName: "Void Breaker",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Wraps enemies in a bladed chain, crushing their armor. Unbalance+30%. [DEF↓ (L) (3 turns)]",
  },
  {
    id: 345,
    craftName: "Belial Raid",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Binds foes with a chain and makes the field run red. [K.O. (30%)/Confuse (30%)]",
  },
  {
    id: 346,
    craftName: "Gabriel Arrow",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description: "Fires a burning arrows that burns away impurity. [Mute 100%]",
  },
  {
    id: 347,
    craftName: "Remedy Fantasia",
    character: "Elliot Craig",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Plays a blessed melody to purify all allies. [Restores all HP/Cures K.O. (HP+50% (2 turns) when at 200 CP)]",
  },
  {
    id: 348,
    craftName: "Lion Rush",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Strikes with the power of a lion and tears away enemy defenses. Unbalance+10%. [STR/DEF↓ (M) (3 turns)]",
  },
  {
    id: 349,
    craftName: "Radiant Phoenix Blade",
    character: "Laura S. Arseid",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "The final skill of the Arseid school. Destroys foes with a dazzling blade. [Faint (100%)]",
  },
  {
    id: 350,
    craftName: "Justice Bullet",
    character: "Machias Regnitz",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Dispenses justice using multiple firearms at once. [Random abnormality (100%)]",
  },
  {
    id: 351,
    craftName: "Palace of Eregion",
    character: "Emma Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Manifests a divine palace to give a great boost to allies' defenses. [Absolute Reflect (Reflects twice when at 200CP)]",
  },
  {
    id: 352,
    craftName: "Aeolus Saber",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Manifests a holy blade that pierces the earth and brings divine retribution. [Seal (100%)]",
  },
  {
    id: 353,
    craftName: "Cipher Edge",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Slices enemies to ribbons with a lightning-fast dash attack. [K.O. (30%)]",
  },
  {
    id: 354,
    craftName: "Tri-Cyclone",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Oppresses the enemy with intense chained attacks that delay their movement. [Seal (30%)/Delay+5]",
  },
  {
    id: 355,
    craftName: "Lethal Crusade",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Unleashes a storm of life-ending bullets over the battlefield. [K.O. (50%)]",
  },
  {
    id: 356,
    craftName: "Gale Storm",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Swallows up a line of enemies in a storm of purification. Unbalance+10%. [Balance Down (2 turns)]",
  },
  {
    id: 357,
    craftName: "Thunder Fang",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Soars high into the sky and then descends on a bolt of lightning. Unbalance+20%. [Delay+10/Seal (70%)]",
  },
  {
    id: 358,
    craftName: "Golden Howl",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Unleashes hidden rage to turn vitality into CP. [HP-30%/STR/DEF↑ (L) (3 turns)/CP+60]",
  },
  {
    id: 359,
    craftName: "Howling Heavens",
    character: "Gaius Worzel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Summons a holy lance that pierces the heavens and brings destruction. [Absolute Delay+10]",
  },
  {
    id: 360,
    craftName: "Terra Breaker",
    character: "Millium Orion",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Splits up Airgetlam and unleashes a huge sphere powerful enough to smash stars. [Faint (100%)]",
  },
  {
    id: 361,
    craftName: "Searing Flash",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Tramples an enemy with the ferocity of lightning and burns them to a crisp. Unbalance+Yes. [Delay+10/Burn (30%)]",
  },
  {
    id: 362,
    craftName: "Northern Lightning",
    character: "Sara Valestein",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "A lost art refined by the power of jaegers and will of bracers. [Seal (100%)]",
  },
  {
    id: 363,
    craftName: "Requiem Shot",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Shoots a silver bullet blessed with a prayer straight through a line of enemies. [Nightmare (100%)]",
  },
  {
    id: 364,
    craftName: "Akashic Star",
    character: "Olivier Lenheim",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Crushes a golden sphere into bullets of light that rain down on enemies.",
  },
  {
    id: 365,
    craftName: "Dynast Sunder",
    character: "Aurelia Le Guin",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "An overwhelming attack that cuts through any obstacle. Unbalance+30%. [STR/ATS↓ (L) (3 turns)]",
  },
  {
    id: 366,
    craftName: "Prismatic Tetra Blade",
    character: "Aurelia Le Guin",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "A slashing attack that harnesses the power of four elements. [Petrify/Freeze/Burn/Sleep (30%)]",
  },
  {
    id: 367,
    craftName: "Military Might",
    character: "Aurelia Le Guin",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Gives encouragement and enshrouds in a golden battle aura. [Brandish (3 turns)/STR/ATS/SPD↑ (L) (3 turns)]",
  },
  {
    id: 368,
    craftName: "Rakshasa Onslaught",
    character: "Aurelia Le Guin",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Unleashes multiple deathblows with countless golden blades. [All stats↓ (L) (2 turns)]",
  },
  {
    id: 369,
    craftName: "Hard Straight",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description: "Mounts a shoulder cannon and machine-guns the enemy.",
  },
  {
    id: 370,
    craftName: "Chaff Grenade",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Launches a special grenade from a shoulder cannon that lowers the enemy's stats. [Impede (100%)/Random Stat Down]",
  },
  {
    id: 371,
    craftName: "Heavy Accel",
    character: "Tita Russell",
    gender: "Female",
    game: "Trails of Cold Steel 3",
    description:
      "Revs boosters to full power and charges into the enemy. [Delay+20/Faint (50%)]",
  },
  {
    id: 372,
    craftName: "Laevateinn",
    character: "Lechter Arundel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Brings destruction about with an intensely burning black flame. Unbalance+30%. [Burn (50%)/Nightmare (50%)]",
  },
  {
    id: 373,
    craftName: "Spell Card",
    character: "Lechter Arundel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Brings about different effects depending on the randomly drawn card. [Support - All - Random effect on ally or enemy]",
  },
  {
    id: 374,
    craftName: "Rubrum Knight",
    character: "Lechter Arundel",
    gender: "Male",
    game: "Trails of Cold Steel 3",
    description:
      "Following a flurry of attacks, traps an enemy in a ruby before crushing it. [Random abnormality (100%)]",
  },
  {
    id: 375,
    craftName: "Breaking Dawn",
    character: "Rean Schwarzer",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "An Eight Leaves technique that drives back the darkness. [Remove positive effects]",
  },
  {
    id: 376,
    craftName: "Burning Heart",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A full-hearted shout to encourage allies. [STR/DEF↑ (M) (4 turns)/Restores 1 BP]",
  },
  {
    id: 377,
    craftName: "Valiant Charge",
    character: "Juna Crawford",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Fires shot from an enchanced gunbreaker before charging in. [Physical - All]",
  },
  {
    id: 378,
    craftName: "Whirling Steel",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Dances up a storm with twin blades to cut down the enemy. [Critical rate+30%]",
  },
  {
    id: 379,
    craftName: "Gemini Judgement",
    character: "Kurt Vander",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "A dual sword art of harmonious balance that ensnares foes in a stellar explosion.",
  },
  {
    id: 380,
    craftName: "Solaris Bringer",
    character: "Altina Orion",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Turns Claiomh Solais into a giant sword that cleaves the earth. [Magical - All - Critical rate+20%]",
  },
  {
    id: 381,
    craftName: "Penta-Shot",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Creates a magic circle with bullets that exorcises foes. Unbalance+Yes. [Magical - Area LL - Suction - Mute (100%)]",
  },
  {
    id: 382,
    craftName: "Galaxia Volley",
    character: "Musse Egret",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Magically replicates the arts rifle to mow down targets. [Magical - Line M+ (Set)]",
  },
  {
    id: 383,
    craftName: "Dead Man's Dart",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Throws a cursed dart that drags its target into the abyss. Unbalance+Yes. [Magical - Line M+ (Set) - Balance Down (20% chance) (2 turns)]",
  },
  {
    id: 384,
    craftName: "Sinner's Revelry",
    character: "Ash Carbide",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Launches foes skyward, then sends them straight to Gehenna. [Physical - One - All stats↓ (S) (4 turns)]",
  },
  {
    id: 385,
    craftName: "Rosetta Arrow",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Draws a magic circle with an arrowhead to create a crimson laser. [Magical - Line S (Set) - Impede (100%) Burn/Crit (25%)]",
  },
  {
    id: 386,
    craftName: "Eye of Balor",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "A magical eye that confuses those who catch its graze, hastening death. Unbalance+15%. [Magical - Area L+ - Charm/Faint/K.O. (20%)]",
  },
  {
    id: 387,
    craftName: "Azure Destiny",
    character: "Crow Armbrust",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Unleashes a dark battle aura, pushing potential to the absolute limit. [Support - Self - Insight (3 turns) - STR/ATS/SPD↑ (L) (6 turns)]",
  },
  {
    id: 388,
    craftName: "Umbral Butterflies",
    character: "Sharon Kreuger",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Open death's door by dampening the target's abilities. [K.O. (50%)/Nightmare (50%)/All stats↓ (L)]",
  },
  {
    id: 389,
    craftName: "Nine Lives",
    character: "Celine Millstein",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Uses the power of the Kin of Fire to boost BP and purify allies. [Recovery - All - Cures ailments/Stat Down - Restores 3 BP]",
  },
  {
    id: 390,
    craftName: "Flame Brand",
    character: "Duvalie",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A sword technique that brands the enemy with raging flames. Unbalance+Yes. [Burn (40%)]",
  },
  {
    id: 391,
    craftName: "Glacial Brand",
    character: "Duvalie",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A sword technique that brands the enemy with sub-zero ice. Unbalance+Yes. [Freeze (40%)]",
  },
  {
    id: 392,
    craftName: "Storm Brand",
    character: "Duvalie",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A sword technique that brands the enemy with crackling lightning. Unbalance+Yes. [Seal (40%)]",
  },
  {
    id: 393,
    craftName: "Swift Slash",
    character: "Duvalie",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A sword technique that spawns doppelgangers to ensnare the enemy. Unbalance+Yes. [Impede (100%)/Delay+4]",
  },
  {
    id: 394,
    craftName: "Bladelord Specter",
    character: "Duvalie",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A special sword technique in two phases. Taught by the Bladelord. Unbalance+25%. [Confuse (40%)/Critical rate+40%]",
  },
  {
    id: 395,
    craftName: "Prism Caliber",
    character: "Duvalie",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Lashes out at unwary foes with divine swiftness. [SPD↓ (L) (4 turns)]",
  },
  {
    id: 396,
    craftName: "Nemesis Party",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A dancing attack that seals foes' fate with a giant guillotine. [Magical - All - K.O. (50%)]",
  },
  {
    id: 397,
    craftName: "Gramr Cannon",
    character: "George Nome",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Two lasers from shoulder-mounted spheres bore holes into the enemy. Unbalance+Yes. [Magical - Line M+ (Set)]",
  },
  {
    id: 398,
    craftName: "Caladbolg",
    character: "George Nome",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Transforms the combat shell into a hammer drill that shreds foes. Unbalance+10%. [Physical - Area M (Set) - Faint (50%)]",
  },
  {
    id: 399,
    craftName: "Bloody Fang",
    character: "Roselia",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Disperses the lifeforce absorbed from the target to all allies. Unbalance+Yes. [Magical - Area M (Set) - Restores ally's HP/CP depending on damage]",
  },
  {
    id: 400,
    craftName: "Crimson Lancer",
    character: "Roselia",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Pierces enemies with a staff entwined by crimson blades of light. Unbalance+20%. [Magical - Line M+ (Set)]",
  },
  {
    id: 401,
    craftName: "Bewitching Blood Moon",
    character: "Roselia",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Immolates everything on the ground using scorching heat rays. [Magical - All]",
  },
  {
    id: 402,
    craftName: "True Radiant Cleaver",
    character: "Victor S. Arseid",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Splits the ground, leaving a glowing crater. Unbalance+50%. [Physical - Line S+ (Set) - SPD/MOV↓ (M) (4 turns)]",
  },
  {
    id: 403,
    craftName: "True Radiant Spin",
    character: "Victor S. Arseid",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Draws foes into an inescapable gleaming vortex. Unbalance+10%. [Physical - Area L (Set) - Suction - Faint (100%)]",
  },
  {
    id: 404,
    craftName: "True Radiant Wings",
    character: "Victor S. Arseid",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Increases strength and healing to their very limits. [Support - Self - Brandish (3 turns) - STR↑ (L) (4 turns) - Restores 10% HP]",
  },
  {
    id: 405,
    craftName: "Radiant Phoenix Blade",
    character: "Victor S. Arseid",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "The final skill of the Arseid school. Destroys foes with a dazzling blade. [Physical - All - Faint (100%)]",
  },
  {
    id: 406,
    craftName: "Helm Splitter",
    character: "Ines",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A powerful strike that cracks open the enemy's skull. Unbalance+5%. [Physical - Area S (Set) - Faint (50%)]",
  },
  {
    id: 407,
    craftName: "Heavy Divider",
    character: "Ines",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Robs the enemy of its mobility with a determined assault. Unbalance+20%. [Physical - Area M+ (Set) - Delay+2 - MOV/SPD↓ (M) (4 turns)]",
  },
  {
    id: 408,
    craftName: "Shield of the Order",
    character: "Ines",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Enhances healing power and creates an impenetrable wall. [Support - Self - Complete Immunity - Restores 10% HP (5 turns)]",
  },
  {
    id: 409,
    craftName: "Piercing Arrow",
    character: "Ennea",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "An arrow that pierces the enemy with cruel accuracy. Unbalance+15%. [Physical - Line S+ (Set) - Impede (100%)]",
  },
  {
    id: 410,
    craftName: "Angel Arrow",
    character: "Ennea",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A targeted shot accompanied by a sweet smile, confusing enemies. Unbalance+Yes. [Magical - Area M (Set) - Confuse (50%)]",
  },
  {
    id: 411,
    craftName: "Medusa Arrow",
    character: "Ennea",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "Releases an arrow imbued with an art that petrifies the enemy. Unbalance+Yes. [Magical - Area M (Set) - Petrify (50%)]",
  },
  {
    id: 412,
    craftName: "Accel Arrow",
    character: "Ennea",
    gender: "Female",
    game: "Trails of Cold Steel 4",
    description:
      "A skilled technique that reinforces the body of the archer. [Support - One - Accelerate - SPD↑ (L) (4 turns)]",
  },
  {
    id: 413,
    craftName: "Storm Raid",
    character: "Xeno",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Obstructs the enemy's vision with a tempestuous attack. Unbalance+10%. [Physical - Line S+ (Set) - Blind (50%)]",
  },
  {
    id: 414,
    craftName: "Murderous Shot",
    character: "Xeno",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Fires through foes with a large rifle, sending them to the abyss. Unbalance+Yes. [Physical - Line S (Set) - K.O. (20%)]",
  },
  {
    id: 415,
    craftName: "Javelin Throw",
    character: "Xeno",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Detonates trap javelins in a continuous, threefold assault. Unbalance+15%. [Physical - Area M+ (Set) - Burn/Confuse/Petrify (50%)]",
  },
  {
    id: 416,
    craftName: "Genocide Rain",
    character: "Xeno",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Snipes from high above, detonating javelins around the enemy with deadly precision. [Physical - Area LL+ - STR↓ (L) (4 turns)]",
  },
  {
    id: 417,
    craftName: "Brutal Spin",
    character: "Leonidas",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "An intense spinning attack that knocks the enemy out cold. Unbalance+Yes. [Physical - Area L (Set) - Faint (50%)]",
  },
  {
    id: 418,
    craftName: "Destructive Buster",
    character: "Leonidas",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Strikes the ground, creating a shockwave that slows the enemy. Unbalance+30%. [Physical - Area L+ (Set) - MOV↓ (L) (4 turns)]",
  },
  {
    id: 419,
    craftName: "Imperial Spike",
    character: "Leonidas",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Attack all enemies within range. Unbalance+Yes. [Physical - Line S+ (Set) - Delay+4]",
  },
  {
    id: 420,
    craftName: "Calamitous Arm",
    character: "Leonidas",
    gender: "Male",
    game: "Trails of Cold Steel 4",
    description:
      "Disrupts foes with a shock wave and finishes with a piledriver. [Physical - Area LL+ - DEF↓ (L) (4 turns)]",
  },
  {
    id: 421,
    craftName: "Carnage Raid",
    character: "Randy Orlando",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Eliminates enemies with flaming slashes and sharp gunfire. [Physical - Area S (Set) - Critical Rate +30% - Random Stat ↓ (L) for 4 turns]",
  },
  {
    id: 422,
    craftName: "Wild Stampede",
    character: "Noel Seeker",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Sends enemies flying with a violent motorcycle attack accompanied by gunfire. [Physical - All - All Stats ↓ (S) for 4 turns]",
  },
  {
    id: 428,
    craftName: "Soul Eater",
    character: "C/Reverie",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Performs a gruesome series of thrusts that devour the enemy's life force. [Physical - Area S+ (Set) - Impede (100%) - Restores ally's HP/CP based on damage dealt]",
  },
  {
    id: 429,
    craftName: "Renegade Edge",
    character: "C/Reverie",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Cuts down both the sphere it unleashes and the enemy, triggering an explosion. [Magical - Area M+ (Set) - Mute/Blind (80%) - Delay +4]",
  },
  {
    id: 430,
    craftName: "Zevarl",
    character: "C/Reverie",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Charges one's aura into a high-level sword technique consisting of three mighty slashes. [Physical - Area M+ (Set) - Brandish for 3 turns - SPD ↑ (L) for 3 turns]",
  },
  {
    id: 431,
    craftName: "Noblesse Rune",
    character: "C/Reverie",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Raises attack power and BP gain by manifesting one's natural noble aura. [Support - Self - STR·ATS ↑ (M) for 3 turns - Cures Ailments/Stat Down - Restores 1 BP]",
  },
  {
    id: 432,
    craftName: "Blutgang Rain",
    character: "C/Reverie",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Directs a series of summoned swords and rains them down upon the enemy without mercy. [Physical - All]",
  },
  {
    id: 433,
    craftName: "Emerald Eye",
    character: "Lapis Rosenberg",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Analyzes enemy weaknesses through emerald eyes, lowering their mobility, defenses, and balance. [Analysis - Balance down (100%) - DEF·ADF·MOV↓ (S) (4 turns)]",
  },
  {
    id: 434,
    craftName: "Adamas Ripper",
    character: "Lapis Rosenberg",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Smashes against the ground, causing a massive shockwave that trembles even distant earth. [Physical - Area M (Set) - STR·ATS↓ (S) (4 turns)]",
  },
  {
    id: 435,
    craftName: "Edel Heart",
    character: "Lapis Rosenberg",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Releases output limiter, healing one's physical self while boosting one's abilities. [Support - Self - STR·ATS·DEF↑ (S) (4 turns) - Restores 30% HP - CP+30]",
  },
  {
    id: 436,
    craftName: "Grimoire Arc",
    character: "Lapis Rosenberg",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Unleashes an evil spirit from one's accompanying case to attack enemies. [Magical - Area M (Set) - Faint/Confuse/Nightmare (20%)]",
  },
  {
    id: 437,
    craftName: "My Mirror Image",
    character: "Lapis Rosenberg",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Traps enemies within mirrors and reduces them to shards with the swing of an axe. [Physical - All - Faint (100%)]",
  },
  {
    id: 438,
    craftName: "Mark",
    character: "Swin Abel",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Brandishes enemies in range with a fast slashing attack. [Physical - Area S+ (Set) - Mark (100%) for 3 turns]",
  },
  {
    id: 439,
    craftName: "Revelation",
    character: "Swin Abel",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Combines twin blades into one for a slash that cuts enemies in two. [Physical - One - Mark (60%) for 3 turns]",
  },
  {
    id: 440,
    craftName: "Zoom Zone",
    character: "Swin Abel",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Hones one's focus to gain CP and increase both attack and speed. [Support - Self - STR·SPD↑ (S) for 4 turns - CP+20 for 4 turns]",
  },
  {
    id: 441,
    craftName: "Three of Swords",
    character: "Swin Abel",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Unlocks one's power by overcoming the past, unleashing strikes and slashes alike with twin swords. [Physical - Area LL (Set) - Mark (100%) for 3 turns]",
  },
  {
    id: 442,
    craftName: "Punitive Pierce",
    character: "Nadia Rayne",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Throws out six hidden poison needles that provide a variety of possible effects. [Magical - Line S (Set) - Impede (100%) - Nightmare/Burn (80%)]",
  },
  {
    id: 443,
    craftName: "Pep Boost!",
    character: "Nadia Rayne",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Tosses one's teddy bear into the air, causing it to explode with reinvigorating goodness. [Recovery - Area M (Set) - Restores 30% HP - Cures All]",
  },
  {
    id: 444,
    craftName: "Thready Bear",
    character: "Nadia Rayne",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Wraps enemies in threads attached to needles, piercing them to bits with blades they cannot even see. [Magical - Area L (Set) - Weak for 2 turns - K.O. (30%)]",
  },
  {
    id: 445,
    craftName: "Nadia Special",
    character: "Nadia Rayne",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Encourages one's teddy bear to perform a body slam, following it up with an explosion. [Magical - All - Random Ailment (100%)]",
  },
  {
    id: 446,
    craftName: "Summon Orbal Gear",
    character: "Alisa Reinford",
    gender: "Female",
    game: "Trails into Cold Steel 4",
    description:
      "Expends 200 EP to summon Orbal Gear EXA. Can only be used once in battle. [Magical - All - Seal (100%)]",
  },
  {
    id: 447,
    craftName: "Holy Sword of Elvars",
    character: "Jusis Albarea",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Wields immense power to cut down any and all evil. [Physical - Area M (Set) - Brandish - STR·ATS ↑ (S) for 3 turns]",
  },
  {
    id: 448,
    craftName: "Dvergr Hammer",
    character: "George Nome",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Transforms Naglfar into a launcher and fires a piercing missile toward the ground. [Physical - All]",
  },
  {
    id: 449,
    craftName: "Pure Serenity",
    character: "Elise Schwarzer",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Focuses one's spirit like the clear surface of water, raising one's power. [Support - Self - STR·ATS·SPD ↑ (S) for 4 turns]",
  },
  {
    id: 450,
    craftName: "Crimson Tail",
    character: "Celine Millstein",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Swings one's flame-wreathed tail while shooting fireballs at foes. [Magical - Area LL (Set) - Burn (150%)]",
  },
  {
    id: 451,
    craftName: "Concentration",
    character: "Claire Rieveldt",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Hones one's focus to raise calculative abilities, attack, and gain insight. [Support - Self - Insight - STR·ATS ↑ (M) (4 turns)]",
  },
  {
    id: 452,
    craftName: "Getting Heated",
    character: "Lechter Arundel",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Heats things up to gain CP and raise one's attack. [Support - Self - CP+40/STR·ATS ↑(M) for 3 turns]",
  },
  {
    id: 453,
    craftName: "Zodiac Code",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails into Reverie",
    description:
      "Makes supporting arts using a code created to oppose none other than the Astral Code. [Support - Self - ATS·ADF·SPD ↑ (M) (4 turns) - Restores 20% EP - Restores 1 BP]",
  },
  {
    id: 454,
    craftName: "Twin Arcane Gale",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Performs a double strike through afterimages that cuts through enemies at godlike speed. [Physical - Line LL (Set) - Impede (100%) - Removes Positive Effects]",
  },
  {
    id: 455,
    craftName: "Second Slash - Raging Tempest",
    character: "Arios MacLaine",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Covers the battlefield with a tempest that eliminates the enemy group as if they were nothing. [Physical - All - Seal (150%)]",
  },
  {
    id: 456,
    craftName: "Flames of Judgment",
    character: "McBurn",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Raises pillars of flames that appear to have clawed their ways out of Gehenna itself. [Magical - Area L (Set) - Burn (70%) - Removes Positive Effects]",
  },
  {
    id: 457,
    craftName: "Hellhounds",
    character: "McBurn",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Summons hounds born from blazing flames to devour enemies. [Magical - Line M (Set) - Scorch/K.O. (25%)]",
  },
  {
    id: 458,
    craftName: "Demonic Sword Angbar",
    character: "McBurn",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Burns away all with a sword forged from the Divergent Laws. [Physical - Area M (Set) - Burn/Faint/Nightmare (40%)]",
  },
  {
    id: 459,
    craftName: "Blazing Demon",
    character: "McBurn",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Transforms into the ****, raising all of their stats exponentially for a time. [Support - Self - Demonization - Restores 150% HP - STR·ATS·SPD ↑ (L) for 6 turns - CP+100]",
  },
  {
    id: 460,
    craftName: "Incandescent Hellfire",
    character: "McBurn",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Fires dense projectiles of fire that cause a giant explosion, reducing all to nothing. [Physical - All - Scorch (60%) - Removes Positive Effects]",
  },
  {
    id: 461,
    craftName: "Melting Slicer",
    character: "Cedric Reise Arnor",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Thrusts repeatedly into enemies with a sword wrapped in melting flames. [Physical - Area M (Set) - Burn (60%)]",
  },
  {
    id: 462,
    craftName: "Talisman Blade",
    character: "Cedric Reise Arnor",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Encloses the enemy in a burning hot sphere and demolishes it with one's sword. [Magical - Area M (Set) - Confuse (30%)]",
  },
  {
    id: 463,
    craftName: "Burning Cry",
    character: "Cedric Reise Arnor",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Raises one's own attack power by letting out a passionate cry. [Support - Self - STR·ATS ↑ (M) for 4 turns - CP+30]",
  },
  {
    id: 464,
    craftName: "Purgatory Saber",
    character: "Cedric Reise Arnor",
    gender: "Male",
    game: "Trails into Reverie",
    description:
      "Sends a series of blazing projectiles while also delivering a scorching slash. [Physical - All - Burn (150%)]",
  },
  {
    id: 465,
    craftName: "Weapon Break",
    character: "Meltgunner",
    gender: "Robot",
    game: "Trails into Reverie",
    description:
      "Precisely calculates the range to target and fires, lowering a target's offensive power. [Physical - Area M (Set) - STR ↓ (S)]",
  },
  {
    id: 466,
    craftName: "Armor Break",
    character: "Meltgunner",
    gender: "Robot",
    game: "Trails into Reverie",
    description:
      "Calculates precise range and fires multiple shots, dropping a target's defense. [Physical - Area M (Set) - DEF ↓ (S)]",
  },
  {
    id: 467,
    craftName: "Arts Canceller",
    character: "Meltgunner",
    gender: "Robot",
    game: "Trails into Reverie",
    description:
      "Calculates precise range and fires multiple shots, interrupting a target's arts incantation. [Physical - Area M (Set) - Impede (100%)]",
  },
  {
    id: 468,
    craftName: "Heated Roar",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "A Kunlun qigong technique that fills the body with power. [Self-Buff - Temper, HP Regen on Turn]",
  },
  {
    id: 469,
    craftName: "Magna Slash",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "A charged sideways slash that leaves foes breathless. [Physical - Impede & Side Attack Bonus]",
  },
  {
    id: 470,
    craftName: "Heavenly Halter",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Staggers foes with a Kunlun-style stun caliber combo. [Physical - Slow]",
  },
  {
    id: 471,
    craftName: "Raging Buster",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "A mighty acrobatic slash that crushes foes. [Physical - Delay (M), Back Attack Bonus]",
  },
  {
    id: 472,
    craftName: "Take the Grendel",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Transforms *** into the *** by enveloping him in shards. [Transformation - Become ***, Recover 100 CP]",
  },
  {
    id: 473,
    craftName: "Vandalize Raid",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description: "A combo attack that leaves foes hopeless. [Physical]",
  },
  {
    id: 474,
    craftName: "Coin Bullets",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Fires off 10 mira coins like bullets, drawing enemy attention. [Magic - DMG Down & Hate Up]",
  },
  {
    id: 475,
    craftName: "Rapid Onslaught",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "A series of punches that make full use of the Grendel's agility. [Physical - RES Down]",
  },
  {
    id: 476,
    craftName: "Heavy Spike",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "An inhuman aerial attack that kicks twice. [Physical - ADMG Down]",
  },
  {
    id: 477,
    craftName: "Savage Blade",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Tears through foes with a deadly blade. [Physical - HP Absorb]",
  },
  {
    id: 478,
    craftName: "Howling Roar",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Terrifies foes with a demonic roar. [Magic - Impede, Hate Up]",
  },
  {
    id: 479,
    craftName: "Mortal Raid",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "A combo of kicks too fast to be seen by the naked eye. [Physical - ARES Down]",
  },
  {
    id: 480,
    craftName: "Limited Blaster",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description: "Fires a high-output shard. [Magic - DMG Down]",
  },
  {
    id: 481,
    craftName: "Oblivion Fist",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Traps foes in lightning, then summons a devastating shockwave. [Physical - Slow]",
  },
  {
    id: 482,
    craftName: "Regal Beatdown",
    character: "Grendel",
    gender: "Male",
    game: "Trails through Daybreak",
    description: "A powerful, destructive rush. [Physical]",
  },
  {
    id: 483,
    craftName: "White Heal",
    character: "Agnès Claudel",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Heals and purifies allies with waves of white light. [Support - HP Recovery & Heal Ailments/Stat Down]",
  },
  {
    id: 484,
    craftName: "Glow Hammer",
    character: "Agnès Claudel",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Converts damage dealt into EP. Damage increases with higher STR. [Physical - EP Absorb & Back Attack Bonus]",
  },
  {
    id: 485,
    craftName: "Étoile Ray",
    character: "Agnès Claudel",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Blast foes with concentrated rays of orbal interference. [Magic - ADMG Down]",
  },
  {
    id: 486,
    craftName: "Jibril Guard",
    character: "Agnès Claudel",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Deploys a shield to guard allies. [Support - Shield, HP Regen on Turn]",
  },
  {
    id: 487,
    craftName: "Brilliant Halo",
    character: "Agnès Claudel",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Summons a circle of holy light to fully heal all allies. [Support - Full HP Heal, HP Regen on Turn]",
  },
  {
    id: 488,
    craftName: "Flaming Prayer",
    character: "Feri Al-Fayed",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Offers up a prayer that blesses all allies. [Support - DMG Up, CP Regen on Turn]",
  },
  {
    id: 489,
    craftName: "Bulwark Blade",
    character: "Feri Al-Fayed",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Weakens foes with a knife blessed by the flames. [Magic - RES/ARES Down]",
  },
  {
    id: 490,
    craftName: "Rapid Eruption",
    character: "Feri Al-Fayed",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Uses rapid yet accurate firepower to control the battlefield. [Physical - Slow]",
  },
  {
    id: 491,
    craftName: "Infernal Edge",
    character: "Feri Al-Fayed",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Cuts through foes with an infernal blade. [Physical - Burn, Side Attack Bonus]",
  },
  {
    id: 492,
    craftName: "Ignis Rampage",
    character: "Feri Al-Fayed",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Sets the battlefield alight with the full power of the flames. [Physical - Burn]",
  },
  {
    id: 493,
    craftName: "Bawanggong",
    character: "Aaron Wei",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Exchanges vitality for heightened spiritual power. [Self-Buff (Cost HP) - Strait, Insight]",
  },
  {
    id: 494,
    craftName: "Shuangxing Huangren",
    character: "Aaron Wei",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Draws out the opposing forces within to decimate foes. [Magic - Impede, Mute]",
  },
  {
    id: 495,
    craftName: "Blazing Slash",
    character: "Aaron Wei",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "An unceasing bombardment of multiple Gekka-style blows from above. [Physical - Delay (M)]",
  },
  {
    id: 496,
    craftName: "Talon Barrage",
    character: "Aaron Wei",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "The perfected mimicry of a striking bird of prey. [Physical - Seal, Back Attack Bonus]",
  },
  {
    id: 497,
    craftName: "Phoenix Dance",
    character: "Aaron Wei",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Overwhelms foes with wild yet breathtaking sword strikes. [Physical]",
  },
  {
    id: 498,
    craftName: "Silent Slasher",
    character: "Risette Twinings",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Carves through foes cleanly and quietly. [Physical - Deathblow, Back Attack Bonus]",
  },
  {
    id: 499,
    craftName: "Edel Snipe",
    character: "Risette Twinings",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Elegantly fires a sniper shot with deadly precision. [Magic - Side Attack Bonus]",
  },
  {
    id: 500,
    craftName: "Cobalt Curtain",
    character: "Risette Twinings",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Deploys a defensive field that boosts strength. [Support - Shield, RES/ARES Up]",
  },
  {
    id: 501,
    craftName: "Sonic Chaser",
    character: "Risette Twinings",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "A series of attacks inconceivable to the naked eye. [Physical - Quick]",
  },
  {
    id: 502,
    craftName: "Radiant Seeker",
    character: "Risette Twinings",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Traps foes, then unleashes a deadly omnidirectional attack. [Physical - Deathblow]",
  },
  {
    id: 503,
    craftName: "Optical Cannon",
    character: "Quatre Salision",
    gender: "Agender",
    game: "Trails through Daybreak",
    description:
      "Disables FIO's limiters and fires an ultra-low temperature beam. [Magic - Freeze, Side Attack Bonus]",
  },
  {
    id: 504,
    craftName: "Satellite Cure",
    character: "Quatre Salision",
    gender: "Agender",
    game: "Trails through Daybreak",
    description:
      "Orders FIO to emit a ray that heals allies. [Support - HP Heal (M), CP Boost]",
  },
  {
    id: 505,
    craftName: "Procyon Fang",
    character: "Quatre Salision",
    gender: "Agender",
    game: "Trails through Daybreak",
    description:
      "Orders XEROS to tear foes asunder. [Physical - DMG/ADMG Down]",
  },
  {
    id: 506,
    craftName: "Digamma Driver",
    character: "Quatre Salision",
    gender: "Agender",
    game: "Trails through Daybreak",
    description:
      "While riding XEROS pierce foes with a FIO-made lance of light. [Magic - Freeze]",
  },
  {
    id: 507,
    craftName: "Twilight Kiss",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Bring foes to their knees with kiss-marked calling cards. [Magic - Bewitch/Remove Buffs]",
  },
  {
    id: 508,
    craftName: "Swift Larceny",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "A stylish thieving technique inconceivable to the naked eye. [Physical - HP Absorb/Gain Sepith]",
  },
  {
    id: 509,
    craftName: "Criminal Beaut",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Entangles foes, then sends them flying. [Physical - Ailment Res. Down, Side Attack Bonus]",
  },
  {
    id: 510,
    craftName: "Go! Go! Grimcat!",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Transforms *** into the phantom thief ***! [Transformation - Add. Magic Damage]",
  },
  {
    id: 511,
    craftName: "Revert",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak",
    description: "Reverts ***'s transformation. [Transformation - Revert]",
  },
  {
    id: 512,
    craftName: "Grimnight Waltz",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Leaps through the night sky, catching their prey unawares. [Physical - Blind/Ailment Res. Down]",
  },
  {
    id: 513,
    craftName: "Titus Hammer",
    character: "Bergard Zeman",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Crushes foes with a powerful strike from above. [Physical - Delay (M), Back Attack Bonus]",
  },
  {
    id: 514,
    craftName: "King of the Beasts",
    character: "Bergard Zeman",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Strikes with a Kunlun-style tetsuzanko, unleashing a lion's aura. [Physical - RES/ARES Down]",
  },
  {
    id: 515,
    craftName: "Lion's Roar",
    character: "Bergard Zeman",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "A mighty roar that boosts vigor and unleashes a deadly shockwave. [Magic - Self-Buff, Impede, Vigor]",
  },
  {
    id: 516,
    craftName: "Celestial Impact",
    character: "Bergard Zeman",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Combines six forms of the Kunlun style into an attack. [Physical]",
  },
  {
    id: 517,
    craftName: "Lohengrin",
    character: "Elaine Auclair",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "A beautiful yet deadly dance that cuts foes to ribbons. [Physical - Delay (S), Quick]",
  },
  {
    id: 518,
    craftName: "Kaleido Fencer",
    character: "Elaine Auclair",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Halts foes with a thrust, followed by a faster-than-light strike. [Physical - Delay (M), DMG Up]",
  },
  {
    id: 519,
    craftName: "Silvery Cross",
    character: "Elaine Auclair",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Disrupts enemy formations with beautiful beams of light. [Magic - Seal, Mute, Side Attack Bonus]",
  },
  {
    id: 520,
    craftName: "Knights of Asteria",
    character: "Elaine Auclair",
    gender: "Female",
    game: "Trails through Daybreak",
    description: "Unleashes an elegant barrage of light upon foes. [Physical]",
  },
  {
    id: 521,
    craftName: "Heralding Fist",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Assaults foes with a heavy elbow strike and a deadly punch. [Physical - Delay (M), Back Attack Bonus]",
  },
  {
    id: 522,
    craftName: "Arhat Palm Strike",
    character: "Zin Vathek",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Unleashes a shuangzhangda that can shatter mountains. [Physical - RES/ARES Down]",
  },
  {
    id: 523,
    craftName: "Arc Dominator",
    character: "René Kincaid",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Fires a magical shot that weakens foes. [Magic - All Stats Down]",
  },
  {
    id: 524,
    craftName: "Exceed Rain",
    character: "René Kincaid",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Fires a series of pinpoint shots that rain down upon foes. [Physical - Impede, Ailment RES. Down]",
  },
  {
    id: 525,
    craftName: "Dualizer",
    character: "René Kincaid",
    gender: "Male",
    game: "Trails through Daybreak",
    description:
      "Uses a special pulse gun to power up a targeted ally. [Support - Haste, DMG/ADMG UP (L)]",
  },
  {
    id: 526,
    craftName: "Duality",
    character: "Shizuna Rem Misurugi",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Creates a shadow that can cut through even the bleakest of nights. [Physical - Remove Buffs, Delay (S), Sure Hit]",
  },
  {
    id: 527,
    craftName: "Raging Blizzard",
    character: "Shizuna Rem Misurugi",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "A strike capable of freezing foes' very souls. [Physical - Freeze, Sure Hit]",
  },
  {
    id: 528,
    craftName: "Silver Winds",
    character: "Shizuna Rem Misurugi",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Slices through enemies with blinding speed. [Physical - Sure Hit, Side Attack Bonus]",
  },
  {
    id: 529,
    craftName: "Zeroth Gleam",
    character: "Shizuna Rem Misurugi",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Cleaves through everything in the night—even the moon. [Physical - Delay (L)]",
  },
  {
    id: 530,
    craftName: "Glimmering Flash",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails through Daybreak",
    description:
      "Slices through foes, then showers them with a rain of bullets. [Physical - Seal, Back Attack Bonus]",
  },
  {
    id: 531,
    craftName: "Azure Greon",
    character: "Fie Claussell",
    gender: "Female",
    game: "Trails through Daybreak",
    description: "Unleashes a barrage of steel and illusions. [Physical]",
  },
  {
    id: 532,
    craftName: "Azure Sunray",
    character: "Van Arkride",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "A powerful technique that focuses Van's chi into a single point. [Physical - Physical/Magic Damage]",
  },
  {
    id: 533,
    craftName: "Holy Bloom",
    character: "Agnès Claudel",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Summons holy flowers to restore allies' EP and Boost Gauge. [Support - EP Regen, Boost Recovery]",
  },
  {
    id: 534,
    craftName: "Ifrit Raid",
    character: "Feri Al-Fayed",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "A series of flame attacks that burns foes to cinders. [Physical - Burn]",
  },
  {
    id: 535,
    craftName: "Scarlet Dance",
    character: "Aaron Wei",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "A mysterious dance that addles foes. [Special - Bewitch, DEF Down]",
  },
  {
    id: 536,
    craftName: "Mystic Vision",
    character: "Risette Twinings",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Deploys a shard clone that attacks foes automatically. [Support - Clone]",
  },
  {
    id: 537,
    craftName: "Laplace Code",
    character: "Quatre Salision",
    gender: "Agender",
    game: "Trails through Daybreak",
    description:
      "Expands FIO's systems, creating a protective shield. [Support - Shield, DMG/ADMG Up]",
  },
  {
    id: 538,
    craftName: "Exousia Ray",
    character: "Quatre Salision",
    gender: "Agender",
    game: "Trails through Daybreak 2",
    description: "Rains countless beams of light upon enemies. [Magic - Delay]",
  },
  {
    id: 539,
    craftName: "Shadow Acceleration",
    character: "Judith Lanster",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Summons shadow clones to deal Impede-inflicting blows. [Physical - Impede, Side Attack Bonus]",
  },
  {
    id: 540,
    craftName: "Sword Ortas",
    character: "Elaine Auclair",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Steals power from foes and shares it with allies. [Magic - Party HP/CP Recovery]",
  },
  {
    id: 541,
    craftName: "Lethal Operation",
    character: "René Kincaid",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "An attack that decimates foes with overwhelming firepower. [Physical - All Stats Down]",
  },
  {
    id: 542,
    craftName: "Zoom Blitz",
    character: "Swin Abel",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "A rapid combo of attacks that gives the user a speed boost. [Physical - Mark, Quick]",
  },
  {
    id: 543,
    craftName: "Cross Cipher",
    character: "Swin Abel",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "A barrage of slashes, followed by a powerful strike. [Physical - Mark]",
  },
  {
    id: 544,
    craftName: "Nana Festival",
    character: "Nadia Rayne",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Traps foes in a pile of stuffed animals, then detonates them. [Magic - DMG/ADMG Down]",
  },
  {
    id: 545,
    craftName: "Grand Serpent",
    character: "Celis Ortesia",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Uses a swarm of burning blades to cut down all foes in its path. [Physical - Burn]",
  },
  {
    id: 546,
    craftName: "Surtr's Judgment",
    character: "Celis Ortesia",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Decimates foes with a sword enveloped in flame. [Physical - Burn, DEF Down]",
  },
  {
    id: 547,
    craftName: "Ogun Orisha",
    character: "Celis Ortesia",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Uses the power of fire to strengthen the user and attack foes. [Magic - Burn, DMG Up]",
  },
  {
    id: 548,
    craftName: "Fiamma Midgard",
    character: "Celis Ortesia",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "Summons forth a giant flame serpent that burns enemies to cinders. [Physical - Burn (Strong)]",
  },
  {
    id: 549,
    craftName: "Frigid Pain",
    character: "Leon Balthazar",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "Uses a swarm of frozen blades to cut down all foes in its path. [Magic - Freeze]",
  },
  {
    id: 550,
    craftName: "Gelicide",
    character: "Leon Balthazar",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "Creates a thin blade of ice that tears frozen foes asunder. [Physical - Freeze, ARES Down]",
  },
  {
    id: 551,
    craftName: "Lycoris Radiata",
    character: "Leon Balthazar",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "Red-tinted ice blades that destroy all foes in their path. [Magic - Freeze, Deathblow]",
  },
  {
    id: 552,
    craftName: "Niflheim",
    character: "Leon Balthazar",
    gender: "Male",
    game: "Trails through Daybreak 2",
    description:
      "Summons a permafrost that freezes all foes. [Magic - Freeze (Strong)]",
  },
  {
    id: 553,
    craftName: "Grim Reaper",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "A lethal blow from Renne's scythe, packed with killer intent. [Physical - Deathblow, Blind, Back Attack Bonus]",
  },
  {
    id: 554,
    craftName: "Hospitable Hostess",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "A tea party that bestows allies with protection and healing. [Support - HP Heal, All Stats Up]",
  },
  {
    id: 555,
    craftName: "Double Buster Cannon",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "A massive double-beam emitted by a shard recreation of Pater-Mater. [Magic - RES/ARES Down]",
  },
  {
    id: 556,
    craftName: "Grand Rennede",
    character: "Renne Bright",
    gender: "Female",
    game: "Trails through Daybreak 2",
    description:
      "A lethal strike from the reaper's scythe. [Physical - Deathblow, Blind]",
  },
];
// 201 in array as of 11.04
export const SILHOUETTES = [
  {
    id: "1",
    character: "Rean Schwarzer",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "2",
    character: "Estelle Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "3",
    character: "Renne Bright",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "4",
    character: "Joshua Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "5",
    character: "Loewe",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "6",
    character: "Van Arkride",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "7",
    character: "Shizuna Rem Misurugi",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "8",
    character: "Agnès Claudel",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "9",
    character: "Agate Crosner",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "10",
    character: "Aina Holden",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "11",
    character: "Alan Richard",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "12",
    character: "Albert Russell",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "13",
    character: "Alicia von Auslese",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "14",
    character: "Anelace Elfead",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "15",
    character: "Carna",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "16",
    character: "Dorothy Hyatt",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "17",
    character: "Kloe Rinz",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "18",
    character: "Nial Burns",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "19",
    character: "Olivier Lenheim",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "20",
    character: "Scherazard Harvey",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "21",
    character: "Tita Russell",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "22",
    character: "Zin Vathek",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "23",
    character: "Bleublanc",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "24",
    character: "Campanella",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "25",
    character: "Cassius Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "26",
    character: "Georg Weissmann",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "27",
    character: "Josette Capua",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "28",
    character: "Julia Schwarz",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "29",
    character: "Kevin Graham",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "30",
    character: "Kurt Nardin",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "31",
    character: "Luciola",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "32",
    character: "Walter Kron",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "33",
    character: "Celeste D. Auslese",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "34",
    character: "Dan Russell",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "35",
    character: "Don Capua",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "36",
    character: "Dunan von Auslese",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "37",
    character: "Ein Selnate",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "38",
    character: "Erika Russell",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "39",
    character: "Halle Coleman",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "40",
    character: "Jack Trevor",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "41",
    character: "Jill Ridonor",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "42",
    character: "Kanone Amalthea",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "43",
    character: "Kilika Rouran",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "44",
    character: "Kyle Capua",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "45",
    character: "Lechter Arundel",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "46",
    character: "Lucy Seiland",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "47",
    character: "Maybelle",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "48",
    character: "Mayor Klaus",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "49",
    character: "Mueller Vander",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "50",
    character: "Phillip Runall",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "51",
    character: "Ries Argent",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "52",
    character: "Rufina Argent",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "53",
    character: "Giliath Osborne",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "54",
    character: "Alex Dudley",
    debutGame: "Trails from Zero",
  },
  {
    id: "55",
    character: "Arios MacLaine",
    debutGame: "Trails from Zero",
  },
  {
    id: "56",
    character: "Cao Lee",
    debutGame: "Trails from Zero",
  },
  {
    id: "57",
    character: "Cecile Neues",
    debutGame: "Trails from Zero",
  },
  {
    id: "58",
    character: "Colin Hayworth",
    debutGame: "Trails from Zero",
  },
  {
    id: "59",
    character: "Dieter Crois",
    debutGame: "Trails from Zero",
  },
  {
    id: "60",
    character: "Elie MacDowell",
    debutGame: "Trails from Zero",
  },
  {
    id: "61",
    character: "Ernest Reis",
    debutGame: "Trails from Zero",
  },
  {
    id: "62",
    character: "Fran Seeker",
    debutGame: "Trails from Zero",
  },
  {
    id: "63",
    character: "Garcia Rossi",
    debutGame: "Trails from Zero",
  },
  {
    id: "64",
    character: "Grace Lynn",
    debutGame: "Trails from Zero",
  },
  {
    id: "65",
    character: "Harold Hayworth",
    debutGame: "Trails from Zero",
  },
  {
    id: "66",
    character: "Hartmann",
    debutGame: "Trails from Zero",
  },
  {
    id: "67",
    character: "Henry MacDowell",
    debutGame: "Trails from Zero",
  },
  {
    id: "68",
    character: "Abbas",
    debutGame: "Trails from Zero",
  },
  {
    id: "69",
    character: "Arianrhod",
    debutGame: "Trails to Azure",
  },
  {
    id: "70",
    character: "Novartis",
    debutGame: "Trails to Azure",
  },
  {
    id: "71",
    character: "Guy Bannings",
    debutGame: "Trails from Zero",
  },
  {
    id: "72",
    character: "Sigmund Orlando",
    debutGame: "Trails to Azure",
  },
  {
    id: "73",
    character: "Shirley Orlando",
    debutGame: "Trails to Azure",
  },
  {
    id: "74",
    character: "Samuel Rocksmith",
    debutGame: "Trails to Azure",
  },
  {
    id: "75",
    character: "Mireille",
    debutGame: "Trails from Zero",
  },
  {
    id: "76",
    character: "Michel",
    debutGame: "Trails from Zero",
  },
  {
    id: "77",
    character: "Alfin Reise Arnor",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "78",
    character: "Alisa Reinford",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "79",
    character: "Angelica Rogner",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "80",
    character: "Bridget",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "81",
    character: "Carl Regnitz",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "82",
    character: "Celine Millstein",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "83",
    character: "Claire Rieveldt",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "84",
    character: "Crow Armbrust",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "85",
    character: "Elise Schwarzer",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "86",
    character: "Elliot Craig",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "87",
    character: "Emma Millstein",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "88",
    character: "Fie Claussell",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "89",
    character: "Gaius Worzel",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "90",
    character: "George Nome",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "91",
    character: "Irina Reinford",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "92",
    character: "Jusis Albarea",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "93",
    character: "Laura S. Arseid",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "94",
    character: "Machias Regnitz",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "95",
    character: "Makarov",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "96",
    character: "Mary Altheim",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "97",
    character: "Michael Gideon",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "98",
    character: "Millium Orion",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "99",
    character: "Misty",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "100",
    character: "Vita Clotilde",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "101",
    character: "Neithardt",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "102",
    character: "Patrick T. Hyarms",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "103",
    character: "Rufus Albarea",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "104",
    character: "Sara Valestein",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "105",
    character: "Scarlet",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "106",
    character: "Sharon Kreuger",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "107",
    character: "Towa Herschel",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "108",
    character: "Vandyck",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "109",
    character: "Victor S. Arseid",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "110",
    character: "Vulcan",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "111",
    character: "Altina Orion",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "112",
    character: "Aurelia Le Guin",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "113",
    character: "Croire de Cayenne",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "114",
    character: "Duvalie",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "115",
    character: "Xeno",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "116",
    character: "Leonidas",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "117",
    character: "McBurn",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "118",
    character: "Toval Randonneur",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "119",
    character: "Ada Grant",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "120",
    character: "Black Alberich",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "121",
    character: "Ash Carbide",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "122",
    character: "Aurier Vander",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "123",
    character: "Azure Siegfried",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "124",
    character: "Cedric Reise Arnor",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "125",
    character: "Celestin",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "126",
    character: "Eugent Reise Arnor III",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "127",
    character: "Fernand Hyarms",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "128",
    character: "Ferris Florald",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "129",
    character: "Freddy",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "130",
    character: "Fritz Geithner",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "131",
    character: "Gerhard Schmidt",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "132",
    character: "Hugo Kleist",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "133",
    character: "Jingo",
    debutGame: "Trails from Zero",
  },
  {
    id: "134",
    character: "Juna Crawford",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "135",
    character: "Kurt Vander",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "136",
    character: "Wilhelm Ballad",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "137",
    character: "Matteus Vander",
    debutGame: "Trails into Reverie",
  },
  {
    id: "138",
    character: "Michael Irving",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "139",
    character: "Mint Braun",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "140",
    character: "Musse Egret",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "141",
    character: "Priscilla Reise Arnor",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "142",
    character: "Roselia",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "143",
    character: "Rosine",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "144",
    character: "Rutger Claussell",
    debutGame: "Trails of Cold Steel 3",
  },
  {
    id: "145",
    character: "Thomas Lysander",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "146",
    character: "Beryl",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "147",
    character: "Fiona Craig",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "148",
    character: "Grandmaster",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "149",
    character: "Imelda",
    debutGame: "Trails from Zero",
  },
  {
    id: "150",
    character: "Yun Ka-Fai",
    debutGame: "Trails beyond the Horizon",
  },
  {
    id: "151",
    character: "Marcel Nielsen",
    debutGame: "Trails to Azure",
  },
  {
    id: "152",
    character: "Margarita Dresden",
    debutGame: "Trails of Cold Steel 1",
  },
  {
    id: "153",
    character: "Jona Sacred",
    debutGame: "Trails from Zero",
  },
  {
    id: "154",
    character: "Kaela McMillan",
    debutGame: "Trails of Cold Steel 4",
  },
  {
    id: "155",
    character: "Aeolia",
    debutGame: "Trails from Zero",
  },
  {
    id: "156",
    character: "C/Reverie",
    debutGame: "Trails into Reverie",
  },
  {
    id: "157",
    character: "Emperor",
    debutGame: "Trails into Reverie",
  },
  {
    id: "158",
    character: "Isola Millstein",
    debutGame: "Trails into Reverie",
  },
  {
    id: "159",
    character: "Lapis Rosenberg",
    debutGame: "Trails into Reverie",
  },
  {
    id: "160",
    character: "Lynn",
    debutGame: "Trails from Zero",
  },
  {
    id: "161",
    character: "Nadia Rayne",
    debutGame: "Trails into Reverie",
  },
  {
    id: "162",
    character: "Roy Gramheart",
    debutGame: "Trails into Reverie",
  },
  {
    id: "163",
    character: "Swin Abel",
    debutGame: "Trails into Reverie",
  },
  {
    id: "164",
    character: "Aaron Wei",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "165",
    character: "Alexandre",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "166",
    character: "Arioch",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "167",
    character: "Ashen Lu",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "168",
    character: "Bergard Zeman",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "169",
    character: "Dingo Brad",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "170",
    character: "Elaine Auclair",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "171",
    character: "Ellroy Harwood",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "172",
    character: "Esmeray Archette",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "173",
    character: "Feri Al-Fayed",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "174",
    character: "Gerard Dantès",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "175",
    character: "Gilliam Thorndyke",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "176",
    character: "Judith Lanster",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "177",
    character: "Kasim Al-Fayed",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "178",
    character: "Kurogane",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "179",
    character: "Latoya Hamilton",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "180",
    character: "Lucrezia Isselee",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "181",
    character: "Mare",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "182",
    character: "Melchior",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "183",
    character: "Nina Fenly",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "184",
    character: "Olympia",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "185",
    character: "Paulette",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "186",
    character: "Quatre Salision",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "187",
    character: "René Kincaid",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "188",
    character: "Risette Twinings",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "189",
    character: "Viola",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "190",
    character: "Yumé",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "191",
    character: "Celis Ortesia",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "192",
    character: "Ixs",
    debutGame: "Trails through Daybreak 2",
  },
  {
    id: "193",
    character: "Jorda",
    debutGame: "Trails through Daybreak 2",
  },
  {
    id: "194",
    character: "Mirabel Aalton",
    debutGame: "Trails through Daybreak 2",
  },
  {
    id: "195",
    character: "Naje Berka",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "196",
    character: "Leon Balthazar",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "197",
    character: "Sherid Asval",
    debutGame: "Trails through Daybreak",
  },
  {
    id: "198",
    character: "Zita Asval",
    debutGame: "Trails through Daybreak 2",
  },
  {
    id: "199",
    character: "Emilia Harring",
    debutGame: "Trails through Daybreak 2",
  },
  {
    id: "200",
    character: "Ulrika",
    debutGame: "Trails beyond the Horizon",
  },
  {
    id: "201",
    character: "Simeon",
    debutGame: "Trails beyond the Horizon",
  },
  {
    id: "202",
    character: "Rais",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "203",
    character: "Sergei Lou",
    debutGame: "Trails from Zero",
  },
  {
    id: "204",
    character: "Towa Herschel",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "205",
    character: "Aeolia",
    debutGame: "Trails from Zero",
  },
  {
    id: "206",
    character: "Bleublanc",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "207",
    character: "Deen",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "208",
    character: "Alisa Reinford",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "209",
    character: "Alisa Reinford",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "210",
    character: "Ernest Reis",
    debutGame: "Trails from Zero",
  },
  {
    id: "211",
    character: "Carna",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "212",
    character: "Rocco",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "213",
    character: "Duvalie",
    debutGame: "Trails to Azure",
  },
  {
    id: "214",
    character: "Elie MacDowell",
    debutGame: "Trails from Zero",
  },
  {
    id: "215",
    character: "Scherazard Harvey",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "216",
    character: "Kyle Capua",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "217",
    character: "Kevin Graham",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "218",
    character: "Alex Dudley",
    debutGame: "Trails from Zero",
  },
  {
    id: "219",
    character: "Tita Russell",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "220",
    character: "Zeit",
    debutGame: "Trails from Zero",
  },
  {
    id: "221",
    character: "Ries Argent",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "222",
    character: "Campanella",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "223",
    character: "Kurt Nardin",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "224",
    character: "Noel Seeker",
    debutGame: "Trails from Zero",
  },
  {
    id: "225",
    character: "Walter Kron",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "226",
    character: "Josette Capua",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "227",
    character: "Tio Plato",
    debutGame: "Trails from Zero",
  },
  {
    id: "228",
    character: "Tio Plato",
    debutGame: "Trails from Zero",
  },
  {
    id: "229",
    character: "Kloe Rinz",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "230",
    character: "Kloe Rinz",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "231",
    character: "Kloe Rinz",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "232",
    character: "Mireille",
    debutGame: "Trails from Zero",
  },
  {
    id: "233",
    character: "Randy Orlando",
    debutGame: "Trails from Zero",
  },
  {
    id: "234",
    character: "Agate Crosner",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "235",
    character: "Alan Richard",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "236",
    character: "Gilbert Stein",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "237",
    character: "Anelace Elfead",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "238",
    character: "Kanone Amalthea",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "239",
    character: "Maximillian Cid",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "240",
    character: "Lechter Arundel",
    debutGame: "Trails in the Sky 3rd",
  },
  {
    id: "241",
    character: "Fie Claussell",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "242",
    character: "Sara Valestein",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "243",
    character: "Joshua Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "244",
    character: "Joshua Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "245",
    character: "Luciola",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "246",
    character: "Renne Bright",
    debutGame: "Trails in the Sky SC",
  },
  {
    id: "247",
    character: "Shirley Orlando",
    debutGame: "Trails to Azure",
  },
  {
    id: "248",
    character: "Rean Schwarzer",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "249",
    character: "Rean Schwarzer",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "250",
    character: "Sharon Kreuger",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "251",
    character: "Kilika Rouran",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "252",
    character: "Wazy Hemisphere",
    debutGame: "Trails from Zero",
  },
  {
    id: "253",
    character: "Rixia Mao",
    debutGame: "Trails from Zero",
  },
  {
    id: "254",
    character: "Rixia Mao",
    debutGame: "Trails from Zero",
  },
  {
    id: "255",
    character: "Olivier Lenheim",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "256",
    character: "Ennea",
    debutGame: "Trails to Azure",
  },
  {
    id: "257",
    character: "Emma Millstein",
    debutGame: "Trails of Cold Steel",
  },
  {
    id: "258",
    character: "Altina Orion",
    debutGame: "Trails of Cold Steel 2",
  },
  {
    id: "259",
    character: "Lynn",
    debutGame: "Trails from Zero",
  },
  {
    id: "260",
    character: "Sigmund Orlando",
    debutGame: "Trails to Azure",
  },
  {
    id: "261",
    character: "Sigmund Orlando",
    debutGame: "Trails to Azure",
  },
  {
    id: "262",
    character: "Zin Vathek",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "263",
    character: "Grant",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "264",
    character: "Morgan",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "265",
    character: "Michel",
    debutGame: "Trails from Zero",
  },
  {
    id: "266",
    character: "Ines",
    debutGame: "Trails to Azure",
  },
  {
    id: "267",
    character: "Abbas",
    debutGame: "Trails from Zero",
  },
  {
    id: "268",
    character: "Mueller Vander",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "269",
    character: "Lloyd Bannings",
    debutGame: "Trails from Zero",
  },
  {
    id: "270",
    character: "Estelle Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "271",
    character: "Wald Wales",
    debutGame: "Trails from Zero",
  },
  {
    id: "272",
    character: "Phillip Runall",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "273",
    character: "Arios MacLaine",
    debutGame: "Trails from Zero",
  },
  {
    id: "274",
    character: "Julia Schwarz",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "275",
    character: "Cassius Bright",
    debutGame: "Trails in the Sky FC",
  },
  {
    id: "276",
    character: "Arianrhod",
    debutGame: "Trails to Azure",
  },
  {
    id: "277",
    character: "Mishy",
    debutGame: "Trails from Zero",
  },
];

export const BACKGROUNDS = [
  "/images/backgrounds/0.webp",
  "/images/backgrounds/1.webp",
  "/images/backgrounds/2.webp",
  "/images/backgrounds/3.webp",
  "/images/backgrounds/4.webp",
  "/images/backgrounds/5.webp",
  "/images/backgrounds/6.webp",
  "/images/backgrounds/7.webp",
  "/images/backgrounds/8.webp",
  "/images/backgrounds/9.webp",
  "/images/backgrounds/10.webp",
  "/images/backgrounds/11.webp",
  "/images/backgrounds/12.webp",
  "/images/backgrounds/13.webp",
  "/images/backgrounds/14.webp",
  "/images/backgrounds/15.webp",
  "/images/backgrounds/16.webp",
  "/images/backgrounds/17.webp",
  "/images/backgrounds/18.webp",
  "/images/backgrounds/19.webp",
  "/images/backgrounds/20.webp",
  "/images/backgrounds/21.webp",
  "/images/backgrounds/22.webp",
  "/images/backgrounds/23.webp",
  "/images/backgrounds/24.webp",
  "/images/backgrounds/25.webp",
  "/images/backgrounds/26.webp",
  "/images/backgrounds/27.webp",
  "/images/backgrounds/28.webp",
  "/images/backgrounds/29.webp",
  "/images/backgrounds/30.webp",
  "/images/backgrounds/31.webp",
  "/images/backgrounds/32.webp",
  "/images/backgrounds/33.webp",
  "/images/backgrounds/34.webp",
  "/images/backgrounds/35.webp",
  "/images/backgrounds/36.webp",
  "/images/backgrounds/37.webp",
  "/images/backgrounds/38.webp",
  "/images/backgrounds/39.webp",
  "/images/backgrounds/40.webp",
  "/images/backgrounds/41.webp",
  "/images/backgrounds/42.webp",
  "/images/backgrounds/43.webp",
  "/images/backgrounds/44.webp",
  "/images/backgrounds/45.webp",
  "/images/backgrounds/46.webp",
  "/images/backgrounds/47.webp",
  "/images/backgrounds/48.webp",
  "/images/backgrounds/49.webp",
  "/images/backgrounds/50.webp",
  "/images/backgrounds/51.webp",
  "/images/backgrounds/52.webp",
  "/images/backgrounds/53.webp",
  "/images/backgrounds/54.webp",
  "/images/backgrounds/55.webp",
  "/images/backgrounds/56.webp",
  "/images/backgrounds/57.webp",
  "/images/backgrounds/58.webp",
  "/images/backgrounds/59.webp",
  "/images/backgrounds/60.webp",
  "/images/backgrounds/61.webp",
  "/images/backgrounds/62.webp",
  "/images/backgrounds/63.webp",
  "/images/backgrounds/64.webp",
  "/images/backgrounds/65.webp",
  "/images/backgrounds/66.webp",
  "/images/backgrounds/67.webp",
  "/images/backgrounds/68.webp",
  "/images/backgrounds/69.webp",
  "/images/backgrounds/70.webp",
  "/images/backgrounds/71.webp",
  "/images/backgrounds/72.webp",
  "/images/backgrounds/73.webp",
  "/images/backgrounds/74.webp",
  "/images/backgrounds/75.webp",
  "/images/backgrounds/76.webp",
  "/images/backgrounds/77.webp",
  "/images/backgrounds/78.webp",
  "/images/backgrounds/79.webp",
  "/images/backgrounds/80.webp",
  "/images/backgrounds/81.webp",
  "/images/backgrounds/82.webp",
  "/images/backgrounds/83.webp",
  "/images/backgrounds/84.webp",
  "/images/backgrounds/85.webp",
  "/images/backgrounds/86.webp",
  "/images/backgrounds/87.webp",
  "/images/backgrounds/88.webp",
  "/images/backgrounds/89.webp",
  "/images/backgrounds/90.webp",
  "/images/backgrounds/91.webp",
  "/images/backgrounds/92.webp",
  "/images/backgrounds/93.webp",
  "/images/backgrounds/94.webp",
  "/images/backgrounds/95.webp",
  "/images/backgrounds/96.webp",
  "/images/backgrounds/97.webp",
  "/images/backgrounds/98.webp",
  "/images/backgrounds/99.webp",
  "/images/backgrounds/100.webp",
  "/images/backgrounds/101.webp",
  "/images/backgrounds/102.webp",
  "/images/backgrounds/103.webp",
  "/images/backgrounds/104.webp",
  "/images/backgrounds/105.webp",
  "/images/backgrounds/106.webp",
  "/images/backgrounds/107.webp",
  "/images/backgrounds/108.webp",
  "/images/backgrounds/109.webp",
  "/images/backgrounds/110.webp",
  "/images/backgrounds/111.webp",
  "/images/backgrounds/112.webp",
  "/images/backgrounds/113.webp",
  "/images/backgrounds/114.webp",
  "/images/backgrounds/115.webp",
  "/images/backgrounds/116.webp",
  "/images/backgrounds/117.webp",
  "/images/backgrounds/118.webp",
  "/images/backgrounds/119.webp",
  "/images/backgrounds/120.webp",
  "/images/backgrounds/121.webp",
  "/images/backgrounds/122.webp",
  "/images/backgrounds/123.webp",
  "/images/backgrounds/124.webp",
  "/images/backgrounds/125.webp",
];
